import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** A bundled product input */
export type BundledProductInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrganisationProductStatusEnum>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  special_price_from?: InputMaybe<Scalars['String']['input']>;
  special_price_to?: InputMaybe<Scalars['String']['input']>;
  todays_offer_price?: InputMaybe<Scalars['Float']['input']>;
  todays_offer_price_from?: InputMaybe<Scalars['String']['input']>;
  todays_offer_price_to?: InputMaybe<Scalars['String']['input']>;
  todays_offer_product_is_active?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<BundledProductItemInput>>;
};

/** A bundled product item input */
export type BundledProductItemInput = {
  productId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  sku: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

/** The input for a cart item */
export type CartItemInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  cartId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  childId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for updating consultant product settings */
export type ConsultantProductSettingsInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  product_id: Scalars['Int']['input'];
  base_price?: InputMaybe<Scalars['Float']['input']>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  special_price_from?: InputMaybe<Scalars['String']['input']>;
  special_price_to?: InputMaybe<Scalars['String']['input']>;
  todays_offer_price?: InputMaybe<Scalars['Float']['input']>;
  todays_offer_price_from?: InputMaybe<Scalars['String']['input']>;
  todays_offer_price_to?: InputMaybe<Scalars['String']['input']>;
  todays_offer_product_is_active?: InputMaybe<Scalars['Boolean']['input']>;
  end_of_life_override?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for contacts */
export type ContactInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  referralHash?: InputMaybe<Scalars['String']['input']>;
};

/** Input for customers of consultants */
export type CustomerInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  user_type?: InputMaybe<UserTypeEnum>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  co?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  class_interest?: InputMaybe<Scalars['Boolean']['input']>;
  career_interest?: InputMaybe<Scalars['Boolean']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  communication_consultant?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for creating notifications */
export type NotificationInput = {
  consultantId?: InputMaybe<Scalars['Int']['input']>;
  guestEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating guest checkout notifications (contact requests) */
export type GuestCheckoutNotificationInput = {
  consultantId: Scalars['Int']['input'];
  guestEmail: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating notifications */
export type UpdateNotificationInput = {
  id: Scalars['Int']['input'];
  consultantId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  guestEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating customers of consultants */
export type UpdateCustomerInput = {
  id: Scalars['Int']['input'];
  user_type: UserTypeEnum;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country_code: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  co?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  class_interest?: InputMaybe<Scalars['Boolean']['input']>;
  career_interest?: InputMaybe<Scalars['Boolean']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  communication_consultant?: InputMaybe<Scalars['Boolean']['input']>;
};

/** User Billing or Shipping Address. */
export type CustomerOrganisationOrderAddressInput = {
  first_name: Scalars['String']['input'];
  middle_name?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  co?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  postal_code?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  email: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

/** An input type for creating customers organisation order */
export type CustomerOrganisationOrderInput = {
  /** The billing address of the customer */
  billing_address: CustomerOrganisationOrderAddressInput;
  /** The shipping address of the customer */
  shipping_address?: InputMaybe<CustomerOrganisationOrderAddressInput>;
};

/** Input type for products in a customers order */
export type CustomerOrganisationOrderItemInput = {
  /** The ID of the product */
  productId: Scalars['Int']['input'];
  /** Quantity of the product */
  quantity: Scalars['Float']['input'];
};

/** Delete relation between a customer and an organisation, and its values. */
export type CustomerOrganisationRelationDeleteInput = {
  user_id: Scalars['Int']['input'];
};

/** The relation between a customer and an organisation, and its values. */
export type CustomerOrganisationRelationInput = {
  user_id: Scalars['Int']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  communication_consultant?: InputMaybe<Scalars['Boolean']['input']>;
  career_interest?: InputMaybe<Scalars['Boolean']['input']>;
  class_interest?: InputMaybe<Scalars['Boolean']['input']>;
  vip?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for and event for hostess. */
export type EventForHostessInput = {
  eventHash: Scalars['String']['input'];
  participants: Array<EventForHostessParticipantInput>;
};

/** Input for a participant of an event that a hostess can add. */
export type EventForHostessParticipantInput = {
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
};

/** Input for and event */
export type EventInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  notify_guests_not_accepted_invites_within_days?: InputMaybe<Scalars['Int']['input']>;
  hostess_id?: InputMaybe<Scalars['Int']['input']>;
  participant_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for my customers sorting options. */
export type MyCustomersProductSortInput = {
  field?: InputMaybe<MyCustomersProductListOrderByEnum>;
  order?: InputMaybe<OrderDirectionEnum>;
};

/** An organisations comment on a customer */
export type OrganisationCustomerCommentInput = {
  user_id: Scalars['Int']['input'];
  comment: Scalars['String']['input'];
};

/** The input type for mail */
export type OrganisationMailInput = {
  subject: Scalars['String']['input'];
  headline: Scalars['String']['input'];
  message: Scalars['String']['input'];
  mailTemplate: BizWizardMailTemplateEnum;
  recipientCustomerIds: Array<Scalars['Int']['input']>;
};

/** An organisations comment on an order */
export type OrganisationOrderCommentInput = {
  organisation_order_id: Scalars['Int']['input'];
  comment: Scalars['String']['input'];
};

/** An input type for creating organisation orders */
export type OrganisationOrderInput = {
  /** List of products and quantities for the order */
  products: Array<OrganisationOrderItemInput>;
  /** The ID of the customer user placing the order */
  customerUserId: Scalars['Int']['input'];
  /** Whether to send an order confirmation. */
  sendConfirmation: Scalars['Boolean']['input'];
  /** When to follow up on the order. */
  followUp?: InputMaybe<Scalars['String']['input']>;
  /** Discount amount applied to the order */
  discountAmount: Scalars['Float']['input'];
  /** Discount percentage applied to the order */
  discountPercentage: Scalars['Float']['input'];
};

/** Input type for products in an order */
export type OrganisationOrderItemInput = {
  /** The ID of the product */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the child/variant product */
  childId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the parent product */
  parentWrapperId?: InputMaybe<Scalars['Int']['input']>;
  /** Quantity of the product */
  quantity: Scalars['Float']['input'];
  /** Discount applied to the order */
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  /** Type of discount applied to the order (e.g., "Percentage", "Amount") */
  discountType?: InputMaybe<OrganisationOrderDiscountTypeEnum>;
};

/** The input for the settings of an organisation */
export type OrganisationSettingsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  presentation?: InputMaybe<Scalars['String']['input']>;
  favourite_quote?: InputMaybe<Scalars['Int']['input']>;
  availability?: InputMaybe<Scalars['String']['input']>;
  deliveryOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  billing_active?: InputMaybe<Scalars['Boolean']['input']>;
  show_vat_on_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  billing_invoicing_method?: InputMaybe<OrganisationBillingInvoicingMethodEnum>;
  billing_payment_method?: InputMaybe<Scalars['String']['input']>;
  billing_account_number?: InputMaybe<Scalars['String']['input']>;
  billing_org_number?: InputMaybe<Scalars['String']['input']>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  billing_phone_number?: InputMaybe<Scalars['String']['input']>;
};

/** Input for product filters */
export type ProductFilterInput = {
  sku?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mkProductType: Array<Scalars['String']['input']>;
  colorName: Array<Scalars['String']['input']>;
  skinType: Array<Scalars['String']['input']>;
  productSeries: Array<Scalars['String']['input']>;
  usageRegion: Array<Scalars['String']['input']>;
  skinTone: Array<Scalars['String']['input']>;
  makeupProperties: Array<Scalars['String']['input']>;
  finish: Array<Scalars['String']['input']>;
  fragrance: Array<Scalars['String']['input']>;
  seminarYear: Array<Scalars['String']['input']>;
};

/** Input for product sorting */
export type ProductSortInput = {
  field: Scalars['String']['input'];
  order: Scalars['String']['input'];
};

/** Input for self registered customers */
export type SelfRegisterCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  co?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  career_interest?: InputMaybe<Scalars['Boolean']['input']>;
  class_interest?: InputMaybe<Scalars['Boolean']['input']>;
  communication_consultant?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for shopper self-registration */
export type ShopperRegisterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  co?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** An input type for creating organisation orders */
export type UpdateOrganisationOrderInput = {
  /** The ID of the order to update. */
  id: Scalars['Int']['input'];
  /** The status of the order. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** When to follow up on the order. */
  followUp?: InputMaybe<Scalars['String']['input']>;
  /** The discount amount for the order. */
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /** The discount percentage for the order. */
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  items?: InputMaybe<Array<OrganisationOrderItemInput>>;
  /** Items that should be updated. */
  itemsToUpdate?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Input for sending mail */
export type SendMailOptionInput = {
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  organisation_order_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for backweb customer users */
export type BackwebCustomerInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  newsletter: Scalars['Boolean']['input'];
  organisation_id?: InputMaybe<Scalars['Int']['input']>;
  customer_specific_information: BackwebCustomerSpecificInformationInput;
};

/** Input for backweb consultant users */
export type BackwebConsultantInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  newsletter: Scalars['Boolean']['input'];
  organisation_id?: InputMaybe<Scalars['Int']['input']>;
  consultant_specific_information: BackwebConsultantSpecificInformationInput;
};

/** Input for backweb contact users */
export type BackwebContactInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  newsletter: Scalars['Boolean']['input'];
  organisation_id?: InputMaybe<Scalars['Int']['input']>;
  contact_specific_information: BackwebContactSpecificInformationInput;
};

/** Input for addresses */
export type BackwebAddressInput = {
  id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  middle_name?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  co?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country_code: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

/** The relation between a customer and an organisation */
export type BackwebOrganisationRelationInput = {
  user_id: Scalars['Int']['input'];
  organisation_id: Scalars['Int']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  communication_consultant?: InputMaybe<Scalars['Boolean']['input']>;
  career_interest?: InputMaybe<Scalars['Boolean']['input']>;
  class_interest?: InputMaybe<Scalars['Boolean']['input']>;
  vip?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Consultant-specific information input for backweb users */
export type BackwebConsultantSpecificInformationInput = {
  consultant_number: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  country_code: Scalars['String']['input'];
  shipping_name: Scalars['String']['input'];
  unregistered: Scalars['Boolean']['input'];
  personal_webshop_active: Scalars['Boolean']['input'];
  find_consultant_active: Scalars['Boolean']['input'];
  personal_webshop_active_from?: InputMaybe<Scalars['String']['input']>;
  personal_webshop_active_to?: InputMaybe<Scalars['String']['input']>;
  personal_webshop_url?: InputMaybe<Scalars['String']['input']>;
  shipping_co?: InputMaybe<Scalars['String']['input']>;
  shipping_address: Scalars['String']['input'];
  shipping_postal_code: Scalars['String']['input'];
  shipping_city: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  title_id: Scalars['String']['input'];
  title_name_long: Scalars['String']['input'];
  title_name_short: Scalars['String']['input'];
};

/** Contact-specific information input for backweb users */
export type BackwebContactSpecificInformationInput = {
  mobile?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
};

/** Customer-specific information input for backweb users */
export type BackwebCustomerSpecificInformationInput = {
  address?: InputMaybe<BackwebAddressInput>;
  organisation_relation?: InputMaybe<BackwebOrganisationRelationInput>;
};

/** Input for updating shipping method */
export type BackwebShippingMethodInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  shipping_price: Scalars['Float']['input'];
  country_code: Scalars['String']['input'];
  status: Scalars['String']['input'];
  choose_pickup_locator: Scalars['Boolean']['input'];
  cart_types: Array<Scalars['String']['input']>;
  labels?: InputMaybe<BackwebShippingMethodLabelsInput>;
  tracking_service?: InputMaybe<Scalars['String']['input']>;
  postal_codes_exclude?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for structured shipping labels */
export type BackwebShippingMethodLabelsInput = {
  /** Label for Sweden */
  se?: InputMaybe<Scalars['String']['input']>;
  /** Label for Norway */
  no?: InputMaybe<Scalars['String']['input']>;
  /** Label for Finland */
  fi?: InputMaybe<Scalars['String']['input']>;
  /** Label for Sweden-Finland */
  sefi?: InputMaybe<Scalars['String']['input']>;
  /** Label for Denmark */
  dk?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for structured date range */
export type BackwebDateRange = {
  /** Filter date from */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Filter date to */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for structured price range */
export type BackwebPriceRange = {
  /** Filter price from */
  from?: InputMaybe<Scalars['Float']['input']>;
  /** Filter price to */
  to?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for backweb admin users */
export type BackwebAdminInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  newsletter: Scalars['Boolean']['input'];
  organisation_id?: InputMaybe<Scalars['Int']['input']>;
  admin_specific_information: BackwebAdminSpecificInformationInput;
  granted_by?: InputMaybe<Scalars['Int']['input']>;
};

/** Admin-specific information input for backweb users */
export type BackwebAdminSpecificInformationInput = {
  mobile?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  acl_role_id: Scalars['Int']['input'];
};

/** Input for a backweb acl role */
export type BackwebAclRoleInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
};

/** Input for updating consultant submissions */
export type BackwebConsultantSubmissionInput = {
  id: Scalars['Int']['input'];
  presentation_text: Scalars['String']['input'];
  ftax_confirmed: Scalars['Boolean']['input'];
  approved: Scalars['Boolean']['input'];
};

/** The types of activities */
export enum ActivityTypeEnum {
  NewCustomer = 'newCustomer',
  NewOrder = 'newOrder',
  EmailReminder = 'emailReminder',
  EventInvite = 'eventInvite',
  AcceptEventInvite = 'acceptEventInvite',
  NewRecruitment = 'newRecruitment',
  UserDeleted = 'userDeleted',
  EventSmsReminderSent = 'eventSmsReminderSent',
  FollowupEmailSent = 'followupEmailSent',
  FollowUpEmailNotSent = 'followUpEmailNotSent',
  EventHostInvitedUsers = 'eventHostInvitedUsers',
  EventReferredAcceptedInvite = 'eventReferredAcceptedInvite',
  FollowupSmsSent = 'followupSmsSent'
}

/** The types of activities */
export enum ActivityTypeFilterEnum {
  NewCustomer = 'newCustomer',
  NewOrder = 'newOrder',
  EmailReminder = 'emailReminder',
  EventInvite = 'eventInvite',
  AcceptEventInvite = 'acceptEventInvite',
  NewRecruitment = 'newRecruitment',
  UserDeleted = 'userDeleted',
  EventSmsReminderSent = 'eventSmsReminderSent',
  FollowupEmailSent = 'followupEmailSent',
  FollowUpEmailNotSent = 'followUpEmailNotSent',
  EventHostInvitedUsers = 'eventHostInvitedUsers',
  EventReferredAcceptedInvite = 'eventReferredAcceptedInvite',
  FollowupSmsSent = 'followupSmsSent',
  All = 'all'
}

/** The types of authorization cookies */
export enum AuthorizationCookiesEnum {
  AnonymousCart = 'anonymous_cart',
  MkWebshopJwt = 'mk_webshop_jwt'
}

/** The types of mail templates */
export enum BizWizardMailTemplateEnum {
  Pink = 'pink',
  Onyx = 'onyx',
  Gold = 'gold',
  FathersDay = 'fathers_day',
  MothersDay = 'mothers_day',
  Easter = 'easter',
  ValentinesDay = 'valentines_day',
  Christmas = 'christmas',
  InternationalWomensDay = 'international_womens_day',
  NewYear = 'new_year',
  SkinCare = 'skin_care',
  Makeup = 'makeup',
  GeneralOffer = 'general_offer',
  Invoice = 'invoice',
  OrderConfirmation = 'order_confirmation',
  WelcomeEmailCreatePassword = 'welcome_email_create_password',
  CustomerResetPassword = 'customer_reset_password',
  VerifyCustomerEmail = 'verify_customer_email',
  MessageToConsultant = 'message_to_consultant',
  InviteSkincareclassGuestFromHostess = 'invite_skincareclass_guest_from_hostess',
  BookingconfirmationWorkshopHostess = 'bookingconfirmation_workshop_hostess',
  OrderAutoReminderTwoDays = 'order_auto_reminder_two_days',
  OrderAutoReminderTwoMonths = 'order_auto_reminder_two_months',
  ReferAFriend = 'refer_a_friend',
  Preorder = 'preorder',
  BookingConfirmationOtherEvent = 'booking_confirmation_other_event',
  BookingConfirmationFacialEvent = 'booking_confirmation_facial_event',
  BookingConfirmationMakeupEvent = 'booking_confirmation_makeup_event',
  BookingConfirmationTeambuildingEvent = 'booking_confirmation_teambuilding_event',
  BookingConfirmationOpenHouseGeneralEvent = 'booking_confirmation_open_house_general_event',
  BookingConfirmationOpenHouseSpringEvent = 'booking_confirmation_open_house_spring_event',
  BookingConfirmationOpenHouseChristmasEvent = 'booking_confirmation_open_house_christmas_event',
  MessageToConsultantNoAcceptedInvite = 'message_to_consultant_no_accepted_invite',
  CustomerLinkRequest = 'customer_link_request',
  BookingConfirmationWorkshopEvent = 'booking_confirmation_workshop_event'
}

/** Country enum type */
export enum CountryEnum {
  Se = 'SE',
  No = 'NO',
  Fi = 'FI',
  Ax = 'AX',
  Dk = 'DK'
}

/** The relation between a customer and an organisation, and its values. */
export type CustomerOrganisationRelation = {
  __typename?: 'CustomerOrganisationRelation';
  user_id: Scalars['Int']['output'];
  organisation_id: Scalars['Int']['output'];
  active: Scalars['Boolean']['output'];
  vip: Scalars['Boolean']['output'];
  communication_consultant: Scalars['Boolean']['output'];
  career_interest: Scalars['Boolean']['output'];
  class_interest: Scalars['Boolean']['output'];
  consultant_name: Scalars['String']['output'];
  consultant_number: Scalars['String']['output'];
};

/** The types of customer system tags */
export enum CustomerSystemTagEnum {
  NewCustomer = 'new_customer',
  Contact = 'contact',
  Customer = 'customer',
  HostedEvent = 'hosted_event'
}

/** Various groups to filter customers by. */
export enum CustomersFilterGroupEnum {
  All = 'all',
  Subscribed = 'subscribed',
  BirthdayThisMonth = 'birthday_this_month',
  NoOrderPastYear = 'no_order_past_year',
  OrderPastYear = 'order_past_year',
  Vip = 'vip',
  ClassInterest = 'class_interest',
  CareerInterest = 'career_interest',
  Active = 'active',
  Inactive = 'inactive',
  Contacts = 'contacts',
  Customers = 'customers',
  HostedEvent = 'hosted_event',
  CustomerHostedEvent = 'customer_hosted_event',
  ContactHostedEvent = 'contact_hosted_event',
  None = 'none'
}

/** An Event */
export type Event = {
  __typename?: 'Event';
  id: Scalars['Int']['output'];
  event_type: Scalars['String']['output'];
  name: Scalars['String']['output'];
  location: Scalars['String']['output'];
  hostess_invited_at?: Maybe<Scalars['String']['output']>;
  starts_at: Scalars['String']['output'];
  ends_at: Scalars['String']['output'];
  notify_guests_not_accepted_invites_within_days?: Maybe<Scalars['Int']['output']>;
  start_date: Scalars['String']['output'];
  start_time: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  end_time: Scalars['String']['output'];
  hostess_id?: Maybe<Scalars['Int']['output']>;
  participant_ids: Array<Scalars['Int']['output']>;
  created_at: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

/** The type of event. */
export enum EventTypeEnum {
  SkincareClass = 'skincare_class',
  MakeupConsultation = 'makeup_consultation',
  TeambuildingInterview = 'teambuilding_interview',
  Facial = 'facial',
  OpenHouseGeneral = 'open_house_general',
  OpenHouseSpring = 'open_house_spring',
  OpenHouseChristmas = 'open_house_christmas',
  Other = 'other'
}

/** A type for GraphQL exceptions. */
export enum GraphQlExceptionsEnum {
  CartCheckedOutException = 'cart_checked_out_exception',
  UserAlreadyExistsException = 'user_already_exists_exception',
  CustomerEmailAlreadyExistsException = 'customer_email_already_exists_exception',
  HashExpired = 'hash_expired'
}

/** Event types that allow hostesses. */
export enum HostessEventTypeEnum {
  SkincareClass = 'skincare_class'
}

/** The type of order to apply to the customer list. Can be used to determine the action to take when the order is applied. */
export enum MyCustomersCustomerListOrderTypeEnum {
  NoSorting = 'no_sorting',
  FirstName = 'first_name',
  LastName = 'last_name',
  DateOfBirth = 'date_of_birth',
  RegisterDate = 'register_date'
}

/** The type of filter for the product list. */
export enum MyCustomersProductListFilterEnum {
  All = 'all',
  Bundled = 'bundled',
  Expired = 'expired',
  Favorites = 'favorites',
  ConsultantPrice = 'consultant_price',
  SpecialPrice = 'special_price',
  TodaysOffer = 'todays_offer'
}

/** The type of order for the product list */
export enum MyCustomersProductListOrderByEnum {
  CreatedAt = 'created_at',
  ProductName = 'product_name'
}

/** The type of order direction for sorting. */
export enum OrderDirectionEnum {
  Asc = 'asc',
  Desc = 'desc'
}

/** The invoicing method of the organisation */
export enum OrganisationBillingInvoicingMethodEnum {
  ConsultantInvoice = 'consultant_invoice'
}

/** The billing method of the organisation */
export enum OrganisationBillingPaymentMethodEnum {
  Bankgiro = 'bankgiro',
  Plusgiro = 'plusgiro',
  BankAccount = 'bank_account'
}

/** Render type of any given datapoint */
export enum OrganisationDatapointTypeEnum {
  DateMonthShort = 'date_month_short',
  Price = 'price',
  Count = 'count'
}

/** The status of a bundled product */
export enum OrganisationProductStatusEnum {
  Active = 'active',
  Inactive = 'inactive',
  Deleted = 'deleted'
}

/** The delivery options of the organisation */
export enum OrganisationDeliveryOptionEnum {
  MyPlace = 'my_place',
  ByMail = 'by_mail',
  HomeDelivery = 'home_delivery',
  Workplace = 'workplace'
}

/** The type of delivery method for the order. */
export enum OrganisationOrderDeliveryMethodEnum {
  ConsultantChoice = 'consultant_choice'
}

/** The type of discount applied to the order item or and order. */
export enum OrganisationOrderDiscountTypeEnum {
  Percentage = 'percentage',
  Amount = 'amount'
}

/** The type of follow up for the order. */
export enum OrganisationOrderFollowUpEnum {
  TwoDays = 'two_days',
  TwoMonths = 'two_months'
}

/** Order by for Organisation order type */
export enum OrganisationOrderOrderByEnum {
  Date = 'date',
  CustomerFirstName = 'customer_first_name',
  CustomerLastName = 'customer_last_name'
}

/** Status for Organisation order type */
export enum OrganisationOrderStatusEnum {
  New = 'new',
  Confirmed = 'confirmed',
  Completed = 'completed',
  Canceled = 'canceled'
}

/** Lists of Email template keys */
export enum SendMailKeyEnum {
  Welcome = 'welcome',
  ResetPassword = 'reset_password',
  OrderConfirmation = 'order_confirmation'
}

/** The type of unique hash. Can be used to determine the action to take when the hash is used. */
export enum UniqueHashTypeEnum {
  CreatePassword = 'create_password',
  ResetPassword = 'reset_password',
  VerifyEmail = 'verify_email',
  EventHostessInvitation = 'event_hostess_invitation',
  EventParticipantInvitation = 'event_participant_invitation',
  ReferAFriend = 'refer_a_friend',
  CustomerLinkRequest = 'customer_link_request'
}

/** The types of users */
export enum UserTypeEnum {
  User = 'user',
  Consultant = 'consultant',
  Contact = 'contact',
  Admin = 'admin',
  Shopper = 'shopper'
}

/** The payload returned when updating a customer */
export type UpdatedCustomerPayload = {
  __typename?: 'UpdatedCustomerPayload';
  /** The updated user object */
  user?: Maybe<User>;
  /** New JWT token if re-issued */
  token?: Maybe<Scalars['String']['output']>;
};

/** The type of filter for the backweb user list */
export enum BackwebUsersFilterEnum {
  NoFilter = 'no_filter',
  Consultant = 'consultant',
  User = 'user',
  Contact = 'contact',
  Admin = 'admin'
}

/** The type of order for the backweb user list */
export enum BackwebUsersOrderByEnum {
  NoSorting = 'no_sorting',
  FirstName = 'first_name',
  LastName = 'last_name',
  DateOfBirth = 'date_of_birth'
}

/** Country codes for shipping */
export enum BackwebShippingMethodsCountryCodeEnum {
  All = 'ALL',
  Se = 'SE',
  No = 'NO',
  Ax = 'AX',
  Dk = 'DK',
  Fi = 'FI'
}

/** The type of status for the backweb shipping type */
export enum BackwebShippingMethodsStatusEnum {
  OnDefault = 'on_default',
  On = 'on',
  Off = 'off'
}

/** Filters for the shipping list options */
export enum BackwebShippingMethodsFilterEnum {
  NoFilter = 'no_filter',
  OnDefault = 'on_default',
  On = 'on',
  Off = 'off',
  All = 'ALL',
  Se = 'SE',
  No = 'NO',
  Ax = 'AX',
  Dk = 'DK',
  Fi = 'FI',
  Bring = 'BRING',
  Postnord = 'POSTNORD',
  NoCarrier = 'NO_CARRIER'
}

/** Order by for the shipping list options */
export enum BackwebShippingMethodsOrderByEnum {
  NoSorting = 'no_sorting',
  ShippingPrice = 'shipping_price',
  Name = 'name'
}

/** Carrier identifier */
export enum BackwebShippingMethodsCarrierEnum {
  Postnord = 'POSTNORD',
  Bring = 'BRING',
  NoCarrier = 'NO_CARRIER'
}

/** The cart types allowed for shipping options */
export enum BackwebShippingMethodsCartTypeEnum {
  Default = 'default',
  FinalPayment = 'final_payment',
  Prepack = 'prepack',
  Ticket = 'ticket',
  Pcp = 'pcp',
  Webpage = 'webpage',
  Dress = 'dress'
}

/** Lables identifier */
export enum BackwebShippingMethodsLabelsEnum {
  Se = 'se',
  No = 'no',
  Fi = 'fi',
  Sefi = 'sefi',
  Dk = 'dk'
}

/** Order market identifier */
export enum BackwebOrdersMarketEnum {
  Se = 'se',
  Sefi = 'sefi',
  Fi = 'fi',
  No = 'no',
  Dk = 'dk'
}

/** Orders order by identifier */
export enum BackwebOrdersOrderByEnum {
  OrderNumber = 'order_number',
  CustomerEmail = 'customer_email',
  GrandTotal = 'grand_total',
  CreatedAt = 'created_at',
  ConsultantNumber = 'consultant_number',
  FirstName = 'first_name',
  LastName = 'last_name'
}

/** Event info on an Activity Feed Item */
export type ActivityFeedItemEventInfo = {
  __typename?: 'ActivityFeedItemEventInfo';
  id: Scalars['Int']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  starts_at: Scalars['String']['output'];
  ends_at: Scalars['String']['output'];
};

/** Order info on an Activity Feed Item */
export type ActivityFeedItemOrderInfo = {
  __typename?: 'ActivityFeedItemOrderInfo';
  id: Scalars['Int']['output'];
  order_number: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  grand_total: Scalars['Float']['output'];
};

/** An Activity Feed Item */
export type ActivityFeedItem = {
  __typename?: 'ActivityFeedItem';
  id: Scalars['Int']['output'];
  type: ActivityTypeEnum;
  description: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  orderInfo?: Maybe<ActivityFeedItemOrderInfo>;
  eventInfo?: Maybe<ActivityFeedItemEventInfo>;
  customer?: Maybe<User>;
};

/** User Billing or Shipping Address. */
export type Address = {
  __typename?: 'Address';
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  middle_name?: Maybe<Scalars['String']['output']>;
  last_name: Scalars['String']['output'];
  co?: Maybe<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  postal_code: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country_code: Scalars['String']['output'];
  email: Scalars['String']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
};

/** Breadcrumb */
export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  /** Title of breadcrumb */
  title: Scalars['String']['output'];
  /** href of the breadcrumb */
  href: Scalars['String']['output'];
};

/** A bundled product */
export type BundledProduct = {
  __typename?: 'BundledProduct';
  id: Scalars['Int']['output'];
  consultant_user_id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  status: Scalars['String']['output'];
  consultant: User;
  items?: Maybe<Array<Maybe<BundledProductItem>>>;
};

/** A bundled product item */
export type BundledProductItem = {
  __typename?: 'BundledProductItem';
  name: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

/** Cart Item type */
export type CartItem = {
  __typename?: 'CartItem';
  id: Scalars['Int']['output'];
  cart_id: Scalars['Int']['output'];
  cart?: Maybe<Cart>;
  product_id: Scalars['Int']['output'];
  product: Product;
  child_id?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Float']['output'];
  created_at: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

/** Cart Response type */
export type CartResponse = {
  __typename?: 'CartResponse';
  cart: Cart;
  totals: Totals;
};

/** Cart type */
export type Cart = {
  __typename?: 'Cart';
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  shipping_address?: Maybe<Scalars['String']['output']>;
  billing_address?: Maybe<Scalars['String']['output']>;
  shipping_method?: Maybe<Scalars['Int']['output']>;
  payment_method?: Maybe<Scalars['Int']['output']>;
  pickup_location?: Maybe<Scalars['String']['output']>;
  checked_out_at?: Maybe<Scalars['String']['output']>;
  items: Array<CartItem>;
  created_at?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

/** An item in a customer order delivery/shipment */
export type CustomerOrderDeliveryItem = {
  __typename?: 'CustomerOrderDeliveryItem';
  /** The SKU of the shipped product */
  sku: Scalars['String']['output'];
  /** Quantity shipped */
  quantity: Scalars['Int']['output'];
};

/** A shipment/delivery for a customer order */
export type CustomerOrderDelivery = {
  __typename?: 'CustomerOrderDelivery';
  /** The ID of the delivery */
  id: Scalars['Int']['output'];
  /** Carrier tracking number, if available */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** Date the delivery was registered */
  createdAt: Scalars['String']['output'];
  /** Items included in this delivery */
  items: Array<CustomerOrderDeliveryItem>;
};

/** An item in a customer order */
export type CustomerOrderItem = {
  __typename?: 'CustomerOrderItem';
  /** The ID of the order item */
  id: Scalars['Int']['output'];
  /** The SKU of the product */
  sku: Scalars['String']['output'];
  /** Snapshot of the product name at time of order */
  productName: Scalars['String']['output'];
  /** Snapshot of the product thumbnail URL at time of order */
  productThumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Quantity ordered */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Price including VAT */
  price?: Maybe<Scalars['Float']['output']>;
  /** Discount amount */
  discount?: Maybe<Scalars['Float']['output']>;
};

/** A paginated list of customer orders */
export type CustomerOrderList = {
  __typename?: 'CustomerOrderList';
  /** A list of customer orders */
  items: Array<CustomerOrder>;
  total: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

/** Details of a customer order */
export type CustomerOrder = {
  __typename?: 'CustomerOrder';
  /** The ID of the order */
  id: Scalars['Int']['output'];
  /** Creation date of the order */
  createdAt: Scalars['String']['output'];
  /** Unique order number */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Status of the order */
  status: Scalars['String']['output'];
  /** Grand total amount */
  grandTotal: Scalars['Float']['output'];
  /** Shipping amount including tax */
  shippingInclTax: Scalars['Float']['output'];
  /** Payment method used */
  paymentMethod: Scalars['String']['output'];
  /** Delivery/shipping method */
  deliveryMethod: Scalars['String']['output'];
  /** Items in the order */
  items: Array<CustomerOrderItem>;
  /** Shipments/deliveries for this order */
  deliveries: Array<CustomerOrderDelivery>;
};

/** Collection of Category type. */
export type CategoryList = {
  __typename?: 'CategoryList';
  items: Array<Category>;
  count: Scalars['Int']['output'];
};

/** Collection of category slug strings. */
export type CategorySlugList = {
  __typename?: 'CategorySlugList';
  items: Array<Scalars['String']['output']>;
};

/** Category type */
export type Category = {
  __typename?: 'Category';
  id: Scalars['Int']['output'];
  pim_id: Scalars['Int']['output'];
  parent_pim_id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  language?: Maybe<Scalars['String']['output']>;
  level: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  slug_path: Scalars['String']['output'];
  title: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Category>>;
  /** Breadcrumbs on the category */
  breadcrumbs: Array<Breadcrumb>;
};

/** Collection of Consultant Activities type. */
export type ConsultantActivityFeed = {
  __typename?: 'ConsultantActivityFeed';
  items: Array<ActivityFeedItem>;
  count: Scalars['Int']['output'];
};

/** The relation between a consultant and a product, and its values. */
export type ConsultantProductSetting = {
  __typename?: 'ConsultantProductSetting';
  organisation_id: Scalars['Int']['output'];
  product_id: Scalars['Int']['output'];
  base_price?: Maybe<Scalars['Float']['output']>;
  special_price?: Maybe<Scalars['Float']['output']>;
  special_price_from?: Maybe<Scalars['String']['output']>;
  special_price_to?: Maybe<Scalars['String']['output']>;
  todays_offer_price?: Maybe<Scalars['Float']['output']>;
  todays_offer_price_from?: Maybe<Scalars['String']['output']>;
  todays_offer_price_to?: Maybe<Scalars['String']['output']>;
  todays_offer_product_is_active?: Maybe<Scalars['Boolean']['output']>;
  product_is_active_central_control?: Maybe<Scalars['Boolean']['output']>;
  end_of_life_override?: Maybe<Scalars['Boolean']['output']>;
};

/** Type for a product filter with count */
export type CountedProductFilter = {
  __typename?: 'CountedProductFilter';
  name: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

/** Return type for product filters */
export type CountedProductFilters = {
  __typename?: 'CountedProductFilters';
  mkProductType: Array<CountedProductFilter>;
  colorName: Array<CountedProductFilter>;
  skinType: Array<CountedProductFilter>;
  productSeries: Array<CountedProductFilter>;
  usageRegion: Array<CountedProductFilter>;
  skinTone: Array<CountedProductFilter>;
  makeupProperties: Array<CountedProductFilter>;
  finish: Array<CountedProductFilter>;
  fragrance: Array<CountedProductFilter>;
  seminarYear: Array<CountedProductFilter>;
};

/** The fields of a customers related organisation that it is allowed to see. */
export type CustomerOrganisation = {
  __typename?: 'CustomerOrganisation';
  country_code: Scalars['String']['output'];
};

/** The information for an event available to a hostess. */
export type EventForHostess = {
  __typename?: 'EventForHostess';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  location: Scalars['String']['output'];
  starts_at: Scalars['String']['output'];
  ends_at: Scalars['String']['output'];
  participants: Array<Participant>;
};

/** A list Events */
export type EventList = {
  __typename?: 'EventList';
  events: Array<Event>;
};

/** A list of emails that did not successefully recieve a mail. */
export type FailedEmailList = {
  __typename?: 'FailedEmailList';
  items: Array<Scalars['String']['output']>;
};

/** Billing address for Jeeves order export */
export type JeevesBillingAddress = {
  __typename?: 'JeevesBillingAddress';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  co?: Maybe<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Failed result of cancelling an order */
export type JeevesCancelOrderError = {
  __typename?: 'JeevesCancelOrderError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Result of cancelling an order; either a success or an error */
export type JeevesCancelOrderResult = JeevesCancelOrderSuccess | JeevesCancelOrderError;

/** Successful result of cancelling an order */
export type JeevesCancelOrderSuccess = {
  __typename?: 'JeevesCancelOrderSuccess';
  /** The cancelled order number */
  orderNumber: Scalars['String']['output'];
};

/** Input for creating a delivery */
export type JeevesCreateDeliveryInput = {
  orderNumber: Scalars['String']['input'];
  erpReference: Scalars['String']['input'];
  deliveryItems: Array<JeevesDeliveryItemInput>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Result for a single delivery in a createDeliveries batch; either a success or an error */
export type JeevesCreateDeliveryResult = JeevesDeliveryResultSuccess | JeevesDeliveryResultError;

/** Input for delivery item */
export type JeevesDeliveryItemInput = {
  id: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
};

/** Failed result for a single delivery in a createDeliveries batch */
export type JeevesDeliveryResultError = {
  __typename?: 'JeevesDeliveryResultError';
  /** Error code */
  errorCode?: Maybe<Scalars['Int']['output']>;
  /** Error message */
  message: Scalars['String']['output'];
};

/** Successful result for a single delivery in a createDeliveries batch */
export type JeevesDeliveryResultSuccess = {
  __typename?: 'JeevesDeliveryResultSuccess';
  /** The order number this delivery was created for */
  orderNumber: Scalars['String']['output'];
  /** The created delivery ID */
  deliveryId: Scalars['String']['output'];
};

/** List of orders for Jeeves export */
export type JeevesGetOrderResult = {
  __typename?: 'JeevesGetOrderResult';
  /** List of exported orders */
  orders: Array<JeevesOrder>;
  /** Total number of unexported orders remaining before this export */
  totalCount: Scalars['Int']['output'];
};

/** Order item for Jeeves order export */
export type JeevesOrderItem = {
  __typename?: 'JeevesOrderItem';
  id: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  priceInclVat?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
};

/** Order for Jeeves order export */
export type JeevesOrder = {
  __typename?: 'JeevesOrder';
  createdAt: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  erpReference?: Maybe<Scalars['String']['output']>;
  market: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  grandTotal: Scalars['Float']['output'];
  shippingAmount: Scalars['Float']['output'];
  vatAmount: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  shippingMethod: Scalars['String']['output'];
  shippingReference?: Maybe<Scalars['String']['output']>;
  paymentMethod: Scalars['String']['output'];
  paymentSubMethod?: Maybe<Scalars['String']['output']>;
  paymentReference?: Maybe<Scalars['String']['output']>;
  pickupLocation?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<JeevesShippingAddress>;
  billingAddress: JeevesBillingAddress;
  items: Array<JeevesOrderItem>;
};

/** Shipping address for Jeeves order export */
export type JeevesShippingAddress = {
  __typename?: 'JeevesShippingAddress';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  co?: Maybe<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** A recipient of an email. */
export type MailRecipient = {
  __typename?: 'MailRecipient';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Menu item */
export type MenuItem = {
  __typename?: 'MenuItem';
  id: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  items: Array<MenuItem>;
};

/** Menu json */
export type Menu = {
  __typename?: 'Menu';
  items: Array<MenuItem>;
};

/** A notification (general or guest checkout) */
export type Notification = {
  __typename?: 'Notification';
  /** The notification ID */
  id: Scalars['Int']['output'];
  /** The notification message */
  message?: Maybe<Scalars['String']['output']>;
  /** The notification title */
  title?: Maybe<Scalars['String']['output']>;
  /** The notification status */
  status: Scalars['String']['output'];
  /** The notification type */
  type: Scalars['String']['output'];
  /** The consultant ID (for guest checkout notifications) */
  consultantId?: Maybe<Scalars['Int']['output']>;
  /** The guest email (for guest checkout notifications) */
  guestEmail?: Maybe<Scalars['String']['output']>;
  /** The customer name (for guest checkout notifications) */
  customerName?: Maybe<Scalars['String']['output']>;
  /** The customer phone (for guest checkout notifications) */
  customerPhone?: Maybe<Scalars['String']['output']>;
  /** When contact was initiated (for guest checkout notifications) */
  contactInitiatedAt?: Maybe<Scalars['String']['output']>;
  /** When contact was confirmed (for guest checkout notifications) */
  contactConfirmedAt?: Maybe<Scalars['String']['output']>;
  /** When customer link was requested (for guest checkout notifications) */
  customerLinkRequestedAt?: Maybe<Scalars['String']['output']>;
  /** When customer link was confirmed (for guest checkout notifications) */
  customerLinkConfirmedAt?: Maybe<Scalars['String']['output']>;
  /** The notification creation date */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The notification update date */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** The notification creation date */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The notification update date */
  updated_at?: Maybe<Scalars['String']['output']>;
};

/** A list of an organisations customer comments. */
export type OrganisationCustomerCommentList = {
  __typename?: 'OrganisationCustomerCommentList';
  items: Array<OrganisationCustomerComment>;
};

/** An organisations comment on a customer */
export type OrganisationCustomerComment = {
  __typename?: 'OrganisationCustomerComment';
  id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
};

/** The fields of a organisations related geolocations. */
export type OrganisationGeolocations = {
  __typename?: 'OrganisationGeolocations';
  items: Array<OrganisationGeolocation>;
};

/** The fields of a organisation with related geolocation data. */
export type OrganisationGeolocation = {
  __typename?: 'OrganisationGeolocation';
  organisation_id: Scalars['Int']['output'];
  longitude: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
};

/** A list of Organisation invoices. */
export type OrganisationInvoiceList = {
  __typename?: 'OrganisationInvoiceList';
  /** A list of Organisation invoices. */
  items: Array<OrganisationInvoice>;
  /** Whether invoicing is enabled for the Organisation. */
  isInvoicingEnabled: Scalars['Boolean']['output'];
};

/** An Organisation invoice type */
export type OrganisationInvoice = {
  __typename?: 'OrganisationInvoice';
  /** The id of the invoice. */
  id: Scalars['Int']['output'];
  /** The date and time the invoice was created. */
  created_at: Scalars['String']['output'];
  /** The date and time the invoice was last updated. */
  updated_at: Scalars['String']['output'];
  /** The id of the organisation. */
  organisation_id: Scalars['Int']['output'];
  /** The id of the customer. */
  customer_user_id?: Maybe<Scalars['Int']['output']>;
  /** The id of the order. */
  organisation_order_id: Scalars['Int']['output'];
  /** The invoice number. */
  invoice_number: Scalars['Int']['output'];
  /** Magento reference invoice number */
  magento_reference?: Maybe<Scalars['String']['output']>;
  /** Payment status of the invoice. */
  payment_status: Scalars['String']['output'];
  /** The date and time the invoice was last sent. */
  last_sent_at?: Maybe<Scalars['String']['output']>;
  /** The number of days the customer has to pay the invoice. */
  payment_terms_days: Scalars['Int']['output'];
  /** The date the invoice is due. */
  due_date: Scalars['String']['output'];
  /** The order the invoice is for. */
  organisationOrder: OrganisationOrder;
  /** The full name of the customer. */
  customerFullName: Scalars['String']['output'];
  /** Whether the invoice is overdue. */
  isOverdue: Scalars['Boolean']['output'];
  /** The amount of the order. */
  orderAmount: Scalars['Float']['output'];
};

/** A preview of an email. */
export type OrganisationMailPreview = {
  __typename?: 'OrganisationMailPreview';
  html: Scalars['String']['output'];
};

/** A list of an organisations order comments. */
export type OrganisationOrderCommentList = {
  __typename?: 'OrganisationOrderCommentList';
  items: Array<OrganisationOrderComment>;
};

/** An Organisation order comment type */
export type OrganisationOrderComment = {
  __typename?: 'OrganisationOrderComment';
  /** The id of the comment. */
  id: Scalars['Int']['output'];
  /** The creation date of the comment. */
  created_at: Scalars['String']['output'];
  /** The last update date of the comment. */
  updated_at: Scalars['String']['output'];
  /** The type of the author of the comment. */
  author_type: Scalars['String']['output'];
  /** The comment. */
  comment: Scalars['String']['output'];
  /** Whether the customer is notified of the comment. */
  is_customer_notified?: Maybe<Scalars['Int']['output']>;
  /** The ID of the organisation order. */
  organisation_order_id?: Maybe<Scalars['Int']['output']>;
  /** The ID of the author user. */
  author_user_id?: Maybe<Scalars['Int']['output']>;
  /** The author user. */
  author_user?: Maybe<User>;
};

/** An Organisation order items type */
export type OrganisationOrderItem = {
  __typename?: 'OrganisationOrderItem';
  /** The id of the order item. */
  id: Scalars['Int']['output'];
  /** The quantity of the order item. */
  quantity: Scalars['Float']['output'];
  /** The base price of the order item. */
  basePrice: Scalars['Float']['output'];
  /** The price of the order item. */
  price: Scalars['Float']['output'];
  /** The price of the order item excluding tax. */
  priceExclTax: Scalars['Float']['output'];
  /** The tax percentage of the order item. */
  taxPercentage: Scalars['Float']['output'];
  /** The discount amount of the order item. */
  discountAmount?: Maybe<Scalars['Float']['output']>;
  /** The discount percentage of the order item. */
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  /** The ID of the product. */
  productId?: Maybe<Scalars['Int']['output']>;
  /** The SKU of the product. */
  productSku: Scalars['String']['output'];
  /** The name of the product. */
  productName: Scalars['String']['output'];
  /** The thumbnail URL of the product. */
  productThumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Original product if still available in elastic search database */
  product?: Maybe<Product>;
};

/** A list of Organisation orders. */
export type OrganisationOrderList = {
  __typename?: 'OrganisationOrderList';
  /** A list of Organisation orders. */
  items: Array<OrganisationOrder>;
  total: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

/** Details of an organisation order */
export type OrganisationOrder = {
  __typename?: 'OrganisationOrder';
  /** The ID of the order */
  id: Scalars['Int']['output'];
  /** Creation date of the order */
  createdAt: Scalars['String']['output'];
  /** Last update date of the order */
  updatedAt: Scalars['String']['output'];
  /** Date the confirmation email was sent */
  confirmationEmailSentAt?: Maybe<Scalars['String']['output']>;
  /** Status of the order */
  status: OrganisationOrderStatusEnum;
  /** Unique order number */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Customers full name */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Market for the order */
  market: Scalars['String']['output'];
  /** Language code */
  languageCode: Scalars['String']['output'];
  /** Payment method used */
  paymentMethod: Scalars['String']['output'];
  /** Payment identification */
  paymentIdentification?: Maybe<Scalars['String']['output']>;
  /** Delivery method */
  deliveryMethod: Scalars['String']['output'];
  /** Customer email address */
  customerEmail?: Maybe<Scalars['String']['output']>;
  /** Subtotal amount */
  subTotal: Scalars['Float']['output'];
  /** Total tax amount */
  taxTotal: Scalars['Float']['output'];
  /** Grand total amount */
  grandTotal: Scalars['Float']['output'];
  /** Grand total excluding tax */
  grandTotalExclTax: Scalars['Float']['output'];
  /** Shipping cost including tax */
  shippingInclTax: Scalars['Float']['output'];
  /** Shipping cost excluding tax */
  shippingExclTax: Scalars['Float']['output'];
  /** Total discount excluding tax */
  totalDiscountExclTax: Scalars['Float']['output'];
  /** Total discount including tax */
  totalDiscountInclTax: Scalars['Float']['output'];
  /** Tax information in JSON format */
  taxInformation?: Maybe<Scalars['String']['output']>;
  /** Discount amount */
  discountAmount?: Maybe<Scalars['Float']['output']>;
  /** Discount percentage */
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  /** Follow-up information */
  followUp?: Maybe<OrganisationOrderFollowUpEnum>;
  /** Whether to send a confirmation email */
  sendConfirmationEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Consultant number */
  consultantNumber?: Maybe<Scalars['String']['output']>;
  /** ID of the pickup location */
  pickupLocationId?: Maybe<Scalars['Int']['output']>;
  /** ID of the organisation */
  organisationId?: Maybe<Scalars['Int']['output']>;
  /** The customers billing address */
  billingAddress: Address;
  /** ID of the billing address */
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  /** ID of the shipping address */
  shippingAddressId?: Maybe<Scalars['Int']['output']>;
  /** ID of the customer user */
  customerUserId?: Maybe<Scalars['Int']['output']>;
  /** Invoice details */
  isInvoicingEnabled: Scalars['Boolean']['output'];
  /** Invoice details */
  invoice?: Maybe<OrganisationInvoice>;
  /** Items in the order */
  items: Array<OrganisationOrderItem>;
  /** Comments on the order */
  comments: Array<OrganisationOrderComment>;
};

/** All public fields for organisation/consultant */
export type OrganisationPublicContent = {
  __typename?: 'OrganisationPublicContent';
  id: Scalars['Int']['output'];
  profile_photo_path?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
  facebook_url: Scalars['String']['output'];
  website_url: Scalars['String']['output'];
  favourite_quote_id: Scalars['Int']['output'];
  presentation: Scalars['String']['output'];
  market: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  middle_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  title_name_short: Scalars['String']['output'];
  title_name_long: Scalars['String']['output'];
  personal_webshop_url: Scalars['String']['output'];
  full_personal_webshop_url: Scalars['String']['output'];
  profile_url: Scalars['String']['output'];
  shipping_co: Scalars['String']['output'];
  shipping_address: Scalars['String']['output'];
  shipping_postal_code: Scalars['String']['output'];
  shipping_city: Scalars['String']['output'];
};

/** Collection of Organisation public content type. */
export type OrganisationPublicSearchResultList = {
  __typename?: 'OrganisationPublicSearchResultList';
  items: Array<OrganisationPublicContent>;
  count: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
};

/** A sent mail. */
export type OrganisationSentMail = {
  __typename?: 'OrganisationSentMail';
  sentAt: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mailTemplate: BizWizardMailTemplateEnum;
  mailRecipients: Array<MailRecipient>;
};

/** A list of sent mails. */
export type OrganisationSentMailsList = {
  __typename?: 'OrganisationSentMailsList';
  /** List of sent organisationSentMails. */
  items: Array<OrganisationSentMail>;
  total: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

/** The settings of an organisation */
export type OrganisationSettings = {
  __typename?: 'OrganisationSettings';
  email?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
  presentation?: Maybe<Scalars['String']['output']>;
  favourite_quote?: Maybe<Scalars['Int']['output']>;
  availability?: Maybe<Scalars['String']['output']>;
  deliveryOptions?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  billing_active?: Maybe<Scalars['Boolean']['output']>;
  show_vat_on_invoice?: Maybe<Scalars['Boolean']['output']>;
  billing_invoicing_method?: Maybe<OrganisationBillingInvoicingMethodEnum>;
  billing_payment_method?: Maybe<Scalars['String']['output']>;
  billing_account_number?: Maybe<Scalars['String']['output']>;
  billing_org_number?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  billing_phone_number?: Maybe<Scalars['String']['output']>;
  profile_url?: Maybe<Scalars['String']['output']>;
};

export type OrganisationStatistics = {
  __typename?: 'OrganisationStatistics';
  date_from: Scalars['String']['output'];
  date_to: Scalars['String']['output'];
  datapoints: Array<OrganisationStatisticsDatapoint>;
  charts: Array<OrganisationStatisticsChart>;
};

export type OrganisationStatisticsChart = {
  __typename?: 'OrganisationStatisticsChart';
  key: Scalars['String']['output'];
  datapoints: Array<OrganisationStatisticsDatapoint>;
};

export type OrganisationStatisticsDatapoint = {
  __typename?: 'OrganisationStatisticsDatapoint';
  key: Scalars['String']['output'];
  value: Scalars['Float']['output'];
  type: OrganisationDatapointTypeEnum;
};

/** A list of an organisations tags. */
export type OrganisationTagList = {
  __typename?: 'OrganisationTagList';
  items: Array<OrganisationTag>;
};

/** A tag of an organisation. */
export type OrganisationTag = {
  __typename?: 'OrganisationTag';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Collection of pages */
export type Page = {
  __typename?: 'Page';
  /** ID of page */
  id: Scalars['Int']['output'];
  /** slug of the page */
  slug: Scalars['String']['output'];
  /** Title of the page */
  title: Scalars['String']['output'];
  /** Body/Content (HTML) of the page */
  content: Scalars['String']['output'];
  /** Breadcrumbs on the page */
  breadcrumbs: Array<Breadcrumb>;
  /** Elementor CSS stylesheet URLs for this page */
  elementorStyles: Array<Scalars['String']['output']>;
  /** Scoped Elementor CSS content for this page */
  elementorCss?: Maybe<Scalars['String']['output']>;
  /** Elementor JS script URLs for this page */
  elementorScripts: Array<Scalars['String']['output']>;
  /** Elementor frontend config JSON string */
  elementorConfig?: Maybe<Scalars['String']['output']>;
};

/** A participant */
export type Participant = {
  __typename?: 'Participant';
  id: Scalars['Int']['output'];
  user_id?: Maybe<Scalars['Int']['output']>;
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  invite_sent_at?: Maybe<Scalars['String']['output']>;
  invite_accepted_at?: Maybe<Scalars['String']['output']>;
  profile_photo_path?: Maybe<Scalars['String']['output']>;
};

/** List of participants */
export type ParticipantsList = {
  __typename?: 'ParticipantsList';
  items: Array<Participant>;
};

/** ProductChild type */
export type ProductChild = {
  __typename?: 'ProductChild';
  groupName: Scalars['String']['output'];
  choices: Array<ProductChoice>;
};

/** ProductChoice type */
export type ProductChoice = {
  __typename?: 'ProductChoice';
  label?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  product: Product;
};

/** Product Filters type */
export type ProductFilters = {
  __typename?: 'ProductFilters';
  mkProductType: Array<Scalars['String']['output']>;
  colorName: Array<Scalars['String']['output']>;
  skinType: Array<Scalars['String']['output']>;
  productSeries: Array<Scalars['String']['output']>;
  usageRegion: Array<Scalars['String']['output']>;
  skinTone: Array<Scalars['String']['output']>;
  makeupProperties: Array<Scalars['String']['output']>;
  finish: Array<Scalars['String']['output']>;
  fragrance: Array<Scalars['String']['output']>;
  seminarYear: Array<Scalars['String']['output']>;
};

/** ProductImage type */
export type ProductImage = {
  __typename?: 'ProductImage';
  full: Scalars['String']['output'];
  url: Scalars['String']['output'];
  preview: Scalars['String']['output'];
  isThumbnail: Scalars['Boolean']['output'];
};

/** Collection of Product type. */
export type ProductList = {
  __typename?: 'ProductList';
  items: Array<Product>;
  total: Scalars['Int']['output'];
  from: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  productFilters: CountedProductFilters;
};

/** Contains consultant favourites, special offers, and daily offers. */
export type ProductRecommendations = {
  __typename?: 'ProductRecommendations';
  favourites?: Maybe<Array<Product>>;
  specialOffers?: Maybe<Array<Product>>;
  dailyOffers?: Maybe<Array<Product>>;
};

/** Collection of Public Product Data type. */
export type PublicProductList = {
  __typename?: 'PublicProductList';
  items: Array<Maybe<PublicProduct>>;
  total: Scalars['Int']['output'];
  from: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

/** Product type */
export type Product = {
  __typename?: 'Product';
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  publish: Scalars['Boolean']['output'];
  images: Array<ProductImage>;
  volume?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  howItWorks?: Maybe<Scalars['String']['output']>;
  applicationTips?: Maybe<Scalars['String']['output']>;
  whatsNew?: Maybe<Scalars['String']['output']>;
  importantInfo?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  parentWrapperId?: Maybe<Scalars['Int']['output']>;
  parentWrapperSku?: Maybe<Scalars['String']['output']>;
  consultantUserId?: Maybe<Scalars['Int']['output']>;
  categoryIndexes: Array<Scalars['Int']['output']>;
  categories?: Maybe<Array<Scalars['Int']['output']>>;
  children?: Maybe<Array<ProductChild>>;
  bundledProducts?: Maybe<Array<BundledProductItem>>;
  productFilters?: Maybe<ProductFilters>;
  /** Breadcrumbs on the product */
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  /** Price set by consultant */
  consultantPrice?: Maybe<Scalars['Float']['output']>;
  /** Special price set by consultant */
  specialPrice?: Maybe<Scalars['Float']['output']>;
  /** Todays offer price set by consultant */
  todaysOfferPrice?: Maybe<Scalars['Float']['output']>;
  /** Is product End of life overridable, set by Lesley */
  endOfLifeOverridable?: Maybe<Scalars['Boolean']['output']>;
  /** End of life override set by consultant */
  endOfLifeOverride?: Maybe<Scalars['Boolean']['output']>;
  /** Lowest price offered in the last 30 days (Omnibus directive) */
  lowestPrice30Days?: Maybe<Scalars['Float']['output']>;
};

/** Public Product type */
export type PublicProduct = {
  __typename?: 'PublicProduct';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Save To Cart Return type */
export type SaveToCartReturn = {
  __typename?: 'SaveToCartReturn';
  cartId: Scalars['Int']['output'];
};

/** Success Return type */
export type SuccessReturn = {
  __typename?: 'SuccessReturn';
  success: Scalars['Boolean']['output'];
};

/** Customer Link Response type */
export type CustomerLinkResponse = {
  __typename?: 'CustomerLinkResponse';
  success: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  already_confirmed?: Maybe<Scalars['Boolean']['output']>;
};

/** Consultant information from hash */
export type ConsultantInfoFromHash = {
  __typename?: 'ConsultantInfoFromHash';
  consultantName?: Maybe<Scalars['String']['output']>;
  consultantImage?: Maybe<Scalars['String']['output']>;
  consultantPresentation?: Maybe<Scalars['String']['output']>;
  organisationName?: Maybe<Scalars['String']['output']>;
};

/** Public information about consultant guest checkout submission */
export type PublicConsultantSubmission = {
  __typename?: 'PublicConsultantSubmission';
  id: Scalars['Int']['output'];
  profile_photo_url: Scalars['String']['output'];
  email: Scalars['String']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  presentation: Scalars['String']['output'];
  consultant_locale: Scalars['String']['output'];
  consultant_number: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  title_name_short: Scalars['String']['output'];
  title_name_long: Scalars['String']['output'];
  personal_webshop_url: Scalars['String']['output'];
};

/** Paginated collection of public consultant submissions */
export type PublicConsultantSubmissions = {
  __typename?: 'PublicConsultantSubmissions';
  items: Array<PublicConsultantSubmission>;
  count: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  currentPage: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
};

/** Totals Row type */
export type TotalsRow = {
  __typename?: 'TotalsRow';
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
  translate: Scalars['Boolean']['output'];
  value: Scalars['Float']['output'];
  sort: Scalars['Int']['output'];
};

/** Totals type */
export type Totals = {
  __typename?: 'Totals';
  rows: Array<TotalsRow>;
};

/** A Users birthday */
export type UserBirthday = {
  __typename?: 'UserBirthday';
  date: Scalars['String']['output'];
  user: User;
  days_until: Scalars['Int']['output'];
  is_today: Scalars['Boolean']['output'];
};

/** A list of users birthdays */
export type UserBirthdayList = {
  __typename?: 'UserBirthdayList';
  total: Scalars['Int']['output'];
  items: Array<UserBirthday>;
};

/** Collection of User type. */
export type UserList = {
  __typename?: 'UserList';
  items: Array<User>;
  count: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
};

/** A User */
export type User = {
  __typename?: 'User';
  id: Scalars['Int']['output'];
  created_at: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
  register_date?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  date_of_birth?: Maybe<Scalars['String']['output']>;
  profile_photo_path?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  user_type: UserTypeEnum;
  newsletter: Scalars['Boolean']['output'];
  login_provider: Scalars['String']['output'];
  billing_address?: Maybe<Address>;
  shipping_address?: Maybe<Address>;
  customer_organisation_relation?: Maybe<CustomerOrganisationRelation>;
  consultant_personal_webshop_slug?: Maybe<Scalars['String']['output']>;
  recruitedByCustomerUser?: Maybe<User>;
  recruited_by_customer_id?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<OrganisationTag>>;
  system_tags?: Maybe<Array<CustomerSystemTagEnum>>;
};

/** A BackwebUser */
export type BackwebUser = {
  __typename?: 'BackwebUser';
  id: Scalars['Int']['output'];
  registered_at: Scalars['String']['output'];
  last_updated_at: Scalars['String']['output'];
  name: Scalars['String']['output'];
  email: Scalars['String']['output'];
  date_of_birth?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  user_type: UserTypeEnum;
  newsletter: Scalars['Boolean']['output'];
  organisation_id?: Maybe<Scalars['Int']['output']>;
  customer_specific_information?: Maybe<BackwebCustomerSpecificInformation>;
  contact_specific_information?: Maybe<BackwebContactSpecificInformation>;
  consultant_specific_information?: Maybe<BackwebConsultantSpecificInformation>;
  admin_specific_information?: Maybe<BackwebAdminSpecificInformation>;
};

/** Paginated collection of minimal user data */
export type BackwebMinimalUsers = {
  __typename?: 'BackwebMinimalUsers';
  items: Array<BackwebMinimalUser>;
  count: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  currentPage: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
};

/** A minimal representation of a BackwebUser */
export type BackwebMinimalUser = {
  __typename?: 'BackwebMinimalUser';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  email: Scalars['String']['output'];
  user_type: UserTypeEnum;
};

/** Consultant-specific information for a user_type consultant */
export type BackwebConsultantSpecificInformation = {
  __typename?: 'BackwebConsultantSpecificInformation';
  created_at: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
  consultant_number: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  country_code: Scalars['String']['output'];
  shipping_name: Scalars['String']['output'];
  register_date?: Maybe<Scalars['String']['output']>;
  unregistered: Scalars['Boolean']['output'];
  unregistered_date?: Maybe<Scalars['String']['output']>;
  recruited_by_number: Scalars['String']['output'];
  personal_webshop_active: Scalars['Boolean']['output'];
  find_consultant_active: Scalars['Boolean']['output'];
  personal_webshop_active_from?: Maybe<Scalars['String']['output']>;
  personal_webshop_active_to?: Maybe<Scalars['String']['output']>;
  personal_webshop_url?: Maybe<Scalars['String']['output']>;
  shipping_co?: Maybe<Scalars['String']['output']>;
  shipping_address: Scalars['String']['output'];
  shipping_postal_code: Scalars['String']['output'];
  shipping_city: Scalars['String']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  title_id: Scalars['String']['output'];
  title_name_short: Scalars['String']['output'];
  title_name_long: Scalars['String']['output'];
};

/** Customer-specific information for a user_type user */
export type BackwebCustomerSpecificInformation = {
  __typename?: 'BackwebCustomerSpecificInformation';
  address?: Maybe<Address>;
  organisation_relation?: Maybe<CustomerOrganisationRelation>;
};

/** Contact-specific information for a contact user_type, */
export type BackwebContactSpecificInformation = {
  __typename?: 'BackwebContactSpecificInformation';
  mobile: Scalars['String']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  city: Scalars['String']['output'];
  address: Scalars['String']['output'];
  consultant_name: Scalars['String']['output'];
  consultant_number: Scalars['String']['output'];
};

/** Admin-specific information for a admin user_type, */
export type BackwebAdminSpecificInformation = {
  __typename?: 'BackwebAdminSpecificInformation';
  mobile: Scalars['String']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  city: Scalars['String']['output'];
  address: Scalars['String']['output'];
  acl_role_id?: Maybe<Scalars['Int']['output']>;
  acl_role_name?: Maybe<Scalars['String']['output']>;
};

/** A type representing shipping method */
export type BackwebShippingMethod = {
  __typename?: 'BackwebShippingMethod';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  shipping_price: Scalars['Int']['output'];
  country_code: BackwebShippingMethodsCountryCodeEnum;
  status: BackwebShippingMethodsStatusEnum;
  choose_pickup_locator: Scalars['Boolean']['output'];
  pickup_locator_code?: Maybe<BackwebShippingMethodsCarrierEnum>;
  cart_types: Scalars['String']['output'];
  labels?: Maybe<Scalars['String']['output']>;
  tracking_service?: Maybe<BackwebShippingMethodsCarrierEnum>;
  postal_codes_exclude: Scalars['String']['output'];
};

/** A type representing an minimal order */
export type BackwebMinimalOrder = {
  __typename?: 'BackwebMinimalOrder';
  id: Scalars['Int']['output'];
  created_at: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
  status: OrganisationOrderStatusEnum;
  order_number?: Maybe<Scalars['String']['output']>;
  market: BackwebOrdersMarketEnum;
  grand_total: Scalars['Float']['output'];
  consultant_number?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
};

/** Paginated collection of minimal orders */
export type BackwebMinimalOrders = {
  __typename?: 'BackwebMinimalOrders';
  items: Array<BackwebMinimalOrder>;
  count: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  currentPage: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
};

/** A BackwebError type */
export type BackwebError = {
  __typename?: 'BackwebError';
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Contains all possible Backweb queries. */
export type BackwebQueryServices = {
  __typename?: 'BackwebQueryServices';
  shippingMethods: Array<BackwebShippingMethod>;
  minimalUsers: BackwebMinimalUsers;
  minimalOrders: BackwebMinimalOrders;
  organisationOrder: OrganisationOrder;
  user?: Maybe<BackwebUser>;
  aclRoles: Array<BackwebAclRole>;
  consultantSubmissions: BackwebConsultantSubmissions;
  commands: Array<Maybe<BackwebCommand>>;
  commandRuns: Array<Maybe<BackwebCommandRun>>;
  commandLog: Array<Maybe<Scalars['String']['output']>>;
};


/** Contains all possible Backweb queries. */
export type BackwebQueryServicesShippingMethodsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
};


/** Contains all possible Backweb queries. */
export type BackwebQueryServicesMinimalUsersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  aclRoleId?: InputMaybe<Scalars['Int']['input']>;
};


/** Contains all possible Backweb queries. */
export type BackwebQueryServicesMinimalOrdersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  filterMarket?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterGrandTotal?: InputMaybe<BackwebPriceRange>;
  filterUpdatedAt?: InputMaybe<BackwebDateRange>;
  filterCreatedAt?: InputMaybe<BackwebDateRange>;
};


/** Contains all possible Backweb queries. */
export type BackwebQueryServicesOrganisationOrderArgs = {
  id: Scalars['Int']['input'];
  consultant_number: Scalars['String']['input'];
};


/** Contains all possible Backweb queries. */
export type BackwebQueryServicesUserArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Contains all possible Backweb queries. */
export type BackwebQueryServicesCommandRunsArgs = {
  key: Scalars['String']['input'];
};


/** Contains all possible Backweb queries. */
export type BackwebQueryServicesCommandLogArgs = {
  key: Scalars['String']['input'];
  runId: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  maxBytes: Scalars['Int']['input'];
};

/** Contains all possible Backweb mutations. */
export type BackwebMutationServices = {
  __typename?: 'BackwebMutationServices';
  deleteUser: SuccessReturn;
  updateConsultant: SuccessReturn;
  updateContact: SuccessReturn;
  updateCustomer: SuccessReturn;
  updateShippingMethod: SuccessReturn;
  updateAdmin: SuccessReturn;
  createAdmin: SuccessReturn;
  updateAclRole: SuccessReturn;
  createAclRole: SuccessReturn;
  deleteAclRole: SuccessReturn;
  startCommand: Scalars['String']['output'];
  updateConsultantSubmission: SuccessReturn;
  deleteConsultantSubmission: SuccessReturn;
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesDeleteUserArgs = {
  id: Scalars['Int']['input'];
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesUpdateConsultantArgs = {
  user?: InputMaybe<BackwebConsultantInput>;
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesUpdateContactArgs = {
  user?: InputMaybe<BackwebContactInput>;
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesUpdateCustomerArgs = {
  user?: InputMaybe<BackwebCustomerInput>;
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesUpdateShippingMethodArgs = {
  shippingMethod?: InputMaybe<BackwebShippingMethodInput>;
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesUpdateAdminArgs = {
  user?: InputMaybe<BackwebAdminInput>;
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesCreateAdminArgs = {
  user?: InputMaybe<BackwebAdminInput>;
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesUpdateAclRoleArgs = {
  role?: InputMaybe<BackwebAclRoleInput>;
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesCreateAclRoleArgs = {
  role?: InputMaybe<BackwebAclRoleInput>;
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesDeleteAclRoleArgs = {
  id: Scalars['Int']['input'];
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesStartCommandArgs = {
  key: Scalars['String']['input'];
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesUpdateConsultantSubmissionArgs = {
  data?: InputMaybe<BackwebConsultantSubmissionInput>;
};


/** Contains all possible Backweb mutations. */
export type BackwebMutationServicesDeleteConsultantSubmissionArgs = {
  id: Scalars['Int']['input'];
};

/** A type representing a backweb acl role */
export type BackwebAclRole = {
  __typename?: 'BackwebAclRole';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permissions: Scalars['String']['output'];
  created_at?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

/** A type representing a consultant guest checkout submission */
export type BackwebConsultantSubmission = {
  __typename?: 'BackwebConsultantSubmission';
  id: Scalars['Int']['output'];
  consultant: BackwebUser;
  presentation_text: Scalars['String']['output'];
  ftax_confirmed: Scalars['Boolean']['output'];
  title_level: Scalars['String']['output'];
  presentation_image_url: Scalars['String']['output'];
  approved: Scalars['Boolean']['output'];
  approved_at?: Maybe<Scalars['String']['output']>;
  approved_by?: Maybe<BackwebUser>;
  created_at: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

/** Paginated collection of consultant submissions */
export type BackwebConsultantSubmissions = {
  __typename?: 'BackwebConsultantSubmissions';
  items: Array<BackwebConsultantSubmission>;
  count: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  currentPage: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
};

/** A whitelisted backweb command */
export type BackwebCommand = {
  __typename?: 'BackwebCommand';
  key: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  description: Scalars['String']['output'];
  dangerous: Scalars['Boolean']['output'];
};

/** A single command run entry */
export type BackwebCommandRun = {
  __typename?: 'BackwebCommandRun';
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  started_at: Scalars['String']['output'];
  finished_at?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  bytes: Scalars['Int']['output'];
};

/** A reusable WordPress block fetched by title */
export type CmsBlock = {
  __typename?: 'CmsBlock';
  content: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  bundledProduct?: Maybe<BundledProduct>;
  cart: CartResponse;
  customerOrderByCartUuid?: Maybe<CustomerOrder>;
  categories?: Maybe<CategoryList>;
  category?: Maybe<Category>;
  categorySlugs?: Maybe<CategorySlugList>;
  consultantActivityFeed: Array<ActivityFeedItem>;
  consultantCustomer: User;
  consultantCustomers: UserList;
  consultantProductSetting: ConsultantProductSetting;
  customerConsultantFavourites?: Maybe<ProductList>;
  customerOrganisationOrders: OrganisationOrderList;
  customerOrganisation?: Maybe<CustomerOrganisation>;
  eventForHostess: EventForHostess;
  event: Event;
  eventList: EventList;
  eventParticipants: ParticipantsList;
  favourites?: Maybe<ProductList>;
  menu: Menu;
  organisationCustomerComments: OrganisationCustomerCommentList;
  organisationFavourites?: Maybe<ProductList>;
  organisationRecommendations?: Maybe<ProductRecommendations>;
  organisationGeolocations: OrganisationGeolocations;
  organisationInvoiceList: OrganisationInvoiceList;
  organisationOrderComments: OrganisationOrderCommentList;
  organisationOrder: OrganisationOrder;
  customerOrdersForShopper: CustomerOrderList;
  organisationOrdersForCustomer: OrganisationOrderList;
  organisationOrders: OrganisationOrderList;
  organisationPublicContent: OrganisationPublicContent;
  organisationPublicSearch: OrganisationPublicSearchResultList;
  organisationSettings: OrganisationSettings;
  organisationStatistics: OrganisationStatistics;
  organisationTags: OrganisationTagList;
  page?: Maybe<Page>;
  cmsBlock?: Maybe<CmsBlock>;
  previewOrganisationMail: OrganisationMailPreview;
  product?: Maybe<Product>;
  products?: Maybe<ProductList>;
  publicProducts?: Maybe<PublicProductList>;
  randomProducts?: Maybe<ProductList>;
  recommended?: Maybe<ProductList>;
  recommendedRelated?: Maybe<ProductList>;
  sentOrganisationMails: OrganisationSentMailsList;
  userBirthdayList: UserBirthdayList;
  userFromUniqueHash?: Maybe<User>;
  user?: Maybe<User>;
  notifications: Array<Notification>;
  generalNotifications: Array<Notification>;
  generalNotificationsCount: Scalars['Int']['output'];
  contactRequests: Array<Notification>;
  contactRequestsCount: Scalars['Int']['output'];
  getConsultantInfoFromHash?: Maybe<ConsultantInfoFromHash>;
  publicConsultantSubmissionsContent: PublicConsultantSubmissions;
  /** Parent query for all Backweb queries, requires authentication */
  backweb: BackwebQueryServices;
};


export type QueryBundledProductArgs = {
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCartArgs = {
  market: Scalars['String']['input'];
};


export type QueryCustomerOrderByCartUuidArgs = {
  cartUuid: Scalars['String']['input'];
};


export type QueryCategoriesArgs = {
  market: Scalars['String']['input'];
};


export type QueryCategoryArgs = {
  market: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  showAllProducts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCategorySlugsArgs = {
  market: Scalars['String']['input'];
};


export type QueryConsultantActivityFeedArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  activityType?: InputMaybe<ActivityTypeFilterEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConsultantCustomerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryConsultantCustomersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paginate?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  filter_groups?: InputMaybe<Array<CustomersFilterGroupEnum>>;
};


export type QueryConsultantProductSettingArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerConsultantFavouritesArgs = {
  filters?: InputMaybe<ProductFilterInput>;
  sort?: InputMaybe<ProductSortInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerOrganisationOrdersArgs = {
  customerUserId: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrganisationOrderStatusEnum>;
  orderBy?: InputMaybe<OrganisationOrderOrderByEnum>;
  orderDirection?: InputMaybe<OrderDirectionEnum>;
};


export type QueryEventForHostessArgs = {
  eventHash: Scalars['String']['input'];
};


export type QueryEventArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEventListArgs = {
  date_from: Scalars['String']['input'];
  date_to: Scalars['String']['input'];
};


export type QueryEventParticipantsArgs = {
  eventId: Scalars['Int']['input'];
};


export type QueryFavouritesArgs = {
  filters?: InputMaybe<ProductFilterInput>;
  sort?: InputMaybe<ProductSortInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMenuArgs = {
  market: Scalars['String']['input'];
};


export type QueryOrganisationCustomerCommentsArgs = {
  customer_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganisationFavouritesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProductFilterInput>;
  sort?: InputMaybe<ProductSortInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganisationRecommendationsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganisationGeolocationsArgs = {
  market: Scalars['String']['input'];
};


export type QueryOrganisationInvoiceListArgs = {
  paymentStatusFilter?: InputMaybe<Scalars['String']['input']>;
  orderByDirection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganisationOrderCommentsArgs = {
  organisation_order_id: Scalars['Int']['input'];
};


export type QueryOrganisationOrderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomerOrdersForShopperArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganisationOrdersForCustomerArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganisationOrdersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrganisationOrderStatusEnum>;
  orderBy?: InputMaybe<OrganisationOrderOrderByEnum>;
  orderDirection?: InputMaybe<OrderDirectionEnum>;
};


export type QueryOrganisationPublicContentArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganisationPublicSearchArgs = {
  market: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organisationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryOrganisationStatisticsArgs = {
  date_from: Scalars['String']['input'];
  date_to: Scalars['String']['input'];
};


export type QueryPageArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
  market: Scalars['String']['input'];
};


export type QueryCmsBlockArgs = {
  title: Scalars['String']['input'];
};


export type QueryPreviewOrganisationMailArgs = {
  organisationMailInput?: InputMaybe<OrganisationMailInput>;
};


export type QueryProductArgs = {
  market: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  organisationPersonalWebshopSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductsArgs = {
  market?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductSortInput>;
  filters?: InputMaybe<ProductFilterInput>;
  category_slug_path?: InputMaybe<Scalars['String']['input']>;
  searchField?: InputMaybe<Scalars['String']['input']>;
  myCustomersFilter?: InputMaybe<MyCustomersProductListFilterEnum>;
  myCustomersSorting?: InputMaybe<MyCustomersProductSortInput>;
  includeUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
  unwrapWrappedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  includeVariants?: InputMaybe<Scalars['Boolean']['input']>;
  organisationPersonalWebshopSlug?: InputMaybe<Scalars['String']['input']>;
  includeEndOfLifeOverridable?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  onlyBundledProducts?: InputMaybe<Scalars['Boolean']['input']>;
  onlySimpleProducts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyReactivatableProducts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPublicProductsArgs = {
  market?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryRandomProductsArgs = {
  market: Scalars['String']['input'];
  organisationPersonalWebshopSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecommendedArgs = {
  market: Scalars['String']['input'];
  organisationPersonalWebshopSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecommendedRelatedArgs = {
  market: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  organisationPersonalWebshopSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySentOrganisationMailsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserBirthdayListArgs = {
  date: Scalars['String']['input'];
};


export type QueryUserFromUniqueHashArgs = {
  hash: Scalars['String']['input'];
  hashType: Scalars['String']['input'];
};


export type QueryNotificationsArgs = {
  consultantId: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGeneralNotificationsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGeneralNotificationsCountArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactRequestsArgs = {
  consultantId: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactRequestsCountArgs = {
  consultantId: Scalars['Int']['input'];
};


export type QueryGetConsultantInfoFromHashArgs = {
  hash: Scalars['String']['input'];
};


export type QueryBackwebArgs = {
  token: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addFavourite?: Maybe<SuccessReturn>;
  /** A mutation */
  createOrUpdateBundledProduct: BundledProduct;
  createContact?: Maybe<SuccessReturn>;
  createCustomer?: Maybe<SuccessReturn>;
  createCustomerOrganisationOrder: SuccessReturn;
  createEvent: SuccessReturn;
  createOrganisationCustomerComment: SuccessReturn;
  createOrganisationCustomerPassword?: Maybe<SuccessReturn>;
  createOrganisationInvoiceFromOrder?: Maybe<SuccessReturn>;
  createOrganisationOrderComment: SuccessReturn;
  createOrganisationOrder: SuccessReturn;
  createSelfRegisterCustomer?: Maybe<SuccessReturn>;
  createShopper?: Maybe<SuccessReturn>;
  sendMail: SuccessReturn;
  deleteCustomerOrganisationRelation: SuccessReturn;
  deleteFromCart: SuccessReturn;
  deleteOrganisationCustomerComment: SuccessReturn;
  deleteOrganisationOrderComment: SuccessReturn;
  participantAcceptEventInvitation: Event;
  removeFavourite?: Maybe<SuccessReturn>;
  requestOrganisationCustomerPasswordResetEmail: SuccessReturn;
  saveToCart: SaveToCartReturn;
  sendEventParticipantInvites: SuccessReturn;
  sendGuestInvitesAsHostessEmail: SuccessReturn;
  sendOrganisationEmail: FailedEmailList;
  sendOrganisationInvoiceEmail?: Maybe<SuccessReturn>;
  sendReferAFriendMail: SuccessReturn;
  unregisterCustomer: SuccessReturn;
  updateConsultantProductSettings: ConsultantProductSetting;
  updateCustomer?: Maybe<UpdatedCustomerPayload>;
  updateCustomerOrganisationRelation: SuccessReturn;
  updateEventForHostess: SuccessReturn;
  updateEvent: SuccessReturn;
  deleteEvent: SuccessReturn;
  updateOrganisationInvoiceMutation?: Maybe<SuccessReturn>;
  updateOrganisationOrder: SuccessReturn;
  updateOrganisationSettings: OrganisationSettings;
  verifyCustomerEmail?: Maybe<SuccessReturn>;
  createNotification?: Maybe<Notification>;
  updateNotification?: Maybe<Notification>;
  deleteNotification?: Maybe<SuccessReturn>;
  confirmContact?: Maybe<Notification>;
  requestCustomerLink?: Maybe<Notification>;
  confirmCustomerLink?: Maybe<Notification>;
  confirmCustomerLinkFromHash?: Maybe<CustomerLinkResponse>;
  markAsCompleted?: Maybe<Notification>;
  backweb: BackwebMutationServices;
};


export type MutationAddFavouriteArgs = {
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateOrUpdateBundledProductArgs = {
  bundle?: InputMaybe<BundledProductInput>;
};


export type MutationCreateContactArgs = {
  contact: ContactInput;
};


export type MutationCreateCustomerArgs = {
  customer?: InputMaybe<CustomerInput>;
};


export type MutationCreateCustomerOrganisationOrderArgs = {
  order: CustomerOrganisationOrderInput;
};


export type MutationCreateEventArgs = {
  event: EventInput;
};


export type MutationCreateOrganisationCustomerCommentArgs = {
  comment: OrganisationCustomerCommentInput;
};


export type MutationCreateOrganisationCustomerPasswordArgs = {
  hash: Scalars['String']['input'];
  hashType?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationCreateOrganisationInvoiceFromOrderArgs = {
  order_id: Scalars['Int']['input'];
  payment_terms_days: Scalars['Int']['input'];
};


export type MutationCreateOrganisationOrderCommentArgs = {
  comment: OrganisationOrderCommentInput;
};


export type MutationCreateOrganisationOrderArgs = {
  order: OrganisationOrderInput;
};


export type MutationCreateSelfRegisterCustomerArgs = {
  user?: InputMaybe<SelfRegisterCustomerInput>;
  consultantId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateShopperArgs = {
  user?: InputMaybe<ShopperRegisterInput>;
};


export type MutationSendMailArgs = {
  key?: InputMaybe<SendMailKeyEnum>;
  options?: InputMaybe<SendMailOptionInput>;
};


export type MutationDeleteCustomerOrganisationRelationArgs = {
  relationInput?: InputMaybe<CustomerOrganisationRelationDeleteInput>;
};


export type MutationDeleteFromCartArgs = {
  productId: Scalars['Int']['input'];
  childId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteOrganisationCustomerCommentArgs = {
  comment_id: Scalars['Int']['input'];
};


export type MutationDeleteOrganisationOrderCommentArgs = {
  comment_id: Scalars['Int']['input'];
};


export type MutationParticipantAcceptEventInvitationArgs = {
  hash: Scalars['String']['input'];
};


export type MutationRemoveFavouriteArgs = {
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRequestOrganisationCustomerPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSaveToCartArgs = {
  item?: InputMaybe<CartItemInput>;
  market: Scalars['String']['input'];
};


export type MutationSendEventParticipantInvitesArgs = {
  eventId: Scalars['Int']['input'];
};


export type MutationSendGuestInvitesAsHostessEmailArgs = {
  eventHash: Scalars['String']['input'];
};


export type MutationSendOrganisationEmailArgs = {
  organisationMailInput?: InputMaybe<OrganisationMailInput>;
};


export type MutationSendOrganisationInvoiceEmailArgs = {
  invoice_id: Scalars['Int']['input'];
  use_company_name?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSendReferAFriendMailArgs = {
  customerId: Scalars['Int']['input'];
};


export type MutationUnregisterCustomerArgs = {
  keepNewsletterSubscription?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateConsultantProductSettingsArgs = {
  productSettings?: InputMaybe<ConsultantProductSettingsInput>;
};


export type MutationUpdateCustomerArgs = {
  customer?: InputMaybe<UpdateCustomerInput>;
};


export type MutationUpdateCustomerOrganisationRelationArgs = {
  relationInput?: InputMaybe<CustomerOrganisationRelationInput>;
};


export type MutationUpdateEventForHostessArgs = {
  event: EventForHostessInput;
};


export type MutationUpdateEventArgs = {
  event: EventInput;
};


export type MutationDeleteEventArgs = {
  event: EventInput;
};


export type MutationUpdateOrganisationInvoiceMutationArgs = {
  invoiceId: Scalars['Int']['input'];
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOrganisationOrderArgs = {
  order: UpdateOrganisationOrderInput;
};


export type MutationUpdateOrganisationSettingsArgs = {
  settings: OrganisationSettingsInput;
};


export type MutationVerifyCustomerEmailArgs = {
  hash: Scalars['String']['input'];
};


export type MutationCreateNotificationArgs = {
  notification: NotificationInput;
};


export type MutationUpdateNotificationArgs = {
  notification: UpdateNotificationInput;
};


export type MutationDeleteNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationConfirmContactArgs = {
  notificationId: Scalars['Int']['input'];
};


export type MutationRequestCustomerLinkArgs = {
  notificationId: Scalars['Int']['input'];
};


export type MutationConfirmCustomerLinkArgs = {
  notificationId: Scalars['Int']['input'];
};


export type MutationConfirmCustomerLinkFromHashArgs = {
  hash: Scalars['String']['input'];
};


export type MutationMarkAsCompletedArgs = {
  notificationId: Scalars['Int']['input'];
};


export type MutationBackwebArgs = {
  token: Scalars['String']['input'];
};

export type BackwebUpdateCustomerMutationVariables = Exact<{
  user: BackwebCustomerInput;
  token: Scalars['String']['input'];
}>;


export type BackwebUpdateCustomerMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', updateCustomer: { __typename?: 'SuccessReturn', success: boolean } } };

export type BackwebUpdateConsultantMutationVariables = Exact<{
  user: BackwebConsultantInput;
  token: Scalars['String']['input'];
}>;


export type BackwebUpdateConsultantMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', updateConsultant: { __typename?: 'SuccessReturn', success: boolean } } };

export type BackwebUpdateContactMutationVariables = Exact<{
  user: BackwebContactInput;
  token: Scalars['String']['input'];
}>;


export type BackwebUpdateContactMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', updateContact: { __typename?: 'SuccessReturn', success: boolean } } };

export type BackwebDeleteUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  token: Scalars['String']['input'];
}>;


export type BackwebDeleteUserMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', deleteUser: { __typename?: 'SuccessReturn', success: boolean } } };

export type BackwebUpdateShippingMethodMutationVariables = Exact<{
  shippingMethod: BackwebShippingMethodInput;
  token: Scalars['String']['input'];
}>;


export type BackwebUpdateShippingMethodMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', updateShippingMethod: { __typename?: 'SuccessReturn', success: boolean } } };

export type BackwebUpdateAdminMutationVariables = Exact<{
  user: BackwebAdminInput;
  token: Scalars['String']['input'];
}>;


export type BackwebUpdateAdminMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', updateAdmin: { __typename?: 'SuccessReturn', success: boolean } } };

export type BackwebCreateAdminMutationVariables = Exact<{
  user: BackwebAdminInput;
  token: Scalars['String']['input'];
}>;


export type BackwebCreateAdminMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', createAdmin: { __typename?: 'SuccessReturn', success: boolean } } };

export type BackwebUpdateAclRoleMutationVariables = Exact<{
  role: BackwebAclRoleInput;
  token: Scalars['String']['input'];
}>;


export type BackwebUpdateAclRoleMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', updateAclRole: { __typename?: 'SuccessReturn', success: boolean } } };

export type BackwebCreateAclRoleMutationVariables = Exact<{
  role: BackwebAclRoleInput;
  token: Scalars['String']['input'];
}>;


export type BackwebCreateAclRoleMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', createAclRole: { __typename?: 'SuccessReturn', success: boolean } } };

export type BackwebDeleteAclRoleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  token: Scalars['String']['input'];
}>;


export type BackwebDeleteAclRoleMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', deleteAclRole: { __typename?: 'SuccessReturn', success: boolean } } };

export type UpdateConsultantSubmissionMutationVariables = Exact<{
  token: Scalars['String']['input'];
  data: BackwebConsultantSubmissionInput;
}>;


export type UpdateConsultantSubmissionMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', updateConsultantSubmission: { __typename?: 'SuccessReturn', success: boolean } } };

export type DeleteConsultantSubmissionMutationVariables = Exact<{
  token: Scalars['String']['input'];
  id: Scalars['Int']['input'];
}>;


export type DeleteConsultantSubmissionMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', deleteConsultantSubmission: { __typename?: 'SuccessReturn', success: boolean } } };

export type SendReferAFriendMailMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;


export type SendReferAFriendMailMutation = { __typename?: 'Mutation', sendReferAFriendMail: { __typename?: 'SuccessReturn', success: boolean } };

export type SendEventParticipantInvitesMutationVariables = Exact<{
  eventId: Scalars['Int']['input'];
}>;


export type SendEventParticipantInvitesMutation = { __typename?: 'Mutation', sendEventParticipantInvites: { __typename?: 'SuccessReturn', success: boolean } };

export type SendMailMutationVariables = Exact<{
  key: SendMailKeyEnum;
  options?: InputMaybe<SendMailOptionInput>;
}>;


export type SendMailMutation = { __typename?: 'Mutation', sendMail: { __typename?: 'SuccessReturn', success: boolean } };

export type CreateOrganisationCustomerPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  hashType: Scalars['String']['input'];
  hash: Scalars['String']['input'];
}>;


export type CreateOrganisationCustomerPasswordMutation = { __typename?: 'Mutation', createOrganisationCustomerPassword?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type VerifyCustomerEmailMutationVariables = Exact<{
  hash: Scalars['String']['input'];
}>;


export type VerifyCustomerEmailMutation = { __typename?: 'Mutation', verifyCustomerEmail?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type UpdateOrganisationOrderMutationVariables = Exact<{
  order: UpdateOrganisationOrderInput;
}>;


export type UpdateOrganisationOrderMutation = { __typename?: 'Mutation', updateOrganisationOrder: { __typename?: 'SuccessReturn', success: boolean } };

export type DeleteOrganisationOrderCommentMutationVariables = Exact<{
  comment_id: Scalars['Int']['input'];
}>;


export type DeleteOrganisationOrderCommentMutation = { __typename?: 'Mutation', deleteOrganisationOrderComment: { __typename?: 'SuccessReturn', success: boolean } };

export type CreateOrganisationOrderCommentMutationVariables = Exact<{
  comment: OrganisationOrderCommentInput;
}>;


export type CreateOrganisationOrderCommentMutation = { __typename?: 'Mutation', createOrganisationOrderComment: { __typename?: 'SuccessReturn', success: boolean } };

export type CreateOrganisationOrderMutationVariables = Exact<{
  order: OrganisationOrderInput;
}>;


export type CreateOrganisationOrderMutation = { __typename?: 'Mutation', createOrganisationOrder: { __typename?: 'SuccessReturn', success: boolean } };

export type SendOrganisationEmailMutationVariables = Exact<{
  organisationMailInput: OrganisationMailInput;
}>;


export type SendOrganisationEmailMutation = { __typename?: 'Mutation', sendOrganisationEmail: { __typename?: 'FailedEmailList', items: Array<string> } };

export type UpdateCustomerMutationVariables = Exact<{
  customer: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'UpdatedCustomerPayload', token?: string | null, user?: { __typename?: 'User', id: number, email: string, date_of_birth?: string | null, locale: string, newsletter: boolean, billing_address?: { __typename?: 'Address', id: number, email: string, mobile?: string | null, phone_number?: string | null, co?: string | null, address: string, postal_code: string, city: string, country_code: string } | null, customer_organisation_relation?: { __typename?: 'CustomerOrganisationRelation', user_id: number, organisation_id: number, active: boolean, vip: boolean, communication_consultant: boolean, career_interest: boolean, class_interest: boolean } | null } | null } | null };

export type UpdateConsultantProductSettingsMutationVariables = Exact<{
  productSettings: ConsultantProductSettingsInput;
}>;


export type UpdateConsultantProductSettingsMutation = { __typename?: 'Mutation', updateConsultantProductSettings: { __typename?: 'ConsultantProductSetting', organisation_id: number, product_id: number, base_price?: number | null, special_price?: number | null, special_price_from?: string | null, special_price_to?: string | null, todays_offer_price?: number | null, todays_offer_price_from?: string | null, todays_offer_price_to?: string | null, todays_offer_product_is_active?: boolean | null, product_is_active_central_control?: boolean | null } };

export type CreateCustomerMutationVariables = Exact<{
  customer: CustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type UpdateCustomerOrganisationRelationMutationVariables = Exact<{
  relationInput: CustomerOrganisationRelationInput;
}>;


export type UpdateCustomerOrganisationRelationMutation = { __typename?: 'Mutation', updateCustomerOrganisationRelation: { __typename?: 'SuccessReturn', success: boolean } };

export type DeleteCustomerOrganisationRelationMutationVariables = Exact<{
  relationInput: CustomerOrganisationRelationDeleteInput;
}>;


export type DeleteCustomerOrganisationRelationMutation = { __typename?: 'Mutation', deleteCustomerOrganisationRelation: { __typename?: 'SuccessReturn', success: boolean } };

export type UpdateOrganisationSettingsMutationVariables = Exact<{
  organisationSettings: OrganisationSettingsInput;
}>;


export type UpdateOrganisationSettingsMutation = { __typename?: 'Mutation', updateOrganisationSettings: { __typename?: 'OrganisationSettings', email?: string | null, mobile?: string | null, telephone?: string | null, facebook_url?: string | null, website_url?: string | null, presentation?: string | null, favourite_quote?: number | null, availability?: string | null, billing_invoicing_method?: OrganisationBillingInvoicingMethodEnum | null, billing_payment_method?: string | null, billing_account_number?: string | null, billing_active?: boolean | null, billing_org_number?: string | null, company_name?: string | null, billing_phone_number?: string | null, show_vat_on_invoice?: boolean | null } };

export type CreateOrganisationCustomerCommentMutationVariables = Exact<{
  comment: OrganisationCustomerCommentInput;
}>;


export type CreateOrganisationCustomerCommentMutation = { __typename?: 'Mutation', createOrganisationCustomerComment: { __typename?: 'SuccessReturn', success: boolean } };

export type DeleteOrganisationCustomerCommentMutationVariables = Exact<{
  comment_id: Scalars['Int']['input'];
}>;


export type DeleteOrganisationCustomerCommentMutation = { __typename?: 'Mutation', deleteOrganisationCustomerComment: { __typename?: 'SuccessReturn', success: boolean } };

export type UpdateEventMutationVariables = Exact<{
  event: EventInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'SuccessReturn', success: boolean } };

export type DeleteEventMutationVariables = Exact<{
  event: EventInput;
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent: { __typename?: 'SuccessReturn', success: boolean } };

export type CreateEventMutationVariables = Exact<{
  event: EventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'SuccessReturn', success: boolean } };

export type CreateContactMutationVariables = Exact<{
  contact: ContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type UpdateOrganisationInvoicePaymentStatusMutationVariables = Exact<{
  invoiceId: Scalars['Int']['input'];
  paymentStatus: Scalars['String']['input'];
}>;


export type UpdateOrganisationInvoicePaymentStatusMutation = { __typename?: 'Mutation', updateOrganisationInvoiceMutation?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type CreateOrganisationInvoiceFromOrderMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
  paymentTermsDays: Scalars['Int']['input'];
}>;


export type CreateOrganisationInvoiceFromOrderMutation = { __typename?: 'Mutation', createOrganisationInvoiceFromOrder?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type SendOrganisationInvoiceEmailMutationVariables = Exact<{
  invoice_id: Scalars['Int']['input'];
  use_company_name?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SendOrganisationInvoiceEmailMutation = { __typename?: 'Mutation', sendOrganisationInvoiceEmail?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type SendGuestInvitesAsHostessEmailMutationVariables = Exact<{
  eventHash: Scalars['String']['input'];
}>;


export type SendGuestInvitesAsHostessEmailMutation = { __typename?: 'Mutation', sendGuestInvitesAsHostessEmail: { __typename?: 'SuccessReturn', success: boolean } };

export type UpdateEventForHostessMutationVariables = Exact<{
  event: EventForHostessInput;
}>;


export type UpdateEventForHostessMutation = { __typename?: 'Mutation', updateEventForHostess: { __typename?: 'SuccessReturn', success: boolean } };

export type ParticipantAcceptEventInvitationMutationVariables = Exact<{
  hash: Scalars['String']['input'];
}>;


export type ParticipantAcceptEventInvitationMutation = { __typename?: 'Mutation', participantAcceptEventInvitation: { __typename?: 'Event', id: number, event_type: string, name: string, location: string, starts_at: string, ends_at: string } };

export type RequestOrganisationCustomerPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestOrganisationCustomerPasswordResetEmailMutation = { __typename?: 'Mutation', requestOrganisationCustomerPasswordResetEmail: { __typename?: 'SuccessReturn', success: boolean } };

export type CreateCustomerOrganisationOrderMutationVariables = Exact<{
  order: CustomerOrganisationOrderInput;
}>;


export type CreateCustomerOrganisationOrderMutation = { __typename?: 'Mutation', createCustomerOrganisationOrder: { __typename?: 'SuccessReturn', success: boolean } };

export type CreateOrUpdateBundledProductMutationVariables = Exact<{
  bundle: BundledProductInput;
}>;


export type CreateOrUpdateBundledProductMutation = { __typename?: 'Mutation', createOrUpdateBundledProduct: { __typename?: 'BundledProduct', id: number } };

export type CreateUserMutationVariables = Exact<{
  user: CustomerInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type CreateSelfRegisterCustomerMutationVariables = Exact<{
  user: SelfRegisterCustomerInput;
  consultantId: Scalars['Int']['input'];
}>;


export type CreateSelfRegisterCustomerMutation = { __typename?: 'Mutation', createSelfRegisterCustomer?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type CreateShopperMutationVariables = Exact<{
  user: ShopperRegisterInput;
}>;


export type CreateShopperMutation = { __typename?: 'Mutation', createShopper?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type UpdateUserMutationVariables = Exact<{
  user: UpdateCustomerInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'UpdatedCustomerPayload', token?: string | null, user?: { __typename?: 'User', id: number, name: string, email: string, date_of_birth?: string | null, locale: string, login_provider: string, newsletter: boolean, user_type: UserTypeEnum, fullName: string, created_at: string, updated_at: string, billing_address?: { __typename?: 'Address', id: number, type: string, phone_number?: string | null, address: string, postal_code: string, city: string, country_code: string, email: string, first_name: string, last_name: string } | null } | null } | null };

export type AddFavouriteMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type AddFavouriteMutation = { __typename?: 'Mutation', addFavourite?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type RemoveFavouriteMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type RemoveFavouriteMutation = { __typename?: 'Mutation', removeFavourite?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type SaveToCartMutationVariables = Exact<{
  market: Scalars['String']['input'];
  item: CartItemInput;
}>;


export type SaveToCartMutation = { __typename?: 'Mutation', saveToCart: { __typename?: 'SaveToCartReturn', cartId: number } };

export type DeleteFromCartMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  childId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DeleteFromCartMutation = { __typename?: 'Mutation', deleteFromCart: { __typename?: 'SuccessReturn', success: boolean } };

export type UnregisterCustomerMutationVariables = Exact<{
  keepNewsletterSubscription?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UnregisterCustomerMutation = { __typename?: 'Mutation', unregisterCustomer: { __typename?: 'SuccessReturn', success: boolean } };

export type ProductFragment = { __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null };

export type EventFragment = { __typename?: 'Event', id: number, name: string, event_type: string, starts_at: string, ends_at: string, start_date: string, end_date: string, start_time: string, end_time: string, notify_guests_not_accepted_invites_within_days?: number | null, location: string, hostess_id?: number | null, hostess_invited_at?: string | null, participant_ids: Array<number> };

export type GetBackwebMinimalUsersQueryVariables = Exact<{
  token: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  aclRoleId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBackwebMinimalUsersQuery = { __typename?: 'Query', backweb: { __typename?: 'BackwebQueryServices', minimalUsers: { __typename?: 'BackwebMinimalUsers', count: number, total: number, currentPage: number, pageCount: number, items: Array<{ __typename?: 'BackwebMinimalUser', id: number, name: string, email: string, user_type: UserTypeEnum }> } } };

export type GetBackwebShippingMethodsQueryVariables = Exact<{
  token: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBackwebShippingMethodsQuery = { __typename?: 'Query', backweb: { __typename?: 'BackwebQueryServices', shippingMethods: Array<{ __typename?: 'BackwebShippingMethod', id: number, name: string, shipping_price: number, country_code: BackwebShippingMethodsCountryCodeEnum, status: BackwebShippingMethodsStatusEnum, choose_pickup_locator: boolean, pickup_locator_code?: BackwebShippingMethodsCarrierEnum | null, cart_types: string, labels?: string | null, tracking_service?: BackwebShippingMethodsCarrierEnum | null, postal_codes_exclude: string }> } };

export type GetBackwebMinimalOrdersQueryVariables = Exact<{
  token: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  filterMarket?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filterStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filterGrandTotal?: InputMaybe<BackwebPriceRange>;
  filterUpdatedAt?: InputMaybe<BackwebDateRange>;
  filterCreatedAt?: InputMaybe<BackwebDateRange>;
}>;


export type GetBackwebMinimalOrdersQuery = { __typename?: 'Query', backweb: { __typename?: 'BackwebQueryServices', minimalOrders: { __typename?: 'BackwebMinimalOrders', count: number, total: number, currentPage: number, pageCount: number, items: Array<{ __typename?: 'BackwebMinimalOrder', id: number, created_at: string, updated_at: string, status: OrganisationOrderStatusEnum, order_number?: string | null, market: BackwebOrdersMarketEnum, grand_total: number, consultant_number?: string | null, first_name?: string | null, last_name?: string | null, customer_email?: string | null }> } } };

export type GetBackwebUserQueryVariables = Exact<{
  token: Scalars['String']['input'];
  id: Scalars['Int']['input'];
}>;


export type GetBackwebUserQuery = { __typename?: 'Query', backweb: { __typename?: 'BackwebQueryServices', user?: { __typename?: 'BackwebUser', id: number, registered_at: string, last_updated_at: string, name: string, email: string, date_of_birth?: string | null, locale: string, user_type: UserTypeEnum, newsletter: boolean, organisation_id?: number | null, customer_specific_information?: { __typename?: 'BackwebCustomerSpecificInformation', address?: { __typename?: 'Address', id: number, type: string, first_name: string, middle_name?: string | null, last_name: string, co?: string | null, address: string, postal_code: string, city: string, country_code: string, email: string, mobile?: string | null, phone_number?: string | null } | null, organisation_relation?: { __typename?: 'CustomerOrganisationRelation', user_id: number, organisation_id: number, active: boolean, vip: boolean, communication_consultant: boolean, career_interest: boolean, class_interest: boolean, consultant_name: string, consultant_number: string } | null } | null, contact_specific_information?: { __typename?: 'BackwebContactSpecificInformation', mobile: string, email: string, first_name: string, last_name: string, city: string, address: string, consultant_name: string, consultant_number: string } | null, consultant_specific_information?: { __typename?: 'BackwebConsultantSpecificInformation', created_at: string, updated_at: string, consultant_number: string, first_name: string, last_name: string, locale: string, country_code: string, shipping_name: string, register_date?: string | null, unregistered: boolean, unregistered_date?: string | null, recruited_by_number: string, personal_webshop_active: boolean, find_consultant_active: boolean, personal_webshop_active_from?: string | null, personal_webshop_active_to?: string | null, personal_webshop_url?: string | null, shipping_co?: string | null, shipping_address: string, shipping_postal_code: string, shipping_city: string, mobile?: string | null, email: string, title_id: string, title_name_short: string, title_name_long: string } | null, admin_specific_information?: { __typename?: 'BackwebAdminSpecificInformation', mobile: string, email: string, first_name: string, last_name: string, city: string, address: string, acl_role_id?: number | null, acl_role_name?: string | null } | null } | null } };

export type GetBackwebAclRolesQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetBackwebAclRolesQuery = { __typename?: 'Query', backweb: { __typename?: 'BackwebQueryServices', aclRoles: Array<{ __typename?: 'BackwebAclRole', id: number, name: string, permissions: string, created_at?: string | null, updated_at?: string | null }> } };

export type GetBackwebOrganisationOrderQueryVariables = Exact<{
  token: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  consultant_number: Scalars['String']['input'];
}>;


export type GetBackwebOrganisationOrderQuery = { __typename?: 'Query', backweb: { __typename?: 'BackwebQueryServices', organisationOrder: { __typename?: 'OrganisationOrder', id: number, orderNumber?: string | null, createdAt: string, customerEmail?: string | null, status: OrganisationOrderStatusEnum, taxTotal: number, grandTotal: number, grandTotalExclTax: number, totalDiscountExclTax: number, totalDiscountInclTax: number, isInvoicingEnabled: boolean, discountAmount?: number | null, discountPercentage?: number | null, followUp?: OrganisationOrderFollowUpEnum | null, sendConfirmationEmail?: boolean | null, confirmationEmailSentAt?: string | null, invoice?: { __typename?: 'OrganisationInvoice', id: number, invoice_number: number } | null, billingAddress: { __typename?: 'Address', id: number, type: string, email: string, mobile?: string | null, phone_number?: string | null, first_name: string, middle_name?: string | null, last_name: string, address: string, co?: string | null, city: string, postal_code: string, country_code: string }, items: Array<{ __typename?: 'OrganisationOrderItem', id: number, price: number, basePrice: number, quantity: number, priceExclTax: number, taxPercentage: number, productId?: number | null, productName: string, productSku: string, productThumbnailUrl?: string | null, discountAmount?: number | null, discountPercentage?: number | null }>, comments: Array<{ __typename?: 'OrganisationOrderComment', id: number, created_at: string, comment: string }> } } };

export type GetBackwebConsultantSubmissionsQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetBackwebConsultantSubmissionsQuery = { __typename?: 'Query', backweb: { __typename?: 'BackwebQueryServices', consultantSubmissions: { __typename?: 'BackwebConsultantSubmissions', count: number, total: number, currentPage: number, pageCount: number, items: Array<{ __typename?: 'BackwebConsultantSubmission', id: number, presentation_text: string, ftax_confirmed: boolean, title_level: string, presentation_image_url: string, approved: boolean, approved_at?: string | null, created_at: string, updated_at: string, consultant: { __typename?: 'BackwebUser', id: number, name: string, email: string, locale: string, registered_at: string, last_updated_at: string, user_type: UserTypeEnum, newsletter: boolean, consultant_specific_information?: { __typename?: 'BackwebConsultantSpecificInformation', created_at: string, updated_at: string, consultant_number: string, first_name: string, last_name: string, locale: string, country_code: string, shipping_name: string, register_date?: string | null, unregistered: boolean, unregistered_date?: string | null, recruited_by_number: string, personal_webshop_active: boolean, find_consultant_active: boolean, personal_webshop_active_from?: string | null, personal_webshop_active_to?: string | null, personal_webshop_url?: string | null, shipping_co?: string | null, shipping_address: string, shipping_postal_code: string, shipping_city: string, mobile?: string | null, email: string, title_id: string, title_name_short: string, title_name_long: string } | null }, approved_by?: { __typename?: 'BackwebUser', id: number, name: string, email: string, locale: string, registered_at: string, last_updated_at: string, user_type: UserTypeEnum, newsletter: boolean } | null }> } } };

export type GetBackwebCommandsQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetBackwebCommandsQuery = { __typename?: 'Query', backweb: { __typename?: 'BackwebQueryServices', commands: Array<{ __typename?: 'BackwebCommand', key: string, signature: string, description: string } | null> } };

export type StartBackwebCommandMutationVariables = Exact<{
  token: Scalars['String']['input'];
  key: Scalars['String']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type StartBackwebCommandMutation = { __typename?: 'Mutation', backweb: { __typename?: 'BackwebMutationServices', startCommand: string } };

export type GetBackwebCommandRunsQueryVariables = Exact<{
  token: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type GetBackwebCommandRunsQuery = { __typename?: 'Query', backweb: { __typename?: 'BackwebQueryServices', commandRuns: Array<{ __typename?: 'BackwebCommandRun', id: string, key: string, started_at: string, finished_at?: string | null, status: string, bytes: number } | null> } };

export type GetBackwebCommandLogQueryVariables = Exact<{
  token: Scalars['String']['input'];
  key: Scalars['String']['input'];
  runId: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  maxBytes: Scalars['Int']['input'];
}>;


export type GetBackwebCommandLogQuery = { __typename?: 'Query', backweb: { __typename?: 'BackwebQueryServices', commandLog: Array<string | null> } };

export type GetBundledProductQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type GetBundledProductQuery = { __typename?: 'Query', bundledProduct?: { __typename?: 'BundledProduct', id: number, consultant_user_id: number, name: string, description: string, sku: string, status: string } | null };

export type GetEventParticipantsQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
}>;


export type GetEventParticipantsQuery = { __typename?: 'Query', eventParticipants: { __typename?: 'ParticipantsList', items: Array<{ __typename?: 'Participant', id: number, user_id?: number | null, invite_sent_at?: string | null, invite_accepted_at?: string | null }> } };

export type GetOrganisationOrderQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOrganisationOrderQuery = { __typename?: 'Query', organisationOrder: { __typename?: 'OrganisationOrder', id: number, orderNumber?: string | null, createdAt: string, fullName?: string | null, customerEmail?: string | null, status: OrganisationOrderStatusEnum, taxTotal: number, grandTotal: number, grandTotalExclTax: number, totalDiscountExclTax: number, totalDiscountInclTax: number, isInvoicingEnabled: boolean, discountAmount?: number | null, discountPercentage?: number | null, followUp?: OrganisationOrderFollowUpEnum | null, sendConfirmationEmail?: boolean | null, confirmationEmailSentAt?: string | null, invoice?: { __typename?: 'OrganisationInvoice', id: number, invoice_number: number } | null, billingAddress: { __typename?: 'Address', id: number, type: string, email: string, mobile?: string | null, phone_number?: string | null, first_name: string, middle_name?: string | null, last_name: string, address: string, co?: string | null, city: string, postal_code: string, country_code: string }, items: Array<{ __typename?: 'OrganisationOrderItem', id: number, price: number, basePrice: number, quantity: number, priceExclTax: number, taxPercentage: number, productId?: number | null, productName: string, productSku: string, productThumbnailUrl?: string | null, discountAmount?: number | null, discountPercentage?: number | null, product?: { __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null } | null }>, comments: Array<{ __typename?: 'OrganisationOrderComment', id: number, created_at: string, comment: string }> } };

export type GetOrganisationOrdersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy: OrganisationOrderOrderByEnum;
  orderDirection: OrderDirectionEnum;
  status?: InputMaybe<OrganisationOrderStatusEnum>;
}>;


export type GetOrganisationOrdersQuery = { __typename?: 'Query', organisationOrders: { __typename?: 'OrganisationOrderList', total: number, page: number, size: number, items: Array<{ __typename?: 'OrganisationOrder', id: number, orderNumber?: string | null, createdAt: string, customerEmail?: string | null, status: OrganisationOrderStatusEnum, taxTotal: number, grandTotal: number, grandTotalExclTax: number, totalDiscountExclTax: number, totalDiscountInclTax: number, isInvoicingEnabled: boolean, discountAmount?: number | null, discountPercentage?: number | null, followUp?: OrganisationOrderFollowUpEnum | null, invoice?: { __typename?: 'OrganisationInvoice', id: number, invoice_number: number } | null, billingAddress: { __typename?: 'Address', id: number, type: string, email: string, mobile?: string | null, phone_number?: string | null, first_name: string, middle_name?: string | null, last_name: string, address: string, co?: string | null, city: string, postal_code: string, country_code: string }, items: Array<{ __typename?: 'OrganisationOrderItem', id: number, price: number, basePrice: number, quantity: number, priceExclTax: number, taxPercentage: number, productId?: number | null, productName: string, productSku: string, productThumbnailUrl?: string | null, discountAmount?: number | null, discountPercentage?: number | null }>, comments: Array<{ __typename?: 'OrganisationOrderComment', id: number, created_at: string, comment: string }> }> } };

export type GetSentOrganisationMailsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSentOrganisationMailsQuery = { __typename?: 'Query', sentOrganisationMails: { __typename?: 'OrganisationSentMailsList', total: number, page: number, size: number, items: Array<{ __typename?: 'OrganisationSentMail', sentAt: string, subject: string, headline: string, message: string, mailTemplate: BizWizardMailTemplateEnum, mailRecipients: Array<{ __typename?: 'MailRecipient', name: string, email: string }> }> } };

export type GetPreviewOrganisationMailQueryVariables = Exact<{
  organisationMailInput: OrganisationMailInput;
}>;


export type GetPreviewOrganisationMailQuery = { __typename?: 'Query', previewOrganisationMail: { __typename?: 'OrganisationMailPreview', html: string } };

export type GetConsultantCustomersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  paginate?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  filter_groups?: InputMaybe<Array<CustomersFilterGroupEnum> | CustomersFilterGroupEnum>;
}>;


export type GetConsultantCustomersQuery = { __typename?: 'Query', consultantCustomers: { __typename?: 'UserList', count: number, total?: number | null, currentPage?: number | null, pageCount?: number | null, items: Array<{ __typename?: 'User', id: number, name: string, created_at: string, updated_at: string, register_date?: string | null, email: string, date_of_birth?: string | null, locale: string, login_provider: string, newsletter: boolean, user_type: UserTypeEnum, profile_photo_path?: string | null, fullName: string, system_tags?: Array<CustomerSystemTagEnum> | null, tags?: Array<{ __typename?: 'OrganisationTag', id: number, name: string }> | null, billing_address?: { __typename?: 'Address', id: number, type: string, email: string, mobile?: string | null, phone_number?: string | null, first_name: string, middle_name?: string | null, last_name: string, address: string, co?: string | null, city: string, postal_code: string, country_code: string } | null, customer_organisation_relation?: { __typename?: 'CustomerOrganisationRelation', user_id: number, organisation_id: number, active: boolean, vip: boolean, communication_consultant: boolean, career_interest: boolean, class_interest: boolean } | null }> } };

export type GetConsultantCustomerQueryVariables = Exact<{
  customerUserId: Scalars['Int']['input'];
}>;


export type GetConsultantCustomerQuery = { __typename?: 'Query', consultantCustomer: { __typename?: 'User', id: number, name: string, created_at: string, updated_at: string, register_date?: string | null, email: string, date_of_birth?: string | null, locale: string, login_provider: string, newsletter: boolean, user_type: UserTypeEnum, profile_photo_path?: string | null, fullName: string, system_tags?: Array<CustomerSystemTagEnum> | null, tags?: Array<{ __typename?: 'OrganisationTag', id: number, name: string }> | null, billing_address?: { __typename?: 'Address', id: number, type: string, email: string, mobile?: string | null, phone_number?: string | null, first_name: string, middle_name?: string | null, last_name: string, address: string, co?: string | null, city: string, postal_code: string, country_code: string } | null, customer_organisation_relation?: { __typename?: 'CustomerOrganisationRelation', user_id: number, organisation_id: number, active: boolean, vip: boolean, communication_consultant: boolean, career_interest: boolean, class_interest: boolean } | null } };

export type GetConsultantActivityFeedQueryVariables = Exact<{
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  activityType?: InputMaybe<ActivityTypeFilterEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetConsultantActivityFeedQuery = { __typename?: 'Query', consultantActivityFeed: Array<{ __typename?: 'ActivityFeedItem', id: number, type: ActivityTypeEnum, description: string, created_at: string, orderInfo?: { __typename?: 'ActivityFeedItemOrderInfo', id: number, order_number: string, fullName: string, grand_total: number } | null, eventInfo?: { __typename?: 'ActivityFeedItemEventInfo', id: number, location: string, name: string, event_type: string, starts_at: string, ends_at: string } | null, customer?: { __typename?: 'User', id: number, name: string, fullName: string, email: string, locale: string, login_provider: string, newsletter: boolean, user_type: UserTypeEnum, created_at: string, updated_at: string, recruitedByCustomerUser?: { __typename?: 'User', id: number, name: string, fullName: string, email: string, locale: string, login_provider: string, newsletter: boolean, user_type: UserTypeEnum, created_at: string, updated_at: string } | null } | null }> };

export type GetConsultantProductSettingQueryVariables = Exact<{
  product_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetConsultantProductSettingQuery = { __typename?: 'Query', consultantProductSetting: { __typename?: 'ConsultantProductSetting', organisation_id: number, product_id: number, base_price?: number | null, special_price?: number | null, special_price_from?: string | null, special_price_to?: string | null, todays_offer_price?: number | null, todays_offer_price_from?: string | null, todays_offer_price_to?: string | null, todays_offer_product_is_active?: boolean | null, product_is_active_central_control?: boolean | null, end_of_life_override?: boolean | null } };

export type GetOrganisationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationSettingsQuery = { __typename?: 'Query', organisationSettings: { __typename?: 'OrganisationSettings', email?: string | null, mobile?: string | null, telephone?: string | null, facebook_url?: string | null, website_url?: string | null, presentation?: string | null, favourite_quote?: number | null, availability?: string | null, tags?: Array<string> | null, deliveryOptions?: Array<string> | null, billing_invoicing_method?: OrganisationBillingInvoicingMethodEnum | null, billing_payment_method?: string | null, billing_account_number?: string | null, billing_active?: boolean | null, billing_org_number?: string | null, company_name?: string | null, billing_phone_number?: string | null, profile_url?: string | null, show_vat_on_invoice?: boolean | null } };

export type GetOrganisationOrderCommentsQueryVariables = Exact<{
  organisation_order_id: Scalars['Int']['input'];
}>;


export type GetOrganisationOrderCommentsQuery = { __typename?: 'Query', organisationOrderComments: { __typename?: 'OrganisationOrderCommentList', items: Array<{ __typename?: 'OrganisationOrderComment', id: number, comment: string, created_at: string }> } };

export type GetOrganisationCustomerCommentsQueryVariables = Exact<{
  customer_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrganisationCustomerCommentsQuery = { __typename?: 'Query', organisationCustomerComments: { __typename?: 'OrganisationCustomerCommentList', items: Array<{ __typename?: 'OrganisationCustomerComment', id: number, comment: string, created_at: string }> } };

export type GetOrganisationTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationTagsQuery = { __typename?: 'Query', organisationTags: { __typename?: 'OrganisationTagList', items: Array<{ __typename?: 'OrganisationTag', id: number, name: string }> } };

export type GetEventQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
}>;


export type GetEventQuery = { __typename?: 'Query', event: { __typename?: 'Event', id: number, name: string, event_type: string, starts_at: string, ends_at: string, start_date: string, end_date: string, start_time: string, end_time: string, notify_guests_not_accepted_invites_within_days?: number | null, location: string, hostess_id?: number | null, hostess_invited_at?: string | null, participant_ids: Array<number> } };

export type GetEventsQueryVariables = Exact<{
  date_from: Scalars['String']['input'];
  date_to: Scalars['String']['input'];
}>;


export type GetEventsQuery = { __typename?: 'Query', eventList: { __typename?: 'EventList', events: Array<{ __typename?: 'Event', id: number, name: string, event_type: string, starts_at: string, ends_at: string, start_date: string, end_date: string, start_time: string, end_time: string, notify_guests_not_accepted_invites_within_days?: number | null, location: string, hostess_id?: number | null, hostess_invited_at?: string | null, participant_ids: Array<number> }> } };

export type GetOrganisationInvoiceListQueryVariables = Exact<{
  paymentStatusFilter?: InputMaybe<Scalars['String']['input']>;
  orderByDirection?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganisationInvoiceListQuery = { __typename?: 'Query', organisationInvoiceList: { __typename?: 'OrganisationInvoiceList', isInvoicingEnabled: boolean, items: Array<{ __typename?: 'OrganisationInvoice', id: number, created_at: string, last_sent_at?: string | null, updated_at: string, organisation_id: number, customer_user_id?: number | null, organisation_order_id: number, invoice_number: number, payment_status: string, payment_terms_days: number, due_date: string, customerFullName: string, isOverdue: boolean, orderAmount: number, magento_reference?: string | null, organisationOrder: { __typename?: 'OrganisationOrder', id: number, createdAt: string, orderNumber?: string | null, grandTotal: number } }> } };

export type GetUsersBirthdayListQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type GetUsersBirthdayListQuery = { __typename?: 'Query', userBirthdayList: { __typename?: 'UserBirthdayList', total: number, items: Array<{ __typename?: 'UserBirthday', date: string, days_until: number, user: { __typename?: 'User', id: number, name: string, created_at: string, updated_at: string, register_date?: string | null, email: string, date_of_birth?: string | null, locale: string, login_provider: string, newsletter: boolean, user_type: UserTypeEnum, profile_photo_path?: string | null, fullName: string, system_tags?: Array<CustomerSystemTagEnum> | null, tags?: Array<{ __typename?: 'OrganisationTag', id: number, name: string }> | null, billing_address?: { __typename?: 'Address', id: number, type: string, email: string, mobile?: string | null, phone_number?: string | null, first_name: string, middle_name?: string | null, last_name: string, address: string, co?: string | null, city: string, postal_code: string, country_code: string } | null, customer_organisation_relation?: { __typename?: 'CustomerOrganisationRelation', user_id: number, organisation_id: number, active: boolean, vip: boolean, communication_consultant: boolean, career_interest: boolean, class_interest: boolean } | null } }> } };

export type GetStatisticsQueryVariables = Exact<{
  date_from: Scalars['String']['input'];
  date_to: Scalars['String']['input'];
}>;


export type GetStatisticsQuery = { __typename?: 'Query', organisationStatistics: { __typename?: 'OrganisationStatistics', date_from: string, date_to: string, datapoints: Array<{ __typename?: 'OrganisationStatisticsDatapoint', key: string, value: number, type: OrganisationDatapointTypeEnum }>, charts: Array<{ __typename?: 'OrganisationStatisticsChart', key: string, datapoints: Array<{ __typename?: 'OrganisationStatisticsDatapoint', key: string, value: number, type: OrganisationDatapointTypeEnum }> }> } };

export type GetContactRequestsCountQueryVariables = Exact<{
  consultantId: Scalars['Int']['input'];
}>;


export type GetContactRequestsCountQuery = { __typename?: 'Query', contactRequestsCount: number };

export type GetGeneralNotificationsCountQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGeneralNotificationsCountQuery = { __typename?: 'Query', generalNotificationsCount: number };

export type GetContactRequestsQueryVariables = Exact<{
  consultantId: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContactRequestsQuery = { __typename?: 'Query', contactRequests: Array<{ __typename?: 'Notification', id: number, consultantId?: number | null, guestEmail?: string | null, message?: string | null, status: string, type: string, title?: string | null, customerName?: string | null, customerPhone?: string | null, contactInitiatedAt?: string | null, contactConfirmedAt?: string | null, customerLinkRequestedAt?: string | null, customerLinkConfirmedAt?: string | null, createdAt?: string | null, updatedAt?: string | null }> };

export type GetGeneralNotificationsQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGeneralNotificationsQuery = { __typename?: 'Query', generalNotifications: Array<{ __typename?: 'Notification', id: number, message?: string | null, status: string, type: string, title?: string | null, createdAt?: string | null, updatedAt?: string | null }> };

export type CreateNotificationMutationVariables = Exact<{
  notification: NotificationInput;
}>;


export type CreateNotificationMutation = { __typename?: 'Mutation', createNotification?: { __typename?: 'Notification', id: number, consultantId?: number | null, guestEmail?: string | null, message?: string | null, status: string, type: string, title?: string | null, customerName?: string | null, customerPhone?: string | null, createdAt?: string | null } | null };

export type UpdateNotificationMutationVariables = Exact<{
  notification: UpdateNotificationInput;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification?: { __typename?: 'Notification', id: number, consultantId?: number | null, guestEmail?: string | null, message?: string | null, status: string, type: string, customerName?: string | null, customerPhone?: string | null, contactInitiatedAt?: string | null, contactConfirmedAt?: string | null, customerLinkRequestedAt?: string | null, customerLinkConfirmedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type DeleteNotificationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteNotificationMutation = { __typename?: 'Mutation', deleteNotification?: { __typename?: 'SuccessReturn', success: boolean } | null };

export type ConfirmContactMutationVariables = Exact<{
  notificationId: Scalars['Int']['input'];
}>;


export type ConfirmContactMutation = { __typename?: 'Mutation', confirmContact?: { __typename?: 'Notification', id: number, consultantId?: number | null, guestEmail?: string | null, message?: string | null, status: string, type: string, customerName?: string | null, customerPhone?: string | null, contactInitiatedAt?: string | null, contactConfirmedAt?: string | null, customerLinkRequestedAt?: string | null, customerLinkConfirmedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type RequestCustomerLinkMutationVariables = Exact<{
  notificationId: Scalars['Int']['input'];
}>;


export type RequestCustomerLinkMutation = { __typename?: 'Mutation', requestCustomerLink?: { __typename?: 'Notification', id: number, consultantId?: number | null, guestEmail?: string | null, message?: string | null, status: string, type: string, customerName?: string | null, customerPhone?: string | null, contactInitiatedAt?: string | null, contactConfirmedAt?: string | null, customerLinkRequestedAt?: string | null, customerLinkConfirmedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type ConfirmCustomerLinkMutationVariables = Exact<{
  notificationId: Scalars['Int']['input'];
}>;


export type ConfirmCustomerLinkMutation = { __typename?: 'Mutation', confirmCustomerLink?: { __typename?: 'Notification', id: number, consultantId?: number | null, guestEmail?: string | null, message?: string | null, status: string, type: string, customerName?: string | null, customerPhone?: string | null, contactInitiatedAt?: string | null, contactConfirmedAt?: string | null, customerLinkRequestedAt?: string | null, customerLinkConfirmedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type ConfirmCustomerLinkFromHashMutationVariables = Exact<{
  hash: Scalars['String']['input'];
}>;


export type ConfirmCustomerLinkFromHashMutation = { __typename?: 'Mutation', confirmCustomerLinkFromHash?: { __typename?: 'CustomerLinkResponse', success: boolean, message: string, already_confirmed?: boolean | null } | null };

export type GetConsultantInfoFromHashQueryVariables = Exact<{
  hash: Scalars['String']['input'];
}>;


export type GetConsultantInfoFromHashQuery = { __typename?: 'Query', getConsultantInfoFromHash?: { __typename?: 'ConsultantInfoFromHash', consultantName?: string | null, consultantImage?: string | null, consultantPresentation?: string | null, organisationName?: string | null } | null };

export type MarkAsCompletedMutationVariables = Exact<{
  notificationId: Scalars['Int']['input'];
}>;


export type MarkAsCompletedMutation = { __typename?: 'Mutation', markAsCompleted?: { __typename?: 'Notification', id: number, consultantId?: number | null, guestEmail?: string | null, message?: string | null, status: string, type: string, customerName?: string | null, customerPhone?: string | null, contactInitiatedAt?: string | null, contactConfirmedAt?: string | null, customerLinkRequestedAt?: string | null, customerLinkConfirmedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type GetOrganisationGeolocationsQueryVariables = Exact<{
  market: Scalars['String']['input'];
}>;


export type GetOrganisationGeolocationsQuery = { __typename?: 'Query', organisationGeolocations: { __typename?: 'OrganisationGeolocations', items: Array<{ __typename?: 'OrganisationGeolocation', organisation_id: number, latitude: number, longitude: number }> } };

export type GetEventForHostessQueryVariables = Exact<{
  eventHash: Scalars['String']['input'];
}>;


export type GetEventForHostessQuery = { __typename?: 'Query', eventForHostess: { __typename?: 'EventForHostess', id: number, name: string, starts_at: string, ends_at: string, location: string, event_type: string, participants: Array<{ __typename?: 'Participant', id: number, user_id?: number | null, invite_sent_at?: string | null, invite_accepted_at?: string | null, fullName: string, first_name: string, last_name: string, email: string, mobile?: string | null, profile_photo_path?: string | null }> } };

export type GetUserFromUniqueHashQueryVariables = Exact<{
  hash: Scalars['String']['input'];
  hashType: Scalars['String']['input'];
}>;


export type GetUserFromUniqueHashQuery = { __typename?: 'Query', userFromUniqueHash?: { __typename?: 'User', email: string } | null };

export type GetConsultantFavouritesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProductFilterInput>;
  sort?: InputMaybe<ProductSortInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetConsultantFavouritesQuery = { __typename?: 'Query', organisationFavourites?: { __typename?: 'ProductList', from: number, size: number, total: number, items: Array<{ __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null }>, productFilters: { __typename?: 'CountedProductFilters', mkProductType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, colorName: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, productSeries: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, usageRegion: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinTone: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, makeupProperties: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, finish: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, fragrance: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, seminarYear: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }> } } | null };

export type GetConsultantRecommendationsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetConsultantRecommendationsQuery = { __typename?: 'Query', organisationRecommendations?: { __typename?: 'ProductRecommendations', favourites?: Array<{ __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null }> | null, specialOffers?: Array<{ __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null }> | null, dailyOffers?: Array<{ __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null }> | null } | null };

export type GetConsultantProfileQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetConsultantProfileQuery = { __typename?: 'Query', organisationPublicContent: { __typename?: 'OrganisationPublicContent', id: number, profile_photo_path?: string | null, email: string, mobile: string, facebook_url: string, favourite_quote_id: number, presentation: string, market: string, first_name: string, middle_name: string, last_name: string, title_name_short: string, title_name_long: string, personal_webshop_url: string } };

export type GetConsultantTextSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  market: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organisationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type GetConsultantTextSearchQuery = { __typename?: 'Query', organisationPublicSearch: { __typename?: 'OrganisationPublicSearchResultList', count: number, total?: number | null, currentPage?: number | null, pageCount?: number | null, items: Array<{ __typename?: 'OrganisationPublicContent', id: number, profile_photo_path?: string | null, first_name: string, middle_name: string, last_name: string, shipping_address: string, shipping_postal_code: string, shipping_city: string, profile_url: string }> } };

export type GetCustomerOrganisationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerOrganisationQuery = { __typename?: 'Query', customerOrganisation?: { __typename?: 'CustomerOrganisation', country_code: string } | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, name: string, fullName: string, email: string, date_of_birth?: string | null, locale: string, login_provider: string, newsletter: boolean, user_type: UserTypeEnum, profile_photo_path?: string | null, consultant_personal_webshop_slug?: string | null, created_at: string, updated_at: string, billing_address?: { __typename?: 'Address', id: number, type: string, phone_number?: string | null, address: string, postal_code: string, city: string, country_code: string, email: string, first_name: string, last_name: string } | null, shipping_address?: { __typename?: 'Address', id: number, type: string, phone_number?: string | null, address: string, postal_code: string, city: string, country_code: string, email: string, first_name: string, last_name: string } | null } | null };

export type GetCustomerConsultantFavouritesQueryVariables = Exact<{
  filters?: InputMaybe<ProductFilterInput>;
  sort?: InputMaybe<ProductSortInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCustomerConsultantFavouritesQuery = { __typename?: 'Query', customerConsultantFavourites?: { __typename?: 'ProductList', from: number, size: number, total: number, items: Array<{ __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null }>, productFilters: { __typename?: 'CountedProductFilters', mkProductType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, colorName: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, productSeries: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, usageRegion: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinTone: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, makeupProperties: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, finish: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, fragrance: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, seminarYear: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }> } } | null };

export type GetFavouritesIdsQueryVariables = Exact<{
  filters?: InputMaybe<ProductFilterInput>;
  sort?: InputMaybe<ProductSortInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFavouritesIdsQuery = { __typename?: 'Query', favourites?: { __typename?: 'ProductList', items: Array<{ __typename?: 'Product', id: number }> } | null };

export type GetFavouritesQueryVariables = Exact<{
  filters?: InputMaybe<ProductFilterInput>;
  sort?: InputMaybe<ProductSortInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFavouritesQuery = { __typename?: 'Query', favourites?: { __typename?: 'ProductList', from: number, size: number, total: number, items: Array<{ __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null }>, productFilters: { __typename?: 'CountedProductFilters', mkProductType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, colorName: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, productSeries: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, usageRegion: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinTone: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, makeupProperties: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, finish: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, fragrance: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, seminarYear: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }> } } | null };

export type GetRandomProductsQueryVariables = Exact<{
  market: Scalars['String']['input'];
  organisationPersonalWebshopSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRandomProductsQuery = { __typename?: 'Query', randomProducts?: { __typename?: 'ProductList', from: number, size: number, total: number, items: Array<{ __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null }>, productFilters: { __typename?: 'CountedProductFilters', mkProductType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, colorName: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, productSeries: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, usageRegion: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinTone: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, makeupProperties: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, finish: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, fragrance: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, seminarYear: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }> } } | null };

export type GetRecommendedProductsQueryVariables = Exact<{
  market: Scalars['String']['input'];
  organisationPersonalWebshopSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRecommendedProductsQuery = { __typename?: 'Query', recommended?: { __typename?: 'ProductList', from: number, size: number, total: number, items: Array<{ __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null }>, productFilters: { __typename?: 'CountedProductFilters', mkProductType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, colorName: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, productSeries: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, usageRegion: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinTone: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, makeupProperties: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, finish: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, fragrance: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, seminarYear: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }> } } | null };

export type GetRecommendedRelatedProductsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  market: Scalars['String']['input'];
  organisationPersonalWebshopSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRecommendedRelatedProductsQuery = { __typename?: 'Query', recommendedRelated?: { __typename?: 'ProductList', from: number, size: number, total: number, items: Array<{ __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null }>, productFilters: { __typename?: 'CountedProductFilters', mkProductType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, colorName: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, productSeries: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, usageRegion: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinTone: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, makeupProperties: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, finish: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, fragrance: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, seminarYear: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }> } } | null };

export type GetCategoryQueryVariables = Exact<{
  market: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  showAllProducts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCategoryQuery = { __typename?: 'Query', category?: { __typename?: 'Category', pim_id: number, parent_pim_id: number, slug_path: string, title: string, meta_keywords?: string | null, meta_description?: string | null, description?: string | null, tag?: string | null, children?: Array<{ __typename?: 'Category', pim_id: number, parent_pim_id: number, slug_path: string, title: string, description?: string | null, meta_keywords?: string | null, meta_description?: string | null }> | null, breadcrumbs: Array<{ __typename?: 'Breadcrumb', title: string, href: string }> } | null };

export type GetCategoriesQueryVariables = Exact<{
  market: Scalars['String']['input'];
}>;


export type GetCategoriesQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoryList', count: number, items: Array<{ __typename?: 'Category', id: number, pim_id: number, parent_pim_id: number, name: string, title: string, language?: string | null, level: number, path: string, slug_path: string, tag?: string | null, breadcrumbs: Array<{ __typename?: 'Breadcrumb', title: string, href: string }>, children?: Array<{ __typename?: 'Category', id: number, pim_id: number, parent_pim_id: number, name: string, title: string, language?: string | null, level: number, path: string, slug_path: string, breadcrumbs: Array<{ __typename?: 'Breadcrumb', title: string, href: string }>, children?: Array<{ __typename?: 'Category', id: number, pim_id: number, parent_pim_id: number, name: string, title: string, language?: string | null, level: number, path: string, slug_path: string, breadcrumbs: Array<{ __typename?: 'Breadcrumb', title: string, href: string }> }> | null }> | null }> } | null };

export type GetCategorySlugsQueryVariables = Exact<{
  market: Scalars['String']['input'];
}>;


export type GetCategorySlugsQuery = { __typename?: 'Query', categorySlugs?: { __typename?: 'CategorySlugList', items: Array<string> } | null };

export type CommonProductFieldsFragment = { __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null };

export type GetCustomerOrganisationOrdersQueryVariables = Exact<{
  customerUserId: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy: OrganisationOrderOrderByEnum;
  orderDirection: OrderDirectionEnum;
  status?: InputMaybe<OrganisationOrderStatusEnum>;
}>;


export type GetCustomerOrganisationOrdersQuery = { __typename?: 'Query', customerOrganisationOrders: { __typename?: 'OrganisationOrderList', total: number, page: number, size: number, items: Array<{ __typename?: 'OrganisationOrder', id: number, orderNumber?: string | null, createdAt: string, customerEmail?: string | null, status: OrganisationOrderStatusEnum, taxTotal: number, grandTotal: number, grandTotalExclTax: number, totalDiscountExclTax: number, totalDiscountInclTax: number, isInvoicingEnabled: boolean, discountAmount?: number | null, discountPercentage?: number | null, followUp?: OrganisationOrderFollowUpEnum | null, invoice?: { __typename?: 'OrganisationInvoice', id: number, invoice_number: number } | null, billingAddress: { __typename?: 'Address', id: number, type: string, email: string, mobile?: string | null, phone_number?: string | null, first_name: string, middle_name?: string | null, last_name: string, address: string, co?: string | null, city: string, postal_code: string, country_code: string }, items: Array<{ __typename?: 'OrganisationOrderItem', id: number, price: number, basePrice: number, quantity: number, priceExclTax: number, taxPercentage: number, productId?: number | null, productName: string, productSku: string, productThumbnailUrl?: string | null, discountAmount?: number | null, discountPercentage?: number | null }>, comments: Array<{ __typename?: 'OrganisationOrderComment', id: number, created_at: string, comment: string }> }> } };

export type ProductFiltersFragment = { __typename?: 'Product', productFilters?: { __typename?: 'ProductFilters', mkProductType: Array<string>, colorName: Array<string>, skinType: Array<string>, productSeries: Array<string>, usageRegion: Array<string>, skinTone: Array<string>, makeupProperties: Array<string>, finish: Array<string>, fragrance: Array<string>, seminarYear: Array<string> } | null };

export type CountedProductFilterFragment = { __typename?: 'CountedProductFilter', name: string, count: number };

export type CountedProductFiltersFragment = { __typename?: 'CountedProductFilters', mkProductType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, colorName: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, productSeries: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, usageRegion: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinTone: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, makeupProperties: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, finish: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, fragrance: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, seminarYear: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }> };

export type GetProductsQueryVariables = Exact<{
  market: Scalars['String']['input'];
  from: Scalars['Int']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  category_slug_path?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchField?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilterInput>;
  myCustomersFilter?: InputMaybe<MyCustomersProductListFilterEnum>;
  myCustomersSorting?: InputMaybe<MyCustomersProductSortInput>;
  sort?: InputMaybe<ProductSortInput>;
  includeUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
  unwrapWrappedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  organisationPersonalWebshopSlug?: InputMaybe<Scalars['String']['input']>;
  includeEndOfLifeOverridable?: InputMaybe<Scalars['Boolean']['input']>;
  includeVariants?: InputMaybe<Scalars['Boolean']['input']>;
  onlyBundledProducts?: InputMaybe<Scalars['Boolean']['input']>;
  onlySimpleProducts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyReactivatableProducts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductList', from: number, size: number, total: number, items: Array<{ __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null }>, productFilters: { __typename?: 'CountedProductFilters', mkProductType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, colorName: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinType: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, productSeries: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, usageRegion: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, skinTone: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, makeupProperties: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, finish: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, fragrance: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }>, seminarYear: Array<{ __typename?: 'CountedProductFilter', name: string, count: number }> } } | null };

export type GetProductQueryVariables = Exact<{
  market: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  organisationPersonalWebshopSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', howItWorks?: string | null, applicationTips?: string | null, id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', title: string, href: string }> | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null, productFilters?: { __typename?: 'ProductFilters', mkProductType: Array<string>, colorName: Array<string>, skinType: Array<string>, productSeries: Array<string>, usageRegion: Array<string>, skinTone: Array<string>, makeupProperties: Array<string>, finish: Array<string>, fragrance: Array<string>, seminarYear: Array<string> } | null } | null };

export type CommonMenuItemFragment = { __typename?: 'MenuItem', id: number, slug: string, title: string, image?: string | null, thumbnail?: string | null };

export type GetFullMenuQueryVariables = Exact<{
  market: Scalars['String']['input'];
}>;


export type GetFullMenuQuery = { __typename?: 'Query', menu: { __typename?: 'Menu', items: Array<{ __typename?: 'MenuItem', id: number, slug: string, title: string, image?: string | null, thumbnail?: string | null, items: Array<{ __typename?: 'MenuItem', id: number, slug: string, title: string, image?: string | null, thumbnail?: string | null, items: Array<{ __typename?: 'MenuItem', id: number, slug: string, title: string, image?: string | null, thumbnail?: string | null, items: Array<{ __typename?: 'MenuItem', id: number, slug: string, title: string, image?: string | null, thumbnail?: string | null }> }> }> }> } };

export type GetPageQueryVariables = Exact<{
  market: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', id: number, slug: string, title: string, content: string, elementorStyles: Array<string>, elementorCss?: string | null, elementorScripts: Array<string>, elementorConfig?: string | null, breadcrumbs: Array<{ __typename?: 'Breadcrumb', title: string, href: string }> } | null };

export type GetCartQueryVariables = Exact<{
  market: Scalars['String']['input'];
}>;


export type GetCartQuery = { __typename?: 'Query', cart: { __typename?: 'CartResponse', cart: { __typename?: 'Cart', id?: number | null, user_id?: string | null, market?: string | null, uuid?: string | null, shipping_address?: string | null, billing_address?: string | null, shipping_method?: number | null, payment_method?: number | null, pickup_location?: string | null, checked_out_at?: string | null, created_at?: string | null, updated_at?: string | null, items: Array<{ __typename?: 'CartItem', id: number, cart_id: number, product_id: number, child_id?: number | null, quantity: number, created_at: string, updated_at: string, product: { __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null } }> }, totals: { __typename?: 'Totals', rows: Array<{ __typename?: 'TotalsRow', label: string, type: string, translate: boolean, value: number, sort: number }> } } };

export type GetOrganisationOrdersForCustomerQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
}>;


export type GetOrganisationOrdersForCustomerQuery = { __typename?: 'Query', organisationOrdersForCustomer: { __typename?: 'OrganisationOrderList', page: number, size: number, total: number, items: Array<{ __typename?: 'OrganisationOrder', id: number, orderNumber?: string | null, createdAt: string, status: OrganisationOrderStatusEnum, grandTotal: number, subTotal: number, taxTotal: number, paymentMethod: string, paymentIdentification?: string | null, deliveryMethod: string, shippingInclTax: number, items: Array<{ __typename?: 'OrganisationOrderItem', id: number, price: number, basePrice: number, quantity: number, priceExclTax: number, taxPercentage: number, productId?: number | null, productName: string, productSku: string, productThumbnailUrl?: string | null, discountAmount?: number | null, discountPercentage?: number | null, product?: { __typename?: 'Product', id: number, type: string, name: string, sku: string, slug?: string | null, parentWrapperId?: number | null, parentWrapperSku?: string | null, price: number, publish: boolean, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, consultantUserId?: number | null, categoryIndexes: Array<number>, description: string, volume?: string | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, lowestPrice30Days?: number | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }>, bundledProducts?: Array<{ __typename?: 'BundledProductItem', name: string, sku: string, quantity: number }> | null, children?: Array<{ __typename?: 'ProductChild', groupName: string, choices: Array<{ __typename?: 'ProductChoice', label?: string | null, color?: string | null, product: { __typename?: 'Product', id: number, name: string, sku: string, slug?: string | null, price: number, publish: boolean, categoryIndexes: Array<number>, description: string, volume?: string | null, type: string, consultantPrice?: number | null, specialPrice?: number | null, todaysOfferPrice?: number | null, endOfLifeOverridable?: boolean | null, endOfLifeOverride?: boolean | null, images: Array<{ __typename?: 'ProductImage', url: string, full: string, isThumbnail: boolean, preview: string }> } }> }> | null } | null }> }> } };

export type GetCustomerOrdersForShopperQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
}>;


export type GetCustomerOrdersForShopperQuery = { __typename?: 'Query', customerOrdersForShopper: { __typename?: 'CustomerOrderList', page: number, size: number, total: number, items: Array<{ __typename?: 'CustomerOrder', id: number, orderNumber?: string | null, createdAt: string, status: string, grandTotal: number, shippingInclTax: number, paymentMethod: string, deliveryMethod: string, items: Array<{ __typename?: 'CustomerOrderItem', id: number, productName: string, productThumbnailUrl?: string | null, price?: number | null, quantity?: number | null, productSku: string }>, deliveries: Array<{ __typename?: 'CustomerOrderDelivery', id: number, trackingNumber?: string | null, createdAt: string, items: Array<{ __typename?: 'CustomerOrderDeliveryItem', sku: string, quantity: number }> }> }> } };

export type GetPublicProductsQueryVariables = Exact<{
  market: Scalars['String']['input'];
  sku: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetPublicProductsQuery = { __typename?: 'Query', publicProducts?: { __typename?: 'PublicProductList', from: number, size: number, total: number, items: Array<{ __typename?: 'PublicProduct', id: number, sku: string, name: string, url?: string | null, thumbnail?: string | null } | null> } | null };

export type GetPublicConsultantSubmissionsProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublicConsultantSubmissionsProfileQuery = { __typename?: 'Query', publicConsultantSubmissionsContent: { __typename?: 'PublicConsultantSubmissions', count: number, total: number, currentPage: number, pageCount: number, items: Array<{ __typename?: 'PublicConsultantSubmission', id: number, profile_photo_url: string, email: string, mobile?: string | null, presentation: string, consultant_locale: string, consultant_number: string, full_name: string, first_name: string, last_name: string, title_name_short: string, title_name_long: string, personal_webshop_url: string }> } };

export type GetCmsBlockQueryVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type GetCmsBlockQuery = { __typename?: 'Query', cmsBlock?: { __typename?: 'CmsBlock', content: string } | null };

export type GetBackwebCommandsForUiQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetBackwebCommandsForUiQuery = { __typename?: 'Query', backweb: { __typename?: 'BackwebQueryServices', commands: Array<{ __typename?: 'BackwebCommand', key: string, signature: string, description: string, dangerous: boolean } | null> } };

export const ProductFragmentDoc = gql`
    fragment Product on Product {
  id
  type
  name
  sku
  slug
  parentWrapperId
  parentWrapperSku
  price
  publish
  consultantPrice
  specialPrice
  todaysOfferPrice
  consultantUserId
  images {
    url
    full
    isThumbnail
    preview
  }
  categoryIndexes
  description
  bundledProducts {
    name
    sku
    quantity
  }
  endOfLifeOverridable
  endOfLifeOverride
  children {
    groupName
    choices {
      label
      color
      product {
        id
        name
        sku
        slug
        price
        publish
        categoryIndexes
        description
        type
        consultantPrice
        specialPrice
        todaysOfferPrice
        endOfLifeOverridable
        endOfLifeOverride
        images {
          url
          full
          isThumbnail
          preview
        }
      }
    }
  }
}
    `;
export const EventFragmentDoc = gql`
    fragment Event on Event {
  id
  name
  event_type
  starts_at
  ends_at
  start_date
  end_date
  start_time
  end_time
  notify_guests_not_accepted_invites_within_days
  location
  hostess_id
  hostess_invited_at
  participant_ids
}
    `;
export const CommonProductFieldsFragmentDoc = gql`
    fragment CommonProductFields on Product {
  id
  type
  name
  sku
  slug
  parentWrapperId
  parentWrapperSku
  price
  publish
  consultantPrice
  specialPrice
  todaysOfferPrice
  consultantUserId
  images {
    url
    full
    isThumbnail
    preview
  }
  categoryIndexes
  description
  volume
  bundledProducts {
    name
    sku
    quantity
  }
  endOfLifeOverridable
  endOfLifeOverride
  lowestPrice30Days
  children {
    groupName
    choices {
      label
      color
      product {
        id
        name
        sku
        slug
        price
        publish
        categoryIndexes
        description
        volume
        type
        consultantPrice
        specialPrice
        todaysOfferPrice
        endOfLifeOverridable
        endOfLifeOverride
        images {
          url
          full
          isThumbnail
          preview
        }
      }
    }
  }
}
    `;
export const ProductFiltersFragmentDoc = gql`
    fragment ProductFilters on Product {
  productFilters {
    mkProductType
    colorName
    skinType
    productSeries
    usageRegion
    skinTone
    makeupProperties
    finish
    fragrance
    seminarYear
  }
}
    `;
export const CountedProductFilterFragmentDoc = gql`
    fragment CountedProductFilter on CountedProductFilter {
  name
  count
}
    `;
export const CountedProductFiltersFragmentDoc = gql`
    fragment CountedProductFilters on CountedProductFilters {
  mkProductType {
    ...CountedProductFilter
  }
  colorName {
    ...CountedProductFilter
  }
  skinType {
    ...CountedProductFilter
  }
  productSeries {
    ...CountedProductFilter
  }
  usageRegion {
    ...CountedProductFilter
  }
  skinTone {
    ...CountedProductFilter
  }
  makeupProperties {
    ...CountedProductFilter
  }
  finish {
    ...CountedProductFilter
  }
  fragrance {
    ...CountedProductFilter
  }
  seminarYear {
    ...CountedProductFilter
  }
}
    ${CountedProductFilterFragmentDoc}`;
export const CommonMenuItemFragmentDoc = gql`
    fragment CommonMenuItem on MenuItem {
  id
  slug
  title
  image
  thumbnail
}
    `;
export const BackwebUpdateCustomerDocument = gql`
    mutation backwebUpdateCustomer($user: BackwebCustomerInput!, $token: String!) {
  backweb(token: $token) {
    updateCustomer(user: $user) {
      success
    }
  }
}
    `;
export type BackwebUpdateCustomerMutationFn = Apollo.MutationFunction<BackwebUpdateCustomerMutation, BackwebUpdateCustomerMutationVariables>;

/**
 * __useBackwebUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useBackwebUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackwebUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backwebUpdateCustomerMutation, { data, loading, error }] = useBackwebUpdateCustomerMutation({
 *   variables: {
 *      user: // value for 'user'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBackwebUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<BackwebUpdateCustomerMutation, BackwebUpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackwebUpdateCustomerMutation, BackwebUpdateCustomerMutationVariables>(BackwebUpdateCustomerDocument, options);
      }
export type BackwebUpdateCustomerMutationHookResult = ReturnType<typeof useBackwebUpdateCustomerMutation>;
export type BackwebUpdateCustomerMutationResult = Apollo.MutationResult<BackwebUpdateCustomerMutation>;
export type BackwebUpdateCustomerMutationOptions = Apollo.BaseMutationOptions<BackwebUpdateCustomerMutation, BackwebUpdateCustomerMutationVariables>;
export const BackwebUpdateConsultantDocument = gql`
    mutation backwebUpdateConsultant($user: BackwebConsultantInput!, $token: String!) {
  backweb(token: $token) {
    updateConsultant(user: $user) {
      success
    }
  }
}
    `;
export type BackwebUpdateConsultantMutationFn = Apollo.MutationFunction<BackwebUpdateConsultantMutation, BackwebUpdateConsultantMutationVariables>;

/**
 * __useBackwebUpdateConsultantMutation__
 *
 * To run a mutation, you first call `useBackwebUpdateConsultantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackwebUpdateConsultantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backwebUpdateConsultantMutation, { data, loading, error }] = useBackwebUpdateConsultantMutation({
 *   variables: {
 *      user: // value for 'user'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBackwebUpdateConsultantMutation(baseOptions?: Apollo.MutationHookOptions<BackwebUpdateConsultantMutation, BackwebUpdateConsultantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackwebUpdateConsultantMutation, BackwebUpdateConsultantMutationVariables>(BackwebUpdateConsultantDocument, options);
      }
export type BackwebUpdateConsultantMutationHookResult = ReturnType<typeof useBackwebUpdateConsultantMutation>;
export type BackwebUpdateConsultantMutationResult = Apollo.MutationResult<BackwebUpdateConsultantMutation>;
export type BackwebUpdateConsultantMutationOptions = Apollo.BaseMutationOptions<BackwebUpdateConsultantMutation, BackwebUpdateConsultantMutationVariables>;
export const BackwebUpdateContactDocument = gql`
    mutation backwebUpdateContact($user: BackwebContactInput!, $token: String!) {
  backweb(token: $token) {
    updateContact(user: $user) {
      success
    }
  }
}
    `;
export type BackwebUpdateContactMutationFn = Apollo.MutationFunction<BackwebUpdateContactMutation, BackwebUpdateContactMutationVariables>;

/**
 * __useBackwebUpdateContactMutation__
 *
 * To run a mutation, you first call `useBackwebUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackwebUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backwebUpdateContactMutation, { data, loading, error }] = useBackwebUpdateContactMutation({
 *   variables: {
 *      user: // value for 'user'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBackwebUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<BackwebUpdateContactMutation, BackwebUpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackwebUpdateContactMutation, BackwebUpdateContactMutationVariables>(BackwebUpdateContactDocument, options);
      }
export type BackwebUpdateContactMutationHookResult = ReturnType<typeof useBackwebUpdateContactMutation>;
export type BackwebUpdateContactMutationResult = Apollo.MutationResult<BackwebUpdateContactMutation>;
export type BackwebUpdateContactMutationOptions = Apollo.BaseMutationOptions<BackwebUpdateContactMutation, BackwebUpdateContactMutationVariables>;
export const BackwebDeleteUserDocument = gql`
    mutation backwebDeleteUser($id: Int!, $token: String!) {
  backweb(token: $token) {
    deleteUser(id: $id) {
      success
    }
  }
}
    `;
export type BackwebDeleteUserMutationFn = Apollo.MutationFunction<BackwebDeleteUserMutation, BackwebDeleteUserMutationVariables>;

/**
 * __useBackwebDeleteUserMutation__
 *
 * To run a mutation, you first call `useBackwebDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackwebDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backwebDeleteUserMutation, { data, loading, error }] = useBackwebDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBackwebDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<BackwebDeleteUserMutation, BackwebDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackwebDeleteUserMutation, BackwebDeleteUserMutationVariables>(BackwebDeleteUserDocument, options);
      }
export type BackwebDeleteUserMutationHookResult = ReturnType<typeof useBackwebDeleteUserMutation>;
export type BackwebDeleteUserMutationResult = Apollo.MutationResult<BackwebDeleteUserMutation>;
export type BackwebDeleteUserMutationOptions = Apollo.BaseMutationOptions<BackwebDeleteUserMutation, BackwebDeleteUserMutationVariables>;
export const BackwebUpdateShippingMethodDocument = gql`
    mutation backwebUpdateShippingMethod($shippingMethod: BackwebShippingMethodInput!, $token: String!) {
  backweb(token: $token) {
    updateShippingMethod(shippingMethod: $shippingMethod) {
      success
    }
  }
}
    `;
export type BackwebUpdateShippingMethodMutationFn = Apollo.MutationFunction<BackwebUpdateShippingMethodMutation, BackwebUpdateShippingMethodMutationVariables>;

/**
 * __useBackwebUpdateShippingMethodMutation__
 *
 * To run a mutation, you first call `useBackwebUpdateShippingMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackwebUpdateShippingMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backwebUpdateShippingMethodMutation, { data, loading, error }] = useBackwebUpdateShippingMethodMutation({
 *   variables: {
 *      shippingMethod: // value for 'shippingMethod'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBackwebUpdateShippingMethodMutation(baseOptions?: Apollo.MutationHookOptions<BackwebUpdateShippingMethodMutation, BackwebUpdateShippingMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackwebUpdateShippingMethodMutation, BackwebUpdateShippingMethodMutationVariables>(BackwebUpdateShippingMethodDocument, options);
      }
export type BackwebUpdateShippingMethodMutationHookResult = ReturnType<typeof useBackwebUpdateShippingMethodMutation>;
export type BackwebUpdateShippingMethodMutationResult = Apollo.MutationResult<BackwebUpdateShippingMethodMutation>;
export type BackwebUpdateShippingMethodMutationOptions = Apollo.BaseMutationOptions<BackwebUpdateShippingMethodMutation, BackwebUpdateShippingMethodMutationVariables>;
export const BackwebUpdateAdminDocument = gql`
    mutation backwebUpdateAdmin($user: BackwebAdminInput!, $token: String!) {
  backweb(token: $token) {
    updateAdmin(user: $user) {
      success
    }
  }
}
    `;
export type BackwebUpdateAdminMutationFn = Apollo.MutationFunction<BackwebUpdateAdminMutation, BackwebUpdateAdminMutationVariables>;

/**
 * __useBackwebUpdateAdminMutation__
 *
 * To run a mutation, you first call `useBackwebUpdateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackwebUpdateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backwebUpdateAdminMutation, { data, loading, error }] = useBackwebUpdateAdminMutation({
 *   variables: {
 *      user: // value for 'user'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBackwebUpdateAdminMutation(baseOptions?: Apollo.MutationHookOptions<BackwebUpdateAdminMutation, BackwebUpdateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackwebUpdateAdminMutation, BackwebUpdateAdminMutationVariables>(BackwebUpdateAdminDocument, options);
      }
export type BackwebUpdateAdminMutationHookResult = ReturnType<typeof useBackwebUpdateAdminMutation>;
export type BackwebUpdateAdminMutationResult = Apollo.MutationResult<BackwebUpdateAdminMutation>;
export type BackwebUpdateAdminMutationOptions = Apollo.BaseMutationOptions<BackwebUpdateAdminMutation, BackwebUpdateAdminMutationVariables>;
export const BackwebCreateAdminDocument = gql`
    mutation backwebCreateAdmin($user: BackwebAdminInput!, $token: String!) {
  backweb(token: $token) {
    createAdmin(user: $user) {
      success
    }
  }
}
    `;
export type BackwebCreateAdminMutationFn = Apollo.MutationFunction<BackwebCreateAdminMutation, BackwebCreateAdminMutationVariables>;

/**
 * __useBackwebCreateAdminMutation__
 *
 * To run a mutation, you first call `useBackwebCreateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackwebCreateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backwebCreateAdminMutation, { data, loading, error }] = useBackwebCreateAdminMutation({
 *   variables: {
 *      user: // value for 'user'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBackwebCreateAdminMutation(baseOptions?: Apollo.MutationHookOptions<BackwebCreateAdminMutation, BackwebCreateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackwebCreateAdminMutation, BackwebCreateAdminMutationVariables>(BackwebCreateAdminDocument, options);
      }
export type BackwebCreateAdminMutationHookResult = ReturnType<typeof useBackwebCreateAdminMutation>;
export type BackwebCreateAdminMutationResult = Apollo.MutationResult<BackwebCreateAdminMutation>;
export type BackwebCreateAdminMutationOptions = Apollo.BaseMutationOptions<BackwebCreateAdminMutation, BackwebCreateAdminMutationVariables>;
export const BackwebUpdateAclRoleDocument = gql`
    mutation backwebUpdateAclRole($role: BackwebAclRoleInput!, $token: String!) {
  backweb(token: $token) {
    updateAclRole(role: $role) {
      success
    }
  }
}
    `;
export type BackwebUpdateAclRoleMutationFn = Apollo.MutationFunction<BackwebUpdateAclRoleMutation, BackwebUpdateAclRoleMutationVariables>;

/**
 * __useBackwebUpdateAclRoleMutation__
 *
 * To run a mutation, you first call `useBackwebUpdateAclRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackwebUpdateAclRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backwebUpdateAclRoleMutation, { data, loading, error }] = useBackwebUpdateAclRoleMutation({
 *   variables: {
 *      role: // value for 'role'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBackwebUpdateAclRoleMutation(baseOptions?: Apollo.MutationHookOptions<BackwebUpdateAclRoleMutation, BackwebUpdateAclRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackwebUpdateAclRoleMutation, BackwebUpdateAclRoleMutationVariables>(BackwebUpdateAclRoleDocument, options);
      }
export type BackwebUpdateAclRoleMutationHookResult = ReturnType<typeof useBackwebUpdateAclRoleMutation>;
export type BackwebUpdateAclRoleMutationResult = Apollo.MutationResult<BackwebUpdateAclRoleMutation>;
export type BackwebUpdateAclRoleMutationOptions = Apollo.BaseMutationOptions<BackwebUpdateAclRoleMutation, BackwebUpdateAclRoleMutationVariables>;
export const BackwebCreateAclRoleDocument = gql`
    mutation backwebCreateAclRole($role: BackwebAclRoleInput!, $token: String!) {
  backweb(token: $token) {
    createAclRole(role: $role) {
      success
    }
  }
}
    `;
export type BackwebCreateAclRoleMutationFn = Apollo.MutationFunction<BackwebCreateAclRoleMutation, BackwebCreateAclRoleMutationVariables>;

/**
 * __useBackwebCreateAclRoleMutation__
 *
 * To run a mutation, you first call `useBackwebCreateAclRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackwebCreateAclRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backwebCreateAclRoleMutation, { data, loading, error }] = useBackwebCreateAclRoleMutation({
 *   variables: {
 *      role: // value for 'role'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBackwebCreateAclRoleMutation(baseOptions?: Apollo.MutationHookOptions<BackwebCreateAclRoleMutation, BackwebCreateAclRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackwebCreateAclRoleMutation, BackwebCreateAclRoleMutationVariables>(BackwebCreateAclRoleDocument, options);
      }
export type BackwebCreateAclRoleMutationHookResult = ReturnType<typeof useBackwebCreateAclRoleMutation>;
export type BackwebCreateAclRoleMutationResult = Apollo.MutationResult<BackwebCreateAclRoleMutation>;
export type BackwebCreateAclRoleMutationOptions = Apollo.BaseMutationOptions<BackwebCreateAclRoleMutation, BackwebCreateAclRoleMutationVariables>;
export const BackwebDeleteAclRoleDocument = gql`
    mutation backwebDeleteAclRole($id: Int!, $token: String!) {
  backweb(token: $token) {
    deleteAclRole(id: $id) {
      success
    }
  }
}
    `;
export type BackwebDeleteAclRoleMutationFn = Apollo.MutationFunction<BackwebDeleteAclRoleMutation, BackwebDeleteAclRoleMutationVariables>;

/**
 * __useBackwebDeleteAclRoleMutation__
 *
 * To run a mutation, you first call `useBackwebDeleteAclRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackwebDeleteAclRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backwebDeleteAclRoleMutation, { data, loading, error }] = useBackwebDeleteAclRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBackwebDeleteAclRoleMutation(baseOptions?: Apollo.MutationHookOptions<BackwebDeleteAclRoleMutation, BackwebDeleteAclRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackwebDeleteAclRoleMutation, BackwebDeleteAclRoleMutationVariables>(BackwebDeleteAclRoleDocument, options);
      }
export type BackwebDeleteAclRoleMutationHookResult = ReturnType<typeof useBackwebDeleteAclRoleMutation>;
export type BackwebDeleteAclRoleMutationResult = Apollo.MutationResult<BackwebDeleteAclRoleMutation>;
export type BackwebDeleteAclRoleMutationOptions = Apollo.BaseMutationOptions<BackwebDeleteAclRoleMutation, BackwebDeleteAclRoleMutationVariables>;
export const UpdateConsultantSubmissionDocument = gql`
    mutation updateConsultantSubmission($token: String!, $data: BackwebConsultantSubmissionInput!) {
  backweb(token: $token) {
    updateConsultantSubmission(data: $data) {
      success
    }
  }
}
    `;
export type UpdateConsultantSubmissionMutationFn = Apollo.MutationFunction<UpdateConsultantSubmissionMutation, UpdateConsultantSubmissionMutationVariables>;

/**
 * __useUpdateConsultantSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateConsultantSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsultantSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsultantSubmissionMutation, { data, loading, error }] = useUpdateConsultantSubmissionMutation({
 *   variables: {
 *      token: // value for 'token'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateConsultantSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConsultantSubmissionMutation, UpdateConsultantSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConsultantSubmissionMutation, UpdateConsultantSubmissionMutationVariables>(UpdateConsultantSubmissionDocument, options);
      }
export type UpdateConsultantSubmissionMutationHookResult = ReturnType<typeof useUpdateConsultantSubmissionMutation>;
export type UpdateConsultantSubmissionMutationResult = Apollo.MutationResult<UpdateConsultantSubmissionMutation>;
export type UpdateConsultantSubmissionMutationOptions = Apollo.BaseMutationOptions<UpdateConsultantSubmissionMutation, UpdateConsultantSubmissionMutationVariables>;
export const DeleteConsultantSubmissionDocument = gql`
    mutation deleteConsultantSubmission($token: String!, $id: Int!) {
  backweb(token: $token) {
    deleteConsultantSubmission(id: $id) {
      success
    }
  }
}
    `;
export type DeleteConsultantSubmissionMutationFn = Apollo.MutationFunction<DeleteConsultantSubmissionMutation, DeleteConsultantSubmissionMutationVariables>;

/**
 * __useDeleteConsultantSubmissionMutation__
 *
 * To run a mutation, you first call `useDeleteConsultantSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConsultantSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConsultantSubmissionMutation, { data, loading, error }] = useDeleteConsultantSubmissionMutation({
 *   variables: {
 *      token: // value for 'token'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConsultantSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConsultantSubmissionMutation, DeleteConsultantSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConsultantSubmissionMutation, DeleteConsultantSubmissionMutationVariables>(DeleteConsultantSubmissionDocument, options);
      }
export type DeleteConsultantSubmissionMutationHookResult = ReturnType<typeof useDeleteConsultantSubmissionMutation>;
export type DeleteConsultantSubmissionMutationResult = Apollo.MutationResult<DeleteConsultantSubmissionMutation>;
export type DeleteConsultantSubmissionMutationOptions = Apollo.BaseMutationOptions<DeleteConsultantSubmissionMutation, DeleteConsultantSubmissionMutationVariables>;
export const SendReferAFriendMailDocument = gql`
    mutation sendReferAFriendMail($customerId: Int!) {
  sendReferAFriendMail(customerId: $customerId) {
    success
  }
}
    `;
export type SendReferAFriendMailMutationFn = Apollo.MutationFunction<SendReferAFriendMailMutation, SendReferAFriendMailMutationVariables>;

/**
 * __useSendReferAFriendMailMutation__
 *
 * To run a mutation, you first call `useSendReferAFriendMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReferAFriendMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReferAFriendMailMutation, { data, loading, error }] = useSendReferAFriendMailMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useSendReferAFriendMailMutation(baseOptions?: Apollo.MutationHookOptions<SendReferAFriendMailMutation, SendReferAFriendMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendReferAFriendMailMutation, SendReferAFriendMailMutationVariables>(SendReferAFriendMailDocument, options);
      }
export type SendReferAFriendMailMutationHookResult = ReturnType<typeof useSendReferAFriendMailMutation>;
export type SendReferAFriendMailMutationResult = Apollo.MutationResult<SendReferAFriendMailMutation>;
export type SendReferAFriendMailMutationOptions = Apollo.BaseMutationOptions<SendReferAFriendMailMutation, SendReferAFriendMailMutationVariables>;
export const SendEventParticipantInvitesDocument = gql`
    mutation sendEventParticipantInvites($eventId: Int!) {
  sendEventParticipantInvites(eventId: $eventId) {
    success
  }
}
    `;
export type SendEventParticipantInvitesMutationFn = Apollo.MutationFunction<SendEventParticipantInvitesMutation, SendEventParticipantInvitesMutationVariables>;

/**
 * __useSendEventParticipantInvitesMutation__
 *
 * To run a mutation, you first call `useSendEventParticipantInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEventParticipantInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEventParticipantInvitesMutation, { data, loading, error }] = useSendEventParticipantInvitesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useSendEventParticipantInvitesMutation(baseOptions?: Apollo.MutationHookOptions<SendEventParticipantInvitesMutation, SendEventParticipantInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEventParticipantInvitesMutation, SendEventParticipantInvitesMutationVariables>(SendEventParticipantInvitesDocument, options);
      }
export type SendEventParticipantInvitesMutationHookResult = ReturnType<typeof useSendEventParticipantInvitesMutation>;
export type SendEventParticipantInvitesMutationResult = Apollo.MutationResult<SendEventParticipantInvitesMutation>;
export type SendEventParticipantInvitesMutationOptions = Apollo.BaseMutationOptions<SendEventParticipantInvitesMutation, SendEventParticipantInvitesMutationVariables>;
export const SendMailDocument = gql`
    mutation sendMail($key: SendMailKeyEnum!, $options: SendMailOptionInput) {
  sendMail(key: $key, options: $options) {
    success
  }
}
    `;
export type SendMailMutationFn = Apollo.MutationFunction<SendMailMutation, SendMailMutationVariables>;

/**
 * __useSendMailMutation__
 *
 * To run a mutation, you first call `useSendMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMailMutation, { data, loading, error }] = useSendMailMutation({
 *   variables: {
 *      key: // value for 'key'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSendMailMutation(baseOptions?: Apollo.MutationHookOptions<SendMailMutation, SendMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMailMutation, SendMailMutationVariables>(SendMailDocument, options);
      }
export type SendMailMutationHookResult = ReturnType<typeof useSendMailMutation>;
export type SendMailMutationResult = Apollo.MutationResult<SendMailMutation>;
export type SendMailMutationOptions = Apollo.BaseMutationOptions<SendMailMutation, SendMailMutationVariables>;
export const CreateOrganisationCustomerPasswordDocument = gql`
    mutation createOrganisationCustomerPassword($password: String!, $hashType: String!, $hash: String!) {
  createOrganisationCustomerPassword(
    password: $password
    hashType: $hashType
    hash: $hash
  ) {
    success
  }
}
    `;
export type CreateOrganisationCustomerPasswordMutationFn = Apollo.MutationFunction<CreateOrganisationCustomerPasswordMutation, CreateOrganisationCustomerPasswordMutationVariables>;

/**
 * __useCreateOrganisationCustomerPasswordMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationCustomerPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationCustomerPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationCustomerPasswordMutation, { data, loading, error }] = useCreateOrganisationCustomerPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      hashType: // value for 'hashType'
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useCreateOrganisationCustomerPasswordMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationCustomerPasswordMutation, CreateOrganisationCustomerPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationCustomerPasswordMutation, CreateOrganisationCustomerPasswordMutationVariables>(CreateOrganisationCustomerPasswordDocument, options);
      }
export type CreateOrganisationCustomerPasswordMutationHookResult = ReturnType<typeof useCreateOrganisationCustomerPasswordMutation>;
export type CreateOrganisationCustomerPasswordMutationResult = Apollo.MutationResult<CreateOrganisationCustomerPasswordMutation>;
export type CreateOrganisationCustomerPasswordMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationCustomerPasswordMutation, CreateOrganisationCustomerPasswordMutationVariables>;
export const VerifyCustomerEmailDocument = gql`
    mutation verifyCustomerEmail($hash: String!) {
  verifyCustomerEmail(hash: $hash) {
    success
  }
}
    `;
export type VerifyCustomerEmailMutationFn = Apollo.MutationFunction<VerifyCustomerEmailMutation, VerifyCustomerEmailMutationVariables>;

/**
 * __useVerifyCustomerEmailMutation__
 *
 * To run a mutation, you first call `useVerifyCustomerEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCustomerEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCustomerEmailMutation, { data, loading, error }] = useVerifyCustomerEmailMutation({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useVerifyCustomerEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCustomerEmailMutation, VerifyCustomerEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCustomerEmailMutation, VerifyCustomerEmailMutationVariables>(VerifyCustomerEmailDocument, options);
      }
export type VerifyCustomerEmailMutationHookResult = ReturnType<typeof useVerifyCustomerEmailMutation>;
export type VerifyCustomerEmailMutationResult = Apollo.MutationResult<VerifyCustomerEmailMutation>;
export type VerifyCustomerEmailMutationOptions = Apollo.BaseMutationOptions<VerifyCustomerEmailMutation, VerifyCustomerEmailMutationVariables>;
export const UpdateOrganisationOrderDocument = gql`
    mutation updateOrganisationOrder($order: UpdateOrganisationOrderInput!) {
  updateOrganisationOrder(order: $order) {
    success
  }
}
    `;
export type UpdateOrganisationOrderMutationFn = Apollo.MutationFunction<UpdateOrganisationOrderMutation, UpdateOrganisationOrderMutationVariables>;

/**
 * __useUpdateOrganisationOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrganisationOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganisationOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganisationOrderMutation, { data, loading, error }] = useUpdateOrganisationOrderMutation({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUpdateOrganisationOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganisationOrderMutation, UpdateOrganisationOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganisationOrderMutation, UpdateOrganisationOrderMutationVariables>(UpdateOrganisationOrderDocument, options);
      }
export type UpdateOrganisationOrderMutationHookResult = ReturnType<typeof useUpdateOrganisationOrderMutation>;
export type UpdateOrganisationOrderMutationResult = Apollo.MutationResult<UpdateOrganisationOrderMutation>;
export type UpdateOrganisationOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrganisationOrderMutation, UpdateOrganisationOrderMutationVariables>;
export const DeleteOrganisationOrderCommentDocument = gql`
    mutation deleteOrganisationOrderComment($comment_id: Int!) {
  deleteOrganisationOrderComment(comment_id: $comment_id) {
    success
  }
}
    `;
export type DeleteOrganisationOrderCommentMutationFn = Apollo.MutationFunction<DeleteOrganisationOrderCommentMutation, DeleteOrganisationOrderCommentMutationVariables>;

/**
 * __useDeleteOrganisationOrderCommentMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationOrderCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationOrderCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationOrderCommentMutation, { data, loading, error }] = useDeleteOrganisationOrderCommentMutation({
 *   variables: {
 *      comment_id: // value for 'comment_id'
 *   },
 * });
 */
export function useDeleteOrganisationOrderCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationOrderCommentMutation, DeleteOrganisationOrderCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationOrderCommentMutation, DeleteOrganisationOrderCommentMutationVariables>(DeleteOrganisationOrderCommentDocument, options);
      }
export type DeleteOrganisationOrderCommentMutationHookResult = ReturnType<typeof useDeleteOrganisationOrderCommentMutation>;
export type DeleteOrganisationOrderCommentMutationResult = Apollo.MutationResult<DeleteOrganisationOrderCommentMutation>;
export type DeleteOrganisationOrderCommentMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationOrderCommentMutation, DeleteOrganisationOrderCommentMutationVariables>;
export const CreateOrganisationOrderCommentDocument = gql`
    mutation createOrganisationOrderComment($comment: OrganisationOrderCommentInput!) {
  createOrganisationOrderComment(comment: $comment) {
    success
  }
}
    `;
export type CreateOrganisationOrderCommentMutationFn = Apollo.MutationFunction<CreateOrganisationOrderCommentMutation, CreateOrganisationOrderCommentMutationVariables>;

/**
 * __useCreateOrganisationOrderCommentMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationOrderCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationOrderCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationOrderCommentMutation, { data, loading, error }] = useCreateOrganisationOrderCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateOrganisationOrderCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationOrderCommentMutation, CreateOrganisationOrderCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationOrderCommentMutation, CreateOrganisationOrderCommentMutationVariables>(CreateOrganisationOrderCommentDocument, options);
      }
export type CreateOrganisationOrderCommentMutationHookResult = ReturnType<typeof useCreateOrganisationOrderCommentMutation>;
export type CreateOrganisationOrderCommentMutationResult = Apollo.MutationResult<CreateOrganisationOrderCommentMutation>;
export type CreateOrganisationOrderCommentMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationOrderCommentMutation, CreateOrganisationOrderCommentMutationVariables>;
export const CreateOrganisationOrderDocument = gql`
    mutation createOrganisationOrder($order: OrganisationOrderInput!) {
  createOrganisationOrder(order: $order) {
    success
  }
}
    `;
export type CreateOrganisationOrderMutationFn = Apollo.MutationFunction<CreateOrganisationOrderMutation, CreateOrganisationOrderMutationVariables>;

/**
 * __useCreateOrganisationOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationOrderMutation, { data, loading, error }] = useCreateOrganisationOrderMutation({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCreateOrganisationOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationOrderMutation, CreateOrganisationOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationOrderMutation, CreateOrganisationOrderMutationVariables>(CreateOrganisationOrderDocument, options);
      }
export type CreateOrganisationOrderMutationHookResult = ReturnType<typeof useCreateOrganisationOrderMutation>;
export type CreateOrganisationOrderMutationResult = Apollo.MutationResult<CreateOrganisationOrderMutation>;
export type CreateOrganisationOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationOrderMutation, CreateOrganisationOrderMutationVariables>;
export const SendOrganisationEmailDocument = gql`
    mutation sendOrganisationEmail($organisationMailInput: OrganisationMailInput!) {
  sendOrganisationEmail(organisationMailInput: $organisationMailInput) {
    items
  }
}
    `;
export type SendOrganisationEmailMutationFn = Apollo.MutationFunction<SendOrganisationEmailMutation, SendOrganisationEmailMutationVariables>;

/**
 * __useSendOrganisationEmailMutation__
 *
 * To run a mutation, you first call `useSendOrganisationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOrganisationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOrganisationEmailMutation, { data, loading, error }] = useSendOrganisationEmailMutation({
 *   variables: {
 *      organisationMailInput: // value for 'organisationMailInput'
 *   },
 * });
 */
export function useSendOrganisationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendOrganisationEmailMutation, SendOrganisationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOrganisationEmailMutation, SendOrganisationEmailMutationVariables>(SendOrganisationEmailDocument, options);
      }
export type SendOrganisationEmailMutationHookResult = ReturnType<typeof useSendOrganisationEmailMutation>;
export type SendOrganisationEmailMutationResult = Apollo.MutationResult<SendOrganisationEmailMutation>;
export type SendOrganisationEmailMutationOptions = Apollo.BaseMutationOptions<SendOrganisationEmailMutation, SendOrganisationEmailMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation updateCustomer($customer: UpdateCustomerInput!) {
  updateCustomer(customer: $customer) {
    user {
      id
      email
      date_of_birth
      locale
      newsletter
      billing_address {
        id
        email
        mobile
        phone_number
        co
        address
        postal_code
        city
        country_code
      }
      customer_organisation_relation {
        user_id
        organisation_id
        active
        vip
        communication_consultant
        career_interest
        class_interest
      }
    }
    token
  }
}
    `;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const UpdateConsultantProductSettingsDocument = gql`
    mutation updateConsultantProductSettings($productSettings: ConsultantProductSettingsInput!) {
  updateConsultantProductSettings(productSettings: $productSettings) {
    organisation_id
    product_id
    base_price
    special_price
    special_price_from
    special_price_to
    todays_offer_price
    todays_offer_price_from
    todays_offer_price_to
    todays_offer_product_is_active
    product_is_active_central_control
  }
}
    `;
export type UpdateConsultantProductSettingsMutationFn = Apollo.MutationFunction<UpdateConsultantProductSettingsMutation, UpdateConsultantProductSettingsMutationVariables>;

/**
 * __useUpdateConsultantProductSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateConsultantProductSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsultantProductSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsultantProductSettingsMutation, { data, loading, error }] = useUpdateConsultantProductSettingsMutation({
 *   variables: {
 *      productSettings: // value for 'productSettings'
 *   },
 * });
 */
export function useUpdateConsultantProductSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConsultantProductSettingsMutation, UpdateConsultantProductSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConsultantProductSettingsMutation, UpdateConsultantProductSettingsMutationVariables>(UpdateConsultantProductSettingsDocument, options);
      }
export type UpdateConsultantProductSettingsMutationHookResult = ReturnType<typeof useUpdateConsultantProductSettingsMutation>;
export type UpdateConsultantProductSettingsMutationResult = Apollo.MutationResult<UpdateConsultantProductSettingsMutation>;
export type UpdateConsultantProductSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateConsultantProductSettingsMutation, UpdateConsultantProductSettingsMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation createCustomer($customer: CustomerInput!) {
  createCustomer(customer: $customer) {
    success
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const UpdateCustomerOrganisationRelationDocument = gql`
    mutation updateCustomerOrganisationRelation($relationInput: CustomerOrganisationRelationInput!) {
  updateCustomerOrganisationRelation(relationInput: $relationInput) {
    success
  }
}
    `;
export type UpdateCustomerOrganisationRelationMutationFn = Apollo.MutationFunction<UpdateCustomerOrganisationRelationMutation, UpdateCustomerOrganisationRelationMutationVariables>;

/**
 * __useUpdateCustomerOrganisationRelationMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerOrganisationRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerOrganisationRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerOrganisationRelationMutation, { data, loading, error }] = useUpdateCustomerOrganisationRelationMutation({
 *   variables: {
 *      relationInput: // value for 'relationInput'
 *   },
 * });
 */
export function useUpdateCustomerOrganisationRelationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerOrganisationRelationMutation, UpdateCustomerOrganisationRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerOrganisationRelationMutation, UpdateCustomerOrganisationRelationMutationVariables>(UpdateCustomerOrganisationRelationDocument, options);
      }
export type UpdateCustomerOrganisationRelationMutationHookResult = ReturnType<typeof useUpdateCustomerOrganisationRelationMutation>;
export type UpdateCustomerOrganisationRelationMutationResult = Apollo.MutationResult<UpdateCustomerOrganisationRelationMutation>;
export type UpdateCustomerOrganisationRelationMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerOrganisationRelationMutation, UpdateCustomerOrganisationRelationMutationVariables>;
export const DeleteCustomerOrganisationRelationDocument = gql`
    mutation deleteCustomerOrganisationRelation($relationInput: CustomerOrganisationRelationDeleteInput!) {
  deleteCustomerOrganisationRelation(relationInput: $relationInput) {
    success
  }
}
    `;
export type DeleteCustomerOrganisationRelationMutationFn = Apollo.MutationFunction<DeleteCustomerOrganisationRelationMutation, DeleteCustomerOrganisationRelationMutationVariables>;

/**
 * __useDeleteCustomerOrganisationRelationMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerOrganisationRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerOrganisationRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerOrganisationRelationMutation, { data, loading, error }] = useDeleteCustomerOrganisationRelationMutation({
 *   variables: {
 *      relationInput: // value for 'relationInput'
 *   },
 * });
 */
export function useDeleteCustomerOrganisationRelationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerOrganisationRelationMutation, DeleteCustomerOrganisationRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerOrganisationRelationMutation, DeleteCustomerOrganisationRelationMutationVariables>(DeleteCustomerOrganisationRelationDocument, options);
      }
export type DeleteCustomerOrganisationRelationMutationHookResult = ReturnType<typeof useDeleteCustomerOrganisationRelationMutation>;
export type DeleteCustomerOrganisationRelationMutationResult = Apollo.MutationResult<DeleteCustomerOrganisationRelationMutation>;
export type DeleteCustomerOrganisationRelationMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerOrganisationRelationMutation, DeleteCustomerOrganisationRelationMutationVariables>;
export const UpdateOrganisationSettingsDocument = gql`
    mutation updateOrganisationSettings($organisationSettings: OrganisationSettingsInput!) {
  updateOrganisationSettings(settings: $organisationSettings) {
    email
    mobile
    telephone
    facebook_url
    website_url
    presentation
    favourite_quote
    availability
    billing_invoicing_method
    billing_payment_method
    billing_account_number
    billing_active
    billing_org_number
    company_name
    billing_phone_number
    show_vat_on_invoice
  }
}
    `;
export type UpdateOrganisationSettingsMutationFn = Apollo.MutationFunction<UpdateOrganisationSettingsMutation, UpdateOrganisationSettingsMutationVariables>;

/**
 * __useUpdateOrganisationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganisationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganisationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganisationSettingsMutation, { data, loading, error }] = useUpdateOrganisationSettingsMutation({
 *   variables: {
 *      organisationSettings: // value for 'organisationSettings'
 *   },
 * });
 */
export function useUpdateOrganisationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganisationSettingsMutation, UpdateOrganisationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganisationSettingsMutation, UpdateOrganisationSettingsMutationVariables>(UpdateOrganisationSettingsDocument, options);
      }
export type UpdateOrganisationSettingsMutationHookResult = ReturnType<typeof useUpdateOrganisationSettingsMutation>;
export type UpdateOrganisationSettingsMutationResult = Apollo.MutationResult<UpdateOrganisationSettingsMutation>;
export type UpdateOrganisationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganisationSettingsMutation, UpdateOrganisationSettingsMutationVariables>;
export const CreateOrganisationCustomerCommentDocument = gql`
    mutation createOrganisationCustomerComment($comment: OrganisationCustomerCommentInput!) {
  createOrganisationCustomerComment(comment: $comment) {
    success
  }
}
    `;
export type CreateOrganisationCustomerCommentMutationFn = Apollo.MutationFunction<CreateOrganisationCustomerCommentMutation, CreateOrganisationCustomerCommentMutationVariables>;

/**
 * __useCreateOrganisationCustomerCommentMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationCustomerCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationCustomerCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationCustomerCommentMutation, { data, loading, error }] = useCreateOrganisationCustomerCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateOrganisationCustomerCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationCustomerCommentMutation, CreateOrganisationCustomerCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationCustomerCommentMutation, CreateOrganisationCustomerCommentMutationVariables>(CreateOrganisationCustomerCommentDocument, options);
      }
export type CreateOrganisationCustomerCommentMutationHookResult = ReturnType<typeof useCreateOrganisationCustomerCommentMutation>;
export type CreateOrganisationCustomerCommentMutationResult = Apollo.MutationResult<CreateOrganisationCustomerCommentMutation>;
export type CreateOrganisationCustomerCommentMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationCustomerCommentMutation, CreateOrganisationCustomerCommentMutationVariables>;
export const DeleteOrganisationCustomerCommentDocument = gql`
    mutation deleteOrganisationCustomerComment($comment_id: Int!) {
  deleteOrganisationCustomerComment(comment_id: $comment_id) {
    success
  }
}
    `;
export type DeleteOrganisationCustomerCommentMutationFn = Apollo.MutationFunction<DeleteOrganisationCustomerCommentMutation, DeleteOrganisationCustomerCommentMutationVariables>;

/**
 * __useDeleteOrganisationCustomerCommentMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationCustomerCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationCustomerCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationCustomerCommentMutation, { data, loading, error }] = useDeleteOrganisationCustomerCommentMutation({
 *   variables: {
 *      comment_id: // value for 'comment_id'
 *   },
 * });
 */
export function useDeleteOrganisationCustomerCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationCustomerCommentMutation, DeleteOrganisationCustomerCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationCustomerCommentMutation, DeleteOrganisationCustomerCommentMutationVariables>(DeleteOrganisationCustomerCommentDocument, options);
      }
export type DeleteOrganisationCustomerCommentMutationHookResult = ReturnType<typeof useDeleteOrganisationCustomerCommentMutation>;
export type DeleteOrganisationCustomerCommentMutationResult = Apollo.MutationResult<DeleteOrganisationCustomerCommentMutation>;
export type DeleteOrganisationCustomerCommentMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationCustomerCommentMutation, DeleteOrganisationCustomerCommentMutationVariables>;
export const UpdateEventDocument = gql`
    mutation updateEvent($event: EventInput!) {
  updateEvent(event: $event) {
    success
  }
}
    `;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const DeleteEventDocument = gql`
    mutation deleteEvent($event: EventInput!) {
  deleteEvent(event: $event) {
    success
  }
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const CreateEventDocument = gql`
    mutation createEvent($event: EventInput!) {
  createEvent(event: $event) {
    success
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($contact: ContactInput!) {
  createContact(contact: $contact) {
    success
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateOrganisationInvoicePaymentStatusDocument = gql`
    mutation updateOrganisationInvoicePaymentStatus($invoiceId: Int!, $paymentStatus: String!) {
  updateOrganisationInvoiceMutation(
    invoiceId: $invoiceId
    paymentStatus: $paymentStatus
  ) {
    success
  }
}
    `;
export type UpdateOrganisationInvoicePaymentStatusMutationFn = Apollo.MutationFunction<UpdateOrganisationInvoicePaymentStatusMutation, UpdateOrganisationInvoicePaymentStatusMutationVariables>;

/**
 * __useUpdateOrganisationInvoicePaymentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrganisationInvoicePaymentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganisationInvoicePaymentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganisationInvoicePaymentStatusMutation, { data, loading, error }] = useUpdateOrganisationInvoicePaymentStatusMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      paymentStatus: // value for 'paymentStatus'
 *   },
 * });
 */
export function useUpdateOrganisationInvoicePaymentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganisationInvoicePaymentStatusMutation, UpdateOrganisationInvoicePaymentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganisationInvoicePaymentStatusMutation, UpdateOrganisationInvoicePaymentStatusMutationVariables>(UpdateOrganisationInvoicePaymentStatusDocument, options);
      }
export type UpdateOrganisationInvoicePaymentStatusMutationHookResult = ReturnType<typeof useUpdateOrganisationInvoicePaymentStatusMutation>;
export type UpdateOrganisationInvoicePaymentStatusMutationResult = Apollo.MutationResult<UpdateOrganisationInvoicePaymentStatusMutation>;
export type UpdateOrganisationInvoicePaymentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrganisationInvoicePaymentStatusMutation, UpdateOrganisationInvoicePaymentStatusMutationVariables>;
export const CreateOrganisationInvoiceFromOrderDocument = gql`
    mutation createOrganisationInvoiceFromOrder($orderId: Int!, $paymentTermsDays: Int!) {
  createOrganisationInvoiceFromOrder(
    order_id: $orderId
    payment_terms_days: $paymentTermsDays
  ) {
    success
  }
}
    `;
export type CreateOrganisationInvoiceFromOrderMutationFn = Apollo.MutationFunction<CreateOrganisationInvoiceFromOrderMutation, CreateOrganisationInvoiceFromOrderMutationVariables>;

/**
 * __useCreateOrganisationInvoiceFromOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationInvoiceFromOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationInvoiceFromOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationInvoiceFromOrderMutation, { data, loading, error }] = useCreateOrganisationInvoiceFromOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      paymentTermsDays: // value for 'paymentTermsDays'
 *   },
 * });
 */
export function useCreateOrganisationInvoiceFromOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationInvoiceFromOrderMutation, CreateOrganisationInvoiceFromOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationInvoiceFromOrderMutation, CreateOrganisationInvoiceFromOrderMutationVariables>(CreateOrganisationInvoiceFromOrderDocument, options);
      }
export type CreateOrganisationInvoiceFromOrderMutationHookResult = ReturnType<typeof useCreateOrganisationInvoiceFromOrderMutation>;
export type CreateOrganisationInvoiceFromOrderMutationResult = Apollo.MutationResult<CreateOrganisationInvoiceFromOrderMutation>;
export type CreateOrganisationInvoiceFromOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationInvoiceFromOrderMutation, CreateOrganisationInvoiceFromOrderMutationVariables>;
export const SendOrganisationInvoiceEmailDocument = gql`
    mutation sendOrganisationInvoiceEmail($invoice_id: Int!, $use_company_name: Boolean) {
  sendOrganisationInvoiceEmail(
    invoice_id: $invoice_id
    use_company_name: $use_company_name
  ) {
    success
  }
}
    `;
export type SendOrganisationInvoiceEmailMutationFn = Apollo.MutationFunction<SendOrganisationInvoiceEmailMutation, SendOrganisationInvoiceEmailMutationVariables>;

/**
 * __useSendOrganisationInvoiceEmailMutation__
 *
 * To run a mutation, you first call `useSendOrganisationInvoiceEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOrganisationInvoiceEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOrganisationInvoiceEmailMutation, { data, loading, error }] = useSendOrganisationInvoiceEmailMutation({
 *   variables: {
 *      invoice_id: // value for 'invoice_id'
 *      use_company_name: // value for 'use_company_name'
 *   },
 * });
 */
export function useSendOrganisationInvoiceEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendOrganisationInvoiceEmailMutation, SendOrganisationInvoiceEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOrganisationInvoiceEmailMutation, SendOrganisationInvoiceEmailMutationVariables>(SendOrganisationInvoiceEmailDocument, options);
      }
export type SendOrganisationInvoiceEmailMutationHookResult = ReturnType<typeof useSendOrganisationInvoiceEmailMutation>;
export type SendOrganisationInvoiceEmailMutationResult = Apollo.MutationResult<SendOrganisationInvoiceEmailMutation>;
export type SendOrganisationInvoiceEmailMutationOptions = Apollo.BaseMutationOptions<SendOrganisationInvoiceEmailMutation, SendOrganisationInvoiceEmailMutationVariables>;
export const SendGuestInvitesAsHostessEmailDocument = gql`
    mutation sendGuestInvitesAsHostessEmail($eventHash: String!) {
  sendGuestInvitesAsHostessEmail(eventHash: $eventHash) {
    success
  }
}
    `;
export type SendGuestInvitesAsHostessEmailMutationFn = Apollo.MutationFunction<SendGuestInvitesAsHostessEmailMutation, SendGuestInvitesAsHostessEmailMutationVariables>;

/**
 * __useSendGuestInvitesAsHostessEmailMutation__
 *
 * To run a mutation, you first call `useSendGuestInvitesAsHostessEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGuestInvitesAsHostessEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGuestInvitesAsHostessEmailMutation, { data, loading, error }] = useSendGuestInvitesAsHostessEmailMutation({
 *   variables: {
 *      eventHash: // value for 'eventHash'
 *   },
 * });
 */
export function useSendGuestInvitesAsHostessEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendGuestInvitesAsHostessEmailMutation, SendGuestInvitesAsHostessEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendGuestInvitesAsHostessEmailMutation, SendGuestInvitesAsHostessEmailMutationVariables>(SendGuestInvitesAsHostessEmailDocument, options);
      }
export type SendGuestInvitesAsHostessEmailMutationHookResult = ReturnType<typeof useSendGuestInvitesAsHostessEmailMutation>;
export type SendGuestInvitesAsHostessEmailMutationResult = Apollo.MutationResult<SendGuestInvitesAsHostessEmailMutation>;
export type SendGuestInvitesAsHostessEmailMutationOptions = Apollo.BaseMutationOptions<SendGuestInvitesAsHostessEmailMutation, SendGuestInvitesAsHostessEmailMutationVariables>;
export const UpdateEventForHostessDocument = gql`
    mutation updateEventForHostess($event: EventForHostessInput!) {
  updateEventForHostess(event: $event) {
    success
  }
}
    `;
export type UpdateEventForHostessMutationFn = Apollo.MutationFunction<UpdateEventForHostessMutation, UpdateEventForHostessMutationVariables>;

/**
 * __useUpdateEventForHostessMutation__
 *
 * To run a mutation, you first call `useUpdateEventForHostessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventForHostessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventForHostessMutation, { data, loading, error }] = useUpdateEventForHostessMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useUpdateEventForHostessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventForHostessMutation, UpdateEventForHostessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventForHostessMutation, UpdateEventForHostessMutationVariables>(UpdateEventForHostessDocument, options);
      }
export type UpdateEventForHostessMutationHookResult = ReturnType<typeof useUpdateEventForHostessMutation>;
export type UpdateEventForHostessMutationResult = Apollo.MutationResult<UpdateEventForHostessMutation>;
export type UpdateEventForHostessMutationOptions = Apollo.BaseMutationOptions<UpdateEventForHostessMutation, UpdateEventForHostessMutationVariables>;
export const ParticipantAcceptEventInvitationDocument = gql`
    mutation participantAcceptEventInvitation($hash: String!) {
  participantAcceptEventInvitation(hash: $hash) {
    id
    event_type
    name
    location
    starts_at
    ends_at
  }
}
    `;
export type ParticipantAcceptEventInvitationMutationFn = Apollo.MutationFunction<ParticipantAcceptEventInvitationMutation, ParticipantAcceptEventInvitationMutationVariables>;

/**
 * __useParticipantAcceptEventInvitationMutation__
 *
 * To run a mutation, you first call `useParticipantAcceptEventInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParticipantAcceptEventInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [participantAcceptEventInvitationMutation, { data, loading, error }] = useParticipantAcceptEventInvitationMutation({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useParticipantAcceptEventInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ParticipantAcceptEventInvitationMutation, ParticipantAcceptEventInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParticipantAcceptEventInvitationMutation, ParticipantAcceptEventInvitationMutationVariables>(ParticipantAcceptEventInvitationDocument, options);
      }
export type ParticipantAcceptEventInvitationMutationHookResult = ReturnType<typeof useParticipantAcceptEventInvitationMutation>;
export type ParticipantAcceptEventInvitationMutationResult = Apollo.MutationResult<ParticipantAcceptEventInvitationMutation>;
export type ParticipantAcceptEventInvitationMutationOptions = Apollo.BaseMutationOptions<ParticipantAcceptEventInvitationMutation, ParticipantAcceptEventInvitationMutationVariables>;
export const RequestOrganisationCustomerPasswordResetEmailDocument = gql`
    mutation requestOrganisationCustomerPasswordResetEmail($email: String!) {
  requestOrganisationCustomerPasswordResetEmail(email: $email) {
    success
  }
}
    `;
export type RequestOrganisationCustomerPasswordResetEmailMutationFn = Apollo.MutationFunction<RequestOrganisationCustomerPasswordResetEmailMutation, RequestOrganisationCustomerPasswordResetEmailMutationVariables>;

/**
 * __useRequestOrganisationCustomerPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useRequestOrganisationCustomerPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOrganisationCustomerPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOrganisationCustomerPasswordResetEmailMutation, { data, loading, error }] = useRequestOrganisationCustomerPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestOrganisationCustomerPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<RequestOrganisationCustomerPasswordResetEmailMutation, RequestOrganisationCustomerPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestOrganisationCustomerPasswordResetEmailMutation, RequestOrganisationCustomerPasswordResetEmailMutationVariables>(RequestOrganisationCustomerPasswordResetEmailDocument, options);
      }
export type RequestOrganisationCustomerPasswordResetEmailMutationHookResult = ReturnType<typeof useRequestOrganisationCustomerPasswordResetEmailMutation>;
export type RequestOrganisationCustomerPasswordResetEmailMutationResult = Apollo.MutationResult<RequestOrganisationCustomerPasswordResetEmailMutation>;
export type RequestOrganisationCustomerPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<RequestOrganisationCustomerPasswordResetEmailMutation, RequestOrganisationCustomerPasswordResetEmailMutationVariables>;
export const CreateCustomerOrganisationOrderDocument = gql`
    mutation createCustomerOrganisationOrder($order: CustomerOrganisationOrderInput!) {
  createCustomerOrganisationOrder(order: $order) {
    success
  }
}
    `;
export type CreateCustomerOrganisationOrderMutationFn = Apollo.MutationFunction<CreateCustomerOrganisationOrderMutation, CreateCustomerOrganisationOrderMutationVariables>;

/**
 * __useCreateCustomerOrganisationOrderMutation__
 *
 * To run a mutation, you first call `useCreateCustomerOrganisationOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerOrganisationOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerOrganisationOrderMutation, { data, loading, error }] = useCreateCustomerOrganisationOrderMutation({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCreateCustomerOrganisationOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerOrganisationOrderMutation, CreateCustomerOrganisationOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerOrganisationOrderMutation, CreateCustomerOrganisationOrderMutationVariables>(CreateCustomerOrganisationOrderDocument, options);
      }
export type CreateCustomerOrganisationOrderMutationHookResult = ReturnType<typeof useCreateCustomerOrganisationOrderMutation>;
export type CreateCustomerOrganisationOrderMutationResult = Apollo.MutationResult<CreateCustomerOrganisationOrderMutation>;
export type CreateCustomerOrganisationOrderMutationOptions = Apollo.BaseMutationOptions<CreateCustomerOrganisationOrderMutation, CreateCustomerOrganisationOrderMutationVariables>;
export const CreateOrUpdateBundledProductDocument = gql`
    mutation createOrUpdateBundledProduct($bundle: BundledProductInput!) {
  createOrUpdateBundledProduct(bundle: $bundle) {
    id
  }
}
    `;
export type CreateOrUpdateBundledProductMutationFn = Apollo.MutationFunction<CreateOrUpdateBundledProductMutation, CreateOrUpdateBundledProductMutationVariables>;

/**
 * __useCreateOrUpdateBundledProductMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBundledProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBundledProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBundledProductMutation, { data, loading, error }] = useCreateOrUpdateBundledProductMutation({
 *   variables: {
 *      bundle: // value for 'bundle'
 *   },
 * });
 */
export function useCreateOrUpdateBundledProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBundledProductMutation, CreateOrUpdateBundledProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBundledProductMutation, CreateOrUpdateBundledProductMutationVariables>(CreateOrUpdateBundledProductDocument, options);
      }
export type CreateOrUpdateBundledProductMutationHookResult = ReturnType<typeof useCreateOrUpdateBundledProductMutation>;
export type CreateOrUpdateBundledProductMutationResult = Apollo.MutationResult<CreateOrUpdateBundledProductMutation>;
export type CreateOrUpdateBundledProductMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBundledProductMutation, CreateOrUpdateBundledProductMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($user: CustomerInput!) {
  createCustomer(customer: $user) {
    success
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateSelfRegisterCustomerDocument = gql`
    mutation createSelfRegisterCustomer($user: SelfRegisterCustomerInput!, $consultantId: Int!) {
  createSelfRegisterCustomer(user: $user, consultantId: $consultantId) {
    success
  }
}
    `;
export type CreateSelfRegisterCustomerMutationFn = Apollo.MutationFunction<CreateSelfRegisterCustomerMutation, CreateSelfRegisterCustomerMutationVariables>;

/**
 * __useCreateSelfRegisterCustomerMutation__
 *
 * To run a mutation, you first call `useCreateSelfRegisterCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSelfRegisterCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSelfRegisterCustomerMutation, { data, loading, error }] = useCreateSelfRegisterCustomerMutation({
 *   variables: {
 *      user: // value for 'user'
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useCreateSelfRegisterCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateSelfRegisterCustomerMutation, CreateSelfRegisterCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSelfRegisterCustomerMutation, CreateSelfRegisterCustomerMutationVariables>(CreateSelfRegisterCustomerDocument, options);
      }
export type CreateSelfRegisterCustomerMutationHookResult = ReturnType<typeof useCreateSelfRegisterCustomerMutation>;
export type CreateSelfRegisterCustomerMutationResult = Apollo.MutationResult<CreateSelfRegisterCustomerMutation>;
export type CreateSelfRegisterCustomerMutationOptions = Apollo.BaseMutationOptions<CreateSelfRegisterCustomerMutation, CreateSelfRegisterCustomerMutationVariables>;
export const CreateShopperDocument = gql`
    mutation createShopper($user: ShopperRegisterInput!) {
  createShopper(user: $user) {
    success
  }
}
    `;
export type CreateShopperMutationFn = Apollo.MutationFunction<CreateShopperMutation, CreateShopperMutationVariables>;

/**
 * __useCreateShopperMutation__
 *
 * To run a mutation, you first call `useCreateShopperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShopperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShopperMutation, { data, loading, error }] = useCreateShopperMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateShopperMutation(baseOptions?: Apollo.MutationHookOptions<CreateShopperMutation, CreateShopperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShopperMutation, CreateShopperMutationVariables>(CreateShopperDocument, options);
      }
export type CreateShopperMutationHookResult = ReturnType<typeof useCreateShopperMutation>;
export type CreateShopperMutationResult = Apollo.MutationResult<CreateShopperMutation>;
export type CreateShopperMutationOptions = Apollo.BaseMutationOptions<CreateShopperMutation, CreateShopperMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($user: UpdateCustomerInput!) {
  updateCustomer(customer: $user) {
    user {
      id
      name
      email
      date_of_birth
      locale
      login_provider
      newsletter
      user_type
      fullName
      created_at
      updated_at
      billing_address {
        id
        type
        phone_number
        address
        postal_code
        city
        country_code
        email
        first_name
        last_name
      }
    }
    token
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const AddFavouriteDocument = gql`
    mutation addFavourite($productId: Int!) {
  addFavourite(productId: $productId) {
    success
  }
}
    `;
export type AddFavouriteMutationFn = Apollo.MutationFunction<AddFavouriteMutation, AddFavouriteMutationVariables>;

/**
 * __useAddFavouriteMutation__
 *
 * To run a mutation, you first call `useAddFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavouriteMutation, { data, loading, error }] = useAddFavouriteMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useAddFavouriteMutation(baseOptions?: Apollo.MutationHookOptions<AddFavouriteMutation, AddFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFavouriteMutation, AddFavouriteMutationVariables>(AddFavouriteDocument, options);
      }
export type AddFavouriteMutationHookResult = ReturnType<typeof useAddFavouriteMutation>;
export type AddFavouriteMutationResult = Apollo.MutationResult<AddFavouriteMutation>;
export type AddFavouriteMutationOptions = Apollo.BaseMutationOptions<AddFavouriteMutation, AddFavouriteMutationVariables>;
export const RemoveFavouriteDocument = gql`
    mutation removeFavourite($productId: Int!) {
  removeFavourite(productId: $productId) {
    success
  }
}
    `;
export type RemoveFavouriteMutationFn = Apollo.MutationFunction<RemoveFavouriteMutation, RemoveFavouriteMutationVariables>;

/**
 * __useRemoveFavouriteMutation__
 *
 * To run a mutation, you first call `useRemoveFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavouriteMutation, { data, loading, error }] = useRemoveFavouriteMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useRemoveFavouriteMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFavouriteMutation, RemoveFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFavouriteMutation, RemoveFavouriteMutationVariables>(RemoveFavouriteDocument, options);
      }
export type RemoveFavouriteMutationHookResult = ReturnType<typeof useRemoveFavouriteMutation>;
export type RemoveFavouriteMutationResult = Apollo.MutationResult<RemoveFavouriteMutation>;
export type RemoveFavouriteMutationOptions = Apollo.BaseMutationOptions<RemoveFavouriteMutation, RemoveFavouriteMutationVariables>;
export const SaveToCartDocument = gql`
    mutation saveToCart($market: String!, $item: CartItemInput!) {
  saveToCart(market: $market, item: $item) {
    cartId
  }
}
    `;
export type SaveToCartMutationFn = Apollo.MutationFunction<SaveToCartMutation, SaveToCartMutationVariables>;

/**
 * __useSaveToCartMutation__
 *
 * To run a mutation, you first call `useSaveToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveToCartMutation, { data, loading, error }] = useSaveToCartMutation({
 *   variables: {
 *      market: // value for 'market'
 *      item: // value for 'item'
 *   },
 * });
 */
export function useSaveToCartMutation(baseOptions?: Apollo.MutationHookOptions<SaveToCartMutation, SaveToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveToCartMutation, SaveToCartMutationVariables>(SaveToCartDocument, options);
      }
export type SaveToCartMutationHookResult = ReturnType<typeof useSaveToCartMutation>;
export type SaveToCartMutationResult = Apollo.MutationResult<SaveToCartMutation>;
export type SaveToCartMutationOptions = Apollo.BaseMutationOptions<SaveToCartMutation, SaveToCartMutationVariables>;
export const DeleteFromCartDocument = gql`
    mutation deleteFromCart($productId: Int!, $childId: Int) {
  deleteFromCart(productId: $productId, childId: $childId) {
    success
  }
}
    `;
export type DeleteFromCartMutationFn = Apollo.MutationFunction<DeleteFromCartMutation, DeleteFromCartMutationVariables>;

/**
 * __useDeleteFromCartMutation__
 *
 * To run a mutation, you first call `useDeleteFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFromCartMutation, { data, loading, error }] = useDeleteFromCartMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      childId: // value for 'childId'
 *   },
 * });
 */
export function useDeleteFromCartMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFromCartMutation, DeleteFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFromCartMutation, DeleteFromCartMutationVariables>(DeleteFromCartDocument, options);
      }
export type DeleteFromCartMutationHookResult = ReturnType<typeof useDeleteFromCartMutation>;
export type DeleteFromCartMutationResult = Apollo.MutationResult<DeleteFromCartMutation>;
export type DeleteFromCartMutationOptions = Apollo.BaseMutationOptions<DeleteFromCartMutation, DeleteFromCartMutationVariables>;
export const UnregisterCustomerDocument = gql`
    mutation UnregisterCustomer($keepNewsletterSubscription: Boolean) {
  unregisterCustomer(keepNewsletterSubscription: $keepNewsletterSubscription) {
    success
  }
}
    `;
export type UnregisterCustomerMutationFn = Apollo.MutationFunction<UnregisterCustomerMutation, UnregisterCustomerMutationVariables>;

/**
 * __useUnregisterCustomerMutation__
 *
 * To run a mutation, you first call `useUnregisterCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnregisterCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unregisterCustomerMutation, { data, loading, error }] = useUnregisterCustomerMutation({
 *   variables: {
 *      keepNewsletterSubscription: // value for 'keepNewsletterSubscription'
 *   },
 * });
 */
export function useUnregisterCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UnregisterCustomerMutation, UnregisterCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnregisterCustomerMutation, UnregisterCustomerMutationVariables>(UnregisterCustomerDocument, options);
      }
export type UnregisterCustomerMutationHookResult = ReturnType<typeof useUnregisterCustomerMutation>;
export type UnregisterCustomerMutationResult = Apollo.MutationResult<UnregisterCustomerMutation>;
export type UnregisterCustomerMutationOptions = Apollo.BaseMutationOptions<UnregisterCustomerMutation, UnregisterCustomerMutationVariables>;
export const GetBackwebMinimalUsersDocument = gql`
    query getBackwebMinimalUsers($token: String!, $search: String, $orderBy: String, $orderDirection: String, $filter: String, $page: Int, $size: Int, $aclRoleId: Int) {
  backweb(token: $token) {
    minimalUsers(
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      filter: $filter
      page: $page
      size: $size
      aclRoleId: $aclRoleId
    ) {
      items {
        id
        name
        email
        user_type
      }
      count
      total
      currentPage
      pageCount
    }
  }
}
    `;

/**
 * __useGetBackwebMinimalUsersQuery__
 *
 * To run a query within a React component, call `useGetBackwebMinimalUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackwebMinimalUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackwebMinimalUsersQuery({
 *   variables: {
 *      token: // value for 'token'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      aclRoleId: // value for 'aclRoleId'
 *   },
 * });
 */
export function useGetBackwebMinimalUsersQuery(baseOptions: Apollo.QueryHookOptions<GetBackwebMinimalUsersQuery, GetBackwebMinimalUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBackwebMinimalUsersQuery, GetBackwebMinimalUsersQueryVariables>(GetBackwebMinimalUsersDocument, options);
      }
export function useGetBackwebMinimalUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBackwebMinimalUsersQuery, GetBackwebMinimalUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBackwebMinimalUsersQuery, GetBackwebMinimalUsersQueryVariables>(GetBackwebMinimalUsersDocument, options);
        }
export function useGetBackwebMinimalUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBackwebMinimalUsersQuery, GetBackwebMinimalUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBackwebMinimalUsersQuery, GetBackwebMinimalUsersQueryVariables>(GetBackwebMinimalUsersDocument, options);
        }
export type GetBackwebMinimalUsersQueryHookResult = ReturnType<typeof useGetBackwebMinimalUsersQuery>;
export type GetBackwebMinimalUsersLazyQueryHookResult = ReturnType<typeof useGetBackwebMinimalUsersLazyQuery>;
export type GetBackwebMinimalUsersSuspenseQueryHookResult = ReturnType<typeof useGetBackwebMinimalUsersSuspenseQuery>;
export type GetBackwebMinimalUsersQueryResult = Apollo.QueryResult<GetBackwebMinimalUsersQuery, GetBackwebMinimalUsersQueryVariables>;
export const GetBackwebShippingMethodsDocument = gql`
    query getBackwebShippingMethods($token: String!, $search: String, $orderBy: String, $orderDirection: String, $filter: String) {
  backweb(token: $token) {
    shippingMethods(
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      filter: $filter
    ) {
      id
      name
      shipping_price
      country_code
      status
      choose_pickup_locator
      pickup_locator_code
      cart_types
      labels
      tracking_service
      postal_codes_exclude
    }
  }
}
    `;

/**
 * __useGetBackwebShippingMethodsQuery__
 *
 * To run a query within a React component, call `useGetBackwebShippingMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackwebShippingMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackwebShippingMethodsQuery({
 *   variables: {
 *      token: // value for 'token'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBackwebShippingMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetBackwebShippingMethodsQuery, GetBackwebShippingMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBackwebShippingMethodsQuery, GetBackwebShippingMethodsQueryVariables>(GetBackwebShippingMethodsDocument, options);
      }
export function useGetBackwebShippingMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBackwebShippingMethodsQuery, GetBackwebShippingMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBackwebShippingMethodsQuery, GetBackwebShippingMethodsQueryVariables>(GetBackwebShippingMethodsDocument, options);
        }
export function useGetBackwebShippingMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBackwebShippingMethodsQuery, GetBackwebShippingMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBackwebShippingMethodsQuery, GetBackwebShippingMethodsQueryVariables>(GetBackwebShippingMethodsDocument, options);
        }
export type GetBackwebShippingMethodsQueryHookResult = ReturnType<typeof useGetBackwebShippingMethodsQuery>;
export type GetBackwebShippingMethodsLazyQueryHookResult = ReturnType<typeof useGetBackwebShippingMethodsLazyQuery>;
export type GetBackwebShippingMethodsSuspenseQueryHookResult = ReturnType<typeof useGetBackwebShippingMethodsSuspenseQuery>;
export type GetBackwebShippingMethodsQueryResult = Apollo.QueryResult<GetBackwebShippingMethodsQuery, GetBackwebShippingMethodsQueryVariables>;
export const GetBackwebMinimalOrdersDocument = gql`
    query getBackwebMinimalOrders($token: String!, $search: String, $orderDirection: String, $orderBy: String, $page: Int, $size: Int, $filterMarket: [String], $filterStatus: [String], $filterGrandTotal: BackwebPriceRange, $filterUpdatedAt: BackwebDateRange, $filterCreatedAt: BackwebDateRange) {
  backweb(token: $token) {
    minimalOrders(
      search: $search
      orderDirection: $orderDirection
      orderBy: $orderBy
      page: $page
      size: $size
      filterMarket: $filterMarket
      filterStatus: $filterStatus
      filterGrandTotal: $filterGrandTotal
      filterUpdatedAt: $filterUpdatedAt
      filterCreatedAt: $filterCreatedAt
    ) {
      items {
        id
        created_at
        updated_at
        status
        order_number
        market
        grand_total
        consultant_number
        first_name
        last_name
        customer_email
      }
      count
      total
      currentPage
      pageCount
    }
  }
}
    `;

/**
 * __useGetBackwebMinimalOrdersQuery__
 *
 * To run a query within a React component, call `useGetBackwebMinimalOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackwebMinimalOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackwebMinimalOrdersQuery({
 *   variables: {
 *      token: // value for 'token'
 *      search: // value for 'search'
 *      orderDirection: // value for 'orderDirection'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      filterMarket: // value for 'filterMarket'
 *      filterStatus: // value for 'filterStatus'
 *      filterGrandTotal: // value for 'filterGrandTotal'
 *      filterUpdatedAt: // value for 'filterUpdatedAt'
 *      filterCreatedAt: // value for 'filterCreatedAt'
 *   },
 * });
 */
export function useGetBackwebMinimalOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetBackwebMinimalOrdersQuery, GetBackwebMinimalOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBackwebMinimalOrdersQuery, GetBackwebMinimalOrdersQueryVariables>(GetBackwebMinimalOrdersDocument, options);
      }
export function useGetBackwebMinimalOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBackwebMinimalOrdersQuery, GetBackwebMinimalOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBackwebMinimalOrdersQuery, GetBackwebMinimalOrdersQueryVariables>(GetBackwebMinimalOrdersDocument, options);
        }
export function useGetBackwebMinimalOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBackwebMinimalOrdersQuery, GetBackwebMinimalOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBackwebMinimalOrdersQuery, GetBackwebMinimalOrdersQueryVariables>(GetBackwebMinimalOrdersDocument, options);
        }
export type GetBackwebMinimalOrdersQueryHookResult = ReturnType<typeof useGetBackwebMinimalOrdersQuery>;
export type GetBackwebMinimalOrdersLazyQueryHookResult = ReturnType<typeof useGetBackwebMinimalOrdersLazyQuery>;
export type GetBackwebMinimalOrdersSuspenseQueryHookResult = ReturnType<typeof useGetBackwebMinimalOrdersSuspenseQuery>;
export type GetBackwebMinimalOrdersQueryResult = Apollo.QueryResult<GetBackwebMinimalOrdersQuery, GetBackwebMinimalOrdersQueryVariables>;
export const GetBackwebUserDocument = gql`
    query getBackwebUser($token: String!, $id: Int!) {
  backweb(token: $token) {
    user(id: $id) {
      id
      registered_at
      last_updated_at
      name
      email
      date_of_birth
      locale
      user_type
      newsletter
      organisation_id
      customer_specific_information {
        address {
          id
          type
          first_name
          middle_name
          last_name
          co
          address
          postal_code
          city
          country_code
          email
          mobile
          phone_number
        }
        organisation_relation {
          user_id
          organisation_id
          active
          vip
          communication_consultant
          career_interest
          class_interest
          consultant_name
          consultant_number
        }
      }
      contact_specific_information {
        mobile
        email
        first_name
        last_name
        city
        address
        consultant_name
        consultant_number
      }
      consultant_specific_information {
        created_at
        updated_at
        consultant_number
        first_name
        last_name
        locale
        country_code
        shipping_name
        register_date
        unregistered
        unregistered_date
        recruited_by_number
        personal_webshop_active
        find_consultant_active
        personal_webshop_active_from
        personal_webshop_active_to
        personal_webshop_url
        shipping_co
        shipping_address
        shipping_postal_code
        shipping_city
        mobile
        email
        title_id
        title_name_short
        title_name_long
      }
      admin_specific_information {
        mobile
        email
        first_name
        last_name
        city
        address
        acl_role_id
        acl_role_name
      }
    }
  }
}
    `;

/**
 * __useGetBackwebUserQuery__
 *
 * To run a query within a React component, call `useGetBackwebUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackwebUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackwebUserQuery({
 *   variables: {
 *      token: // value for 'token'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBackwebUserQuery(baseOptions: Apollo.QueryHookOptions<GetBackwebUserQuery, GetBackwebUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBackwebUserQuery, GetBackwebUserQueryVariables>(GetBackwebUserDocument, options);
      }
export function useGetBackwebUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBackwebUserQuery, GetBackwebUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBackwebUserQuery, GetBackwebUserQueryVariables>(GetBackwebUserDocument, options);
        }
export function useGetBackwebUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBackwebUserQuery, GetBackwebUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBackwebUserQuery, GetBackwebUserQueryVariables>(GetBackwebUserDocument, options);
        }
export type GetBackwebUserQueryHookResult = ReturnType<typeof useGetBackwebUserQuery>;
export type GetBackwebUserLazyQueryHookResult = ReturnType<typeof useGetBackwebUserLazyQuery>;
export type GetBackwebUserSuspenseQueryHookResult = ReturnType<typeof useGetBackwebUserSuspenseQuery>;
export type GetBackwebUserQueryResult = Apollo.QueryResult<GetBackwebUserQuery, GetBackwebUserQueryVariables>;
export const GetBackwebAclRolesDocument = gql`
    query getBackwebAclRoles($token: String!) {
  backweb(token: $token) {
    aclRoles {
      id
      name
      permissions
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useGetBackwebAclRolesQuery__
 *
 * To run a query within a React component, call `useGetBackwebAclRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackwebAclRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackwebAclRolesQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetBackwebAclRolesQuery(baseOptions: Apollo.QueryHookOptions<GetBackwebAclRolesQuery, GetBackwebAclRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBackwebAclRolesQuery, GetBackwebAclRolesQueryVariables>(GetBackwebAclRolesDocument, options);
      }
export function useGetBackwebAclRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBackwebAclRolesQuery, GetBackwebAclRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBackwebAclRolesQuery, GetBackwebAclRolesQueryVariables>(GetBackwebAclRolesDocument, options);
        }
export function useGetBackwebAclRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBackwebAclRolesQuery, GetBackwebAclRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBackwebAclRolesQuery, GetBackwebAclRolesQueryVariables>(GetBackwebAclRolesDocument, options);
        }
export type GetBackwebAclRolesQueryHookResult = ReturnType<typeof useGetBackwebAclRolesQuery>;
export type GetBackwebAclRolesLazyQueryHookResult = ReturnType<typeof useGetBackwebAclRolesLazyQuery>;
export type GetBackwebAclRolesSuspenseQueryHookResult = ReturnType<typeof useGetBackwebAclRolesSuspenseQuery>;
export type GetBackwebAclRolesQueryResult = Apollo.QueryResult<GetBackwebAclRolesQuery, GetBackwebAclRolesQueryVariables>;
export const GetBackwebOrganisationOrderDocument = gql`
    query getBackwebOrganisationOrder($token: String!, $id: Int!, $consultant_number: String!) {
  backweb(token: $token) {
    organisationOrder(id: $id, consultant_number: $consultant_number) {
      id
      orderNumber
      createdAt
      customerEmail
      status
      taxTotal
      grandTotal
      grandTotalExclTax
      totalDiscountExclTax
      totalDiscountInclTax
      isInvoicingEnabled
      discountAmount
      discountPercentage
      followUp
      sendConfirmationEmail
      confirmationEmailSentAt
      invoice {
        id
        invoice_number
      }
      billingAddress {
        id
        type
        email
        mobile
        phone_number
        first_name
        middle_name
        last_name
        address
        co
        city
        postal_code
        country_code
      }
      items {
        id
        price
        basePrice
        quantity
        priceExclTax
        taxPercentage
        productId
        productName
        productSku
        productThumbnailUrl
        discountAmount
        discountPercentage
      }
      comments {
        id
        created_at
        comment
      }
    }
  }
}
    `;

/**
 * __useGetBackwebOrganisationOrderQuery__
 *
 * To run a query within a React component, call `useGetBackwebOrganisationOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackwebOrganisationOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackwebOrganisationOrderQuery({
 *   variables: {
 *      token: // value for 'token'
 *      id: // value for 'id'
 *      consultant_number: // value for 'consultant_number'
 *   },
 * });
 */
export function useGetBackwebOrganisationOrderQuery(baseOptions: Apollo.QueryHookOptions<GetBackwebOrganisationOrderQuery, GetBackwebOrganisationOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBackwebOrganisationOrderQuery, GetBackwebOrganisationOrderQueryVariables>(GetBackwebOrganisationOrderDocument, options);
      }
export function useGetBackwebOrganisationOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBackwebOrganisationOrderQuery, GetBackwebOrganisationOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBackwebOrganisationOrderQuery, GetBackwebOrganisationOrderQueryVariables>(GetBackwebOrganisationOrderDocument, options);
        }
export function useGetBackwebOrganisationOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBackwebOrganisationOrderQuery, GetBackwebOrganisationOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBackwebOrganisationOrderQuery, GetBackwebOrganisationOrderQueryVariables>(GetBackwebOrganisationOrderDocument, options);
        }
export type GetBackwebOrganisationOrderQueryHookResult = ReturnType<typeof useGetBackwebOrganisationOrderQuery>;
export type GetBackwebOrganisationOrderLazyQueryHookResult = ReturnType<typeof useGetBackwebOrganisationOrderLazyQuery>;
export type GetBackwebOrganisationOrderSuspenseQueryHookResult = ReturnType<typeof useGetBackwebOrganisationOrderSuspenseQuery>;
export type GetBackwebOrganisationOrderQueryResult = Apollo.QueryResult<GetBackwebOrganisationOrderQuery, GetBackwebOrganisationOrderQueryVariables>;
export const GetBackwebConsultantSubmissionsDocument = gql`
    query getBackwebConsultantSubmissions($token: String!) {
  backweb(token: $token) {
    consultantSubmissions {
      items {
        id
        consultant {
          id
          name
          email
          locale
          registered_at
          last_updated_at
          user_type
          newsletter
          consultant_specific_information {
            created_at
            updated_at
            consultant_number
            first_name
            last_name
            locale
            country_code
            shipping_name
            register_date
            unregistered
            unregistered_date
            recruited_by_number
            personal_webshop_active
            find_consultant_active
            personal_webshop_active_from
            personal_webshop_active_to
            personal_webshop_url
            shipping_co
            shipping_address
            shipping_postal_code
            shipping_city
            mobile
            email
            title_id
            title_name_short
            title_name_long
          }
        }
        presentation_text
        ftax_confirmed
        title_level
        presentation_image_url
        approved
        approved_at
        approved_by {
          id
          name
          email
          locale
          registered_at
          last_updated_at
          user_type
          newsletter
        }
        created_at
        updated_at
      }
      count
      total
      currentPage
      pageCount
    }
  }
}
    `;

/**
 * __useGetBackwebConsultantSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetBackwebConsultantSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackwebConsultantSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackwebConsultantSubmissionsQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetBackwebConsultantSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<GetBackwebConsultantSubmissionsQuery, GetBackwebConsultantSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBackwebConsultantSubmissionsQuery, GetBackwebConsultantSubmissionsQueryVariables>(GetBackwebConsultantSubmissionsDocument, options);
      }
export function useGetBackwebConsultantSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBackwebConsultantSubmissionsQuery, GetBackwebConsultantSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBackwebConsultantSubmissionsQuery, GetBackwebConsultantSubmissionsQueryVariables>(GetBackwebConsultantSubmissionsDocument, options);
        }
export function useGetBackwebConsultantSubmissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBackwebConsultantSubmissionsQuery, GetBackwebConsultantSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBackwebConsultantSubmissionsQuery, GetBackwebConsultantSubmissionsQueryVariables>(GetBackwebConsultantSubmissionsDocument, options);
        }
export type GetBackwebConsultantSubmissionsQueryHookResult = ReturnType<typeof useGetBackwebConsultantSubmissionsQuery>;
export type GetBackwebConsultantSubmissionsLazyQueryHookResult = ReturnType<typeof useGetBackwebConsultantSubmissionsLazyQuery>;
export type GetBackwebConsultantSubmissionsSuspenseQueryHookResult = ReturnType<typeof useGetBackwebConsultantSubmissionsSuspenseQuery>;
export type GetBackwebConsultantSubmissionsQueryResult = Apollo.QueryResult<GetBackwebConsultantSubmissionsQuery, GetBackwebConsultantSubmissionsQueryVariables>;
export const GetBackwebCommandsDocument = gql`
    query GetBackwebCommands($token: String!) {
  backweb(token: $token) {
    commands {
      key
      signature
      description
    }
  }
}
    `;

/**
 * __useGetBackwebCommandsQuery__
 *
 * To run a query within a React component, call `useGetBackwebCommandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackwebCommandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackwebCommandsQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetBackwebCommandsQuery(baseOptions: Apollo.QueryHookOptions<GetBackwebCommandsQuery, GetBackwebCommandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBackwebCommandsQuery, GetBackwebCommandsQueryVariables>(GetBackwebCommandsDocument, options);
      }
export function useGetBackwebCommandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBackwebCommandsQuery, GetBackwebCommandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBackwebCommandsQuery, GetBackwebCommandsQueryVariables>(GetBackwebCommandsDocument, options);
        }
export function useGetBackwebCommandsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBackwebCommandsQuery, GetBackwebCommandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBackwebCommandsQuery, GetBackwebCommandsQueryVariables>(GetBackwebCommandsDocument, options);
        }
export type GetBackwebCommandsQueryHookResult = ReturnType<typeof useGetBackwebCommandsQuery>;
export type GetBackwebCommandsLazyQueryHookResult = ReturnType<typeof useGetBackwebCommandsLazyQuery>;
export type GetBackwebCommandsSuspenseQueryHookResult = ReturnType<typeof useGetBackwebCommandsSuspenseQuery>;
export type GetBackwebCommandsQueryResult = Apollo.QueryResult<GetBackwebCommandsQuery, GetBackwebCommandsQueryVariables>;
export const StartBackwebCommandDocument = gql`
    mutation StartBackwebCommand($token: String!, $key: String!, $options: [String!]) {
  backweb(token: $token) {
    startCommand(key: $key, options: $options)
  }
}
    `;
export type StartBackwebCommandMutationFn = Apollo.MutationFunction<StartBackwebCommandMutation, StartBackwebCommandMutationVariables>;

/**
 * __useStartBackwebCommandMutation__
 *
 * To run a mutation, you first call `useStartBackwebCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartBackwebCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startBackwebCommandMutation, { data, loading, error }] = useStartBackwebCommandMutation({
 *   variables: {
 *      token: // value for 'token'
 *      key: // value for 'key'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useStartBackwebCommandMutation(baseOptions?: Apollo.MutationHookOptions<StartBackwebCommandMutation, StartBackwebCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartBackwebCommandMutation, StartBackwebCommandMutationVariables>(StartBackwebCommandDocument, options);
      }
export type StartBackwebCommandMutationHookResult = ReturnType<typeof useStartBackwebCommandMutation>;
export type StartBackwebCommandMutationResult = Apollo.MutationResult<StartBackwebCommandMutation>;
export type StartBackwebCommandMutationOptions = Apollo.BaseMutationOptions<StartBackwebCommandMutation, StartBackwebCommandMutationVariables>;
export const GetBackwebCommandRunsDocument = gql`
    query GetBackwebCommandRuns($token: String!, $key: String!) {
  backweb(token: $token) {
    commandRuns(key: $key) {
      id
      key
      started_at
      finished_at
      status
      bytes
    }
  }
}
    `;

/**
 * __useGetBackwebCommandRunsQuery__
 *
 * To run a query within a React component, call `useGetBackwebCommandRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackwebCommandRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackwebCommandRunsQuery({
 *   variables: {
 *      token: // value for 'token'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetBackwebCommandRunsQuery(baseOptions: Apollo.QueryHookOptions<GetBackwebCommandRunsQuery, GetBackwebCommandRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBackwebCommandRunsQuery, GetBackwebCommandRunsQueryVariables>(GetBackwebCommandRunsDocument, options);
      }
export function useGetBackwebCommandRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBackwebCommandRunsQuery, GetBackwebCommandRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBackwebCommandRunsQuery, GetBackwebCommandRunsQueryVariables>(GetBackwebCommandRunsDocument, options);
        }
export function useGetBackwebCommandRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBackwebCommandRunsQuery, GetBackwebCommandRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBackwebCommandRunsQuery, GetBackwebCommandRunsQueryVariables>(GetBackwebCommandRunsDocument, options);
        }
export type GetBackwebCommandRunsQueryHookResult = ReturnType<typeof useGetBackwebCommandRunsQuery>;
export type GetBackwebCommandRunsLazyQueryHookResult = ReturnType<typeof useGetBackwebCommandRunsLazyQuery>;
export type GetBackwebCommandRunsSuspenseQueryHookResult = ReturnType<typeof useGetBackwebCommandRunsSuspenseQuery>;
export type GetBackwebCommandRunsQueryResult = Apollo.QueryResult<GetBackwebCommandRunsQuery, GetBackwebCommandRunsQueryVariables>;
export const GetBackwebCommandLogDocument = gql`
    query GetBackwebCommandLog($token: String!, $key: String!, $runId: String!, $offset: Int!, $maxBytes: Int!) {
  backweb(token: $token) {
    commandLog(key: $key, runId: $runId, offset: $offset, maxBytes: $maxBytes)
  }
}
    `;

/**
 * __useGetBackwebCommandLogQuery__
 *
 * To run a query within a React component, call `useGetBackwebCommandLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackwebCommandLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackwebCommandLogQuery({
 *   variables: {
 *      token: // value for 'token'
 *      key: // value for 'key'
 *      runId: // value for 'runId'
 *      offset: // value for 'offset'
 *      maxBytes: // value for 'maxBytes'
 *   },
 * });
 */
export function useGetBackwebCommandLogQuery(baseOptions: Apollo.QueryHookOptions<GetBackwebCommandLogQuery, GetBackwebCommandLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBackwebCommandLogQuery, GetBackwebCommandLogQueryVariables>(GetBackwebCommandLogDocument, options);
      }
export function useGetBackwebCommandLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBackwebCommandLogQuery, GetBackwebCommandLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBackwebCommandLogQuery, GetBackwebCommandLogQueryVariables>(GetBackwebCommandLogDocument, options);
        }
export function useGetBackwebCommandLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBackwebCommandLogQuery, GetBackwebCommandLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBackwebCommandLogQuery, GetBackwebCommandLogQueryVariables>(GetBackwebCommandLogDocument, options);
        }
export type GetBackwebCommandLogQueryHookResult = ReturnType<typeof useGetBackwebCommandLogQuery>;
export type GetBackwebCommandLogLazyQueryHookResult = ReturnType<typeof useGetBackwebCommandLogLazyQuery>;
export type GetBackwebCommandLogSuspenseQueryHookResult = ReturnType<typeof useGetBackwebCommandLogSuspenseQuery>;
export type GetBackwebCommandLogQueryResult = Apollo.QueryResult<GetBackwebCommandLogQuery, GetBackwebCommandLogQueryVariables>;
export const GetBundledProductDocument = gql`
    query getBundledProduct($productId: Int!) {
  bundledProduct(productId: $productId) {
    id
    consultant_user_id
    name
    description
    sku
    status
  }
}
    `;

/**
 * __useGetBundledProductQuery__
 *
 * To run a query within a React component, call `useGetBundledProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBundledProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBundledProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetBundledProductQuery(baseOptions: Apollo.QueryHookOptions<GetBundledProductQuery, GetBundledProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBundledProductQuery, GetBundledProductQueryVariables>(GetBundledProductDocument, options);
      }
export function useGetBundledProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBundledProductQuery, GetBundledProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBundledProductQuery, GetBundledProductQueryVariables>(GetBundledProductDocument, options);
        }
export function useGetBundledProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBundledProductQuery, GetBundledProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBundledProductQuery, GetBundledProductQueryVariables>(GetBundledProductDocument, options);
        }
export type GetBundledProductQueryHookResult = ReturnType<typeof useGetBundledProductQuery>;
export type GetBundledProductLazyQueryHookResult = ReturnType<typeof useGetBundledProductLazyQuery>;
export type GetBundledProductSuspenseQueryHookResult = ReturnType<typeof useGetBundledProductSuspenseQuery>;
export type GetBundledProductQueryResult = Apollo.QueryResult<GetBundledProductQuery, GetBundledProductQueryVariables>;
export const GetEventParticipantsDocument = gql`
    query getEventParticipants($eventId: Int!) {
  eventParticipants(eventId: $eventId) {
    items {
      id
      user_id
      invite_sent_at
      invite_accepted_at
    }
  }
}
    `;

/**
 * __useGetEventParticipantsQuery__
 *
 * To run a query within a React component, call `useGetEventParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventParticipantsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventParticipantsQuery(baseOptions: Apollo.QueryHookOptions<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>(GetEventParticipantsDocument, options);
      }
export function useGetEventParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>(GetEventParticipantsDocument, options);
        }
export function useGetEventParticipantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>(GetEventParticipantsDocument, options);
        }
export type GetEventParticipantsQueryHookResult = ReturnType<typeof useGetEventParticipantsQuery>;
export type GetEventParticipantsLazyQueryHookResult = ReturnType<typeof useGetEventParticipantsLazyQuery>;
export type GetEventParticipantsSuspenseQueryHookResult = ReturnType<typeof useGetEventParticipantsSuspenseQuery>;
export type GetEventParticipantsQueryResult = Apollo.QueryResult<GetEventParticipantsQuery, GetEventParticipantsQueryVariables>;
export const GetOrganisationOrderDocument = gql`
    query getOrganisationOrder($id: Int!) {
  organisationOrder(id: $id) {
    id
    orderNumber
    createdAt
    fullName
    customerEmail
    status
    taxTotal
    grandTotal
    grandTotalExclTax
    totalDiscountExclTax
    totalDiscountInclTax
    isInvoicingEnabled
    discountAmount
    discountPercentage
    followUp
    sendConfirmationEmail
    confirmationEmailSentAt
    invoice {
      id
      invoice_number
    }
    billingAddress {
      id
      type
      email
      mobile
      phone_number
      first_name
      middle_name
      last_name
      address
      co
      city
      postal_code
      country_code
    }
    items {
      id
      price
      basePrice
      quantity
      priceExclTax
      taxPercentage
      productId
      productName
      productSku
      productThumbnailUrl
      discountAmount
      discountPercentage
      product {
        ...Product
      }
    }
    comments {
      id
      created_at
      comment
    }
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useGetOrganisationOrderQuery__
 *
 * To run a query within a React component, call `useGetOrganisationOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganisationOrderQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationOrderQuery, GetOrganisationOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationOrderQuery, GetOrganisationOrderQueryVariables>(GetOrganisationOrderDocument, options);
      }
export function useGetOrganisationOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationOrderQuery, GetOrganisationOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationOrderQuery, GetOrganisationOrderQueryVariables>(GetOrganisationOrderDocument, options);
        }
export function useGetOrganisationOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationOrderQuery, GetOrganisationOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationOrderQuery, GetOrganisationOrderQueryVariables>(GetOrganisationOrderDocument, options);
        }
export type GetOrganisationOrderQueryHookResult = ReturnType<typeof useGetOrganisationOrderQuery>;
export type GetOrganisationOrderLazyQueryHookResult = ReturnType<typeof useGetOrganisationOrderLazyQuery>;
export type GetOrganisationOrderSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationOrderSuspenseQuery>;
export type GetOrganisationOrderQueryResult = Apollo.QueryResult<GetOrganisationOrderQuery, GetOrganisationOrderQueryVariables>;
export const GetOrganisationOrdersDocument = gql`
    query getOrganisationOrders($page: Int, $size: Int, $search: String, $orderBy: OrganisationOrderOrderByEnum!, $orderDirection: OrderDirectionEnum!, $status: OrganisationOrderStatusEnum) {
  organisationOrders(
    page: $page
    size: $size
    search: $search
    orderBy: $orderBy
    orderDirection: $orderDirection
    status: $status
  ) {
    items {
      id
      orderNumber
      createdAt
      customerEmail
      status
      taxTotal
      grandTotal
      grandTotalExclTax
      totalDiscountExclTax
      totalDiscountInclTax
      isInvoicingEnabled
      discountAmount
      discountPercentage
      followUp
      invoice {
        id
        invoice_number
      }
      billingAddress {
        id
        type
        email
        mobile
        phone_number
        first_name
        middle_name
        last_name
        address
        co
        city
        postal_code
        country_code
      }
      items {
        id
        price
        basePrice
        quantity
        priceExclTax
        taxPercentage
        productId
        productName
        productSku
        productThumbnailUrl
        discountAmount
        discountPercentage
      }
      comments {
        id
        created_at
        comment
      }
    }
    total
    page
    size
  }
}
    `;

/**
 * __useGetOrganisationOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrganisationOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationOrdersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetOrganisationOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationOrdersQuery, GetOrganisationOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationOrdersQuery, GetOrganisationOrdersQueryVariables>(GetOrganisationOrdersDocument, options);
      }
export function useGetOrganisationOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationOrdersQuery, GetOrganisationOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationOrdersQuery, GetOrganisationOrdersQueryVariables>(GetOrganisationOrdersDocument, options);
        }
export function useGetOrganisationOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationOrdersQuery, GetOrganisationOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationOrdersQuery, GetOrganisationOrdersQueryVariables>(GetOrganisationOrdersDocument, options);
        }
export type GetOrganisationOrdersQueryHookResult = ReturnType<typeof useGetOrganisationOrdersQuery>;
export type GetOrganisationOrdersLazyQueryHookResult = ReturnType<typeof useGetOrganisationOrdersLazyQuery>;
export type GetOrganisationOrdersSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationOrdersSuspenseQuery>;
export type GetOrganisationOrdersQueryResult = Apollo.QueryResult<GetOrganisationOrdersQuery, GetOrganisationOrdersQueryVariables>;
export const GetSentOrganisationMailsDocument = gql`
    query getSentOrganisationMails($page: Int, $size: Int) {
  sentOrganisationMails(page: $page, size: $size) {
    total
    page
    size
    items {
      sentAt
      subject
      headline
      message
      mailTemplate
      mailRecipients {
        name
        email
      }
    }
  }
}
    `;

/**
 * __useGetSentOrganisationMailsQuery__
 *
 * To run a query within a React component, call `useGetSentOrganisationMailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSentOrganisationMailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSentOrganisationMailsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetSentOrganisationMailsQuery(baseOptions?: Apollo.QueryHookOptions<GetSentOrganisationMailsQuery, GetSentOrganisationMailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSentOrganisationMailsQuery, GetSentOrganisationMailsQueryVariables>(GetSentOrganisationMailsDocument, options);
      }
export function useGetSentOrganisationMailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSentOrganisationMailsQuery, GetSentOrganisationMailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSentOrganisationMailsQuery, GetSentOrganisationMailsQueryVariables>(GetSentOrganisationMailsDocument, options);
        }
export function useGetSentOrganisationMailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSentOrganisationMailsQuery, GetSentOrganisationMailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSentOrganisationMailsQuery, GetSentOrganisationMailsQueryVariables>(GetSentOrganisationMailsDocument, options);
        }
export type GetSentOrganisationMailsQueryHookResult = ReturnType<typeof useGetSentOrganisationMailsQuery>;
export type GetSentOrganisationMailsLazyQueryHookResult = ReturnType<typeof useGetSentOrganisationMailsLazyQuery>;
export type GetSentOrganisationMailsSuspenseQueryHookResult = ReturnType<typeof useGetSentOrganisationMailsSuspenseQuery>;
export type GetSentOrganisationMailsQueryResult = Apollo.QueryResult<GetSentOrganisationMailsQuery, GetSentOrganisationMailsQueryVariables>;
export const GetPreviewOrganisationMailDocument = gql`
    query getPreviewOrganisationMail($organisationMailInput: OrganisationMailInput!) {
  previewOrganisationMail(organisationMailInput: $organisationMailInput) {
    html
  }
}
    `;

/**
 * __useGetPreviewOrganisationMailQuery__
 *
 * To run a query within a React component, call `useGetPreviewOrganisationMailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewOrganisationMailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewOrganisationMailQuery({
 *   variables: {
 *      organisationMailInput: // value for 'organisationMailInput'
 *   },
 * });
 */
export function useGetPreviewOrganisationMailQuery(baseOptions: Apollo.QueryHookOptions<GetPreviewOrganisationMailQuery, GetPreviewOrganisationMailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewOrganisationMailQuery, GetPreviewOrganisationMailQueryVariables>(GetPreviewOrganisationMailDocument, options);
      }
export function useGetPreviewOrganisationMailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewOrganisationMailQuery, GetPreviewOrganisationMailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewOrganisationMailQuery, GetPreviewOrganisationMailQueryVariables>(GetPreviewOrganisationMailDocument, options);
        }
export function useGetPreviewOrganisationMailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreviewOrganisationMailQuery, GetPreviewOrganisationMailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviewOrganisationMailQuery, GetPreviewOrganisationMailQueryVariables>(GetPreviewOrganisationMailDocument, options);
        }
export type GetPreviewOrganisationMailQueryHookResult = ReturnType<typeof useGetPreviewOrganisationMailQuery>;
export type GetPreviewOrganisationMailLazyQueryHookResult = ReturnType<typeof useGetPreviewOrganisationMailLazyQuery>;
export type GetPreviewOrganisationMailSuspenseQueryHookResult = ReturnType<typeof useGetPreviewOrganisationMailSuspenseQuery>;
export type GetPreviewOrganisationMailQueryResult = Apollo.QueryResult<GetPreviewOrganisationMailQuery, GetPreviewOrganisationMailQueryVariables>;
export const GetConsultantCustomersDocument = gql`
    query getConsultantCustomers($search: String, $page: Int, $size: Int, $paginate: Boolean, $orderBy: String, $orderDirection: String, $tagIds: [Int!], $filter_groups: [CustomersFilterGroupEnum!]) {
  consultantCustomers(
    search: $search
    orderBy: $orderBy
    orderDirection: $orderDirection
    page: $page
    size: $size
    paginate: $paginate
    tagIds: $tagIds
    filter_groups: $filter_groups
  ) {
    items {
      id
      name
      created_at
      updated_at
      register_date
      email
      date_of_birth
      locale
      login_provider
      newsletter
      user_type
      profile_photo_path
      fullName
      tags {
        id
        name
      }
      system_tags
      billing_address {
        id
        type
        email
        mobile
        phone_number
        first_name
        middle_name
        last_name
        address
        co
        city
        postal_code
        country_code
      }
      customer_organisation_relation {
        user_id
        organisation_id
        active
        vip
        communication_consultant
        career_interest
        class_interest
      }
    }
    count
    total
    currentPage
    pageCount
  }
}
    `;

/**
 * __useGetConsultantCustomersQuery__
 *
 * To run a query within a React component, call `useGetConsultantCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantCustomersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      paginate: // value for 'paginate'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      tagIds: // value for 'tagIds'
 *      filter_groups: // value for 'filter_groups'
 *   },
 * });
 */
export function useGetConsultantCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetConsultantCustomersQuery, GetConsultantCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultantCustomersQuery, GetConsultantCustomersQueryVariables>(GetConsultantCustomersDocument, options);
      }
export function useGetConsultantCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultantCustomersQuery, GetConsultantCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultantCustomersQuery, GetConsultantCustomersQueryVariables>(GetConsultantCustomersDocument, options);
        }
export function useGetConsultantCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConsultantCustomersQuery, GetConsultantCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultantCustomersQuery, GetConsultantCustomersQueryVariables>(GetConsultantCustomersDocument, options);
        }
export type GetConsultantCustomersQueryHookResult = ReturnType<typeof useGetConsultantCustomersQuery>;
export type GetConsultantCustomersLazyQueryHookResult = ReturnType<typeof useGetConsultantCustomersLazyQuery>;
export type GetConsultantCustomersSuspenseQueryHookResult = ReturnType<typeof useGetConsultantCustomersSuspenseQuery>;
export type GetConsultantCustomersQueryResult = Apollo.QueryResult<GetConsultantCustomersQuery, GetConsultantCustomersQueryVariables>;
export const GetConsultantCustomerDocument = gql`
    query getConsultantCustomer($customerUserId: Int!) {
  consultantCustomer(id: $customerUserId) {
    id
    name
    created_at
    updated_at
    register_date
    email
    date_of_birth
    locale
    login_provider
    newsletter
    user_type
    profile_photo_path
    fullName
    system_tags
    tags {
      id
      name
    }
    billing_address {
      id
      type
      email
      mobile
      phone_number
      first_name
      middle_name
      last_name
      address
      co
      city
      postal_code
      country_code
    }
    customer_organisation_relation {
      user_id
      organisation_id
      active
      vip
      communication_consultant
      career_interest
      class_interest
    }
  }
}
    `;

/**
 * __useGetConsultantCustomerQuery__
 *
 * To run a query within a React component, call `useGetConsultantCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantCustomerQuery({
 *   variables: {
 *      customerUserId: // value for 'customerUserId'
 *   },
 * });
 */
export function useGetConsultantCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetConsultantCustomerQuery, GetConsultantCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultantCustomerQuery, GetConsultantCustomerQueryVariables>(GetConsultantCustomerDocument, options);
      }
export function useGetConsultantCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultantCustomerQuery, GetConsultantCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultantCustomerQuery, GetConsultantCustomerQueryVariables>(GetConsultantCustomerDocument, options);
        }
export function useGetConsultantCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConsultantCustomerQuery, GetConsultantCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultantCustomerQuery, GetConsultantCustomerQueryVariables>(GetConsultantCustomerDocument, options);
        }
export type GetConsultantCustomerQueryHookResult = ReturnType<typeof useGetConsultantCustomerQuery>;
export type GetConsultantCustomerLazyQueryHookResult = ReturnType<typeof useGetConsultantCustomerLazyQuery>;
export type GetConsultantCustomerSuspenseQueryHookResult = ReturnType<typeof useGetConsultantCustomerSuspenseQuery>;
export type GetConsultantCustomerQueryResult = Apollo.QueryResult<GetConsultantCustomerQuery, GetConsultantCustomerQueryVariables>;
export const GetConsultantActivityFeedDocument = gql`
    query getConsultantActivityFeed($orderBy: String, $orderDirection: String, $activityType: ActivityTypeFilterEnum, $limit: Int, $search: String) {
  consultantActivityFeed(
    orderBy: $orderBy
    orderDirection: $orderDirection
    activityType: $activityType
    limit: $limit
    search: $search
  ) {
    id
    type
    description
    created_at
    orderInfo {
      id
      order_number
      fullName
      grand_total
    }
    eventInfo {
      id
      location
      name
      event_type
      starts_at
      ends_at
    }
    customer {
      id
      name
      fullName
      email
      locale
      login_provider
      newsletter
      user_type
      created_at
      updated_at
      recruitedByCustomerUser {
        id
        name
        fullName
        email
        locale
        login_provider
        newsletter
        user_type
        created_at
        updated_at
      }
    }
  }
}
    `;

/**
 * __useGetConsultantActivityFeedQuery__
 *
 * To run a query within a React component, call `useGetConsultantActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantActivityFeedQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      activityType: // value for 'activityType'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetConsultantActivityFeedQuery(baseOptions?: Apollo.QueryHookOptions<GetConsultantActivityFeedQuery, GetConsultantActivityFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultantActivityFeedQuery, GetConsultantActivityFeedQueryVariables>(GetConsultantActivityFeedDocument, options);
      }
export function useGetConsultantActivityFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultantActivityFeedQuery, GetConsultantActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultantActivityFeedQuery, GetConsultantActivityFeedQueryVariables>(GetConsultantActivityFeedDocument, options);
        }
export function useGetConsultantActivityFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConsultantActivityFeedQuery, GetConsultantActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultantActivityFeedQuery, GetConsultantActivityFeedQueryVariables>(GetConsultantActivityFeedDocument, options);
        }
export type GetConsultantActivityFeedQueryHookResult = ReturnType<typeof useGetConsultantActivityFeedQuery>;
export type GetConsultantActivityFeedLazyQueryHookResult = ReturnType<typeof useGetConsultantActivityFeedLazyQuery>;
export type GetConsultantActivityFeedSuspenseQueryHookResult = ReturnType<typeof useGetConsultantActivityFeedSuspenseQuery>;
export type GetConsultantActivityFeedQueryResult = Apollo.QueryResult<GetConsultantActivityFeedQuery, GetConsultantActivityFeedQueryVariables>;
export const GetConsultantProductSettingDocument = gql`
    query getConsultantProductSetting($product_id: Int) {
  consultantProductSetting(product_id: $product_id) {
    organisation_id
    product_id
    base_price
    special_price
    special_price_from
    special_price_to
    todays_offer_price
    todays_offer_price_from
    todays_offer_price_to
    todays_offer_product_is_active
    product_is_active_central_control
    end_of_life_override
  }
}
    `;

/**
 * __useGetConsultantProductSettingQuery__
 *
 * To run a query within a React component, call `useGetConsultantProductSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantProductSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantProductSettingQuery({
 *   variables: {
 *      product_id: // value for 'product_id'
 *   },
 * });
 */
export function useGetConsultantProductSettingQuery(baseOptions?: Apollo.QueryHookOptions<GetConsultantProductSettingQuery, GetConsultantProductSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultantProductSettingQuery, GetConsultantProductSettingQueryVariables>(GetConsultantProductSettingDocument, options);
      }
export function useGetConsultantProductSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultantProductSettingQuery, GetConsultantProductSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultantProductSettingQuery, GetConsultantProductSettingQueryVariables>(GetConsultantProductSettingDocument, options);
        }
export function useGetConsultantProductSettingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConsultantProductSettingQuery, GetConsultantProductSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultantProductSettingQuery, GetConsultantProductSettingQueryVariables>(GetConsultantProductSettingDocument, options);
        }
export type GetConsultantProductSettingQueryHookResult = ReturnType<typeof useGetConsultantProductSettingQuery>;
export type GetConsultantProductSettingLazyQueryHookResult = ReturnType<typeof useGetConsultantProductSettingLazyQuery>;
export type GetConsultantProductSettingSuspenseQueryHookResult = ReturnType<typeof useGetConsultantProductSettingSuspenseQuery>;
export type GetConsultantProductSettingQueryResult = Apollo.QueryResult<GetConsultantProductSettingQuery, GetConsultantProductSettingQueryVariables>;
export const GetOrganisationSettingsDocument = gql`
    query getOrganisationSettings {
  organisationSettings {
    email
    mobile
    telephone
    facebook_url
    website_url
    presentation
    favourite_quote
    availability
    tags
    deliveryOptions
    billing_invoicing_method
    billing_payment_method
    billing_account_number
    billing_active
    billing_org_number
    company_name
    billing_phone_number
    profile_url
    show_vat_on_invoice
  }
}
    `;

/**
 * __useGetOrganisationSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganisationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganisationSettingsQuery, GetOrganisationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationSettingsQuery, GetOrganisationSettingsQueryVariables>(GetOrganisationSettingsDocument, options);
      }
export function useGetOrganisationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationSettingsQuery, GetOrganisationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationSettingsQuery, GetOrganisationSettingsQueryVariables>(GetOrganisationSettingsDocument, options);
        }
export function useGetOrganisationSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationSettingsQuery, GetOrganisationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationSettingsQuery, GetOrganisationSettingsQueryVariables>(GetOrganisationSettingsDocument, options);
        }
export type GetOrganisationSettingsQueryHookResult = ReturnType<typeof useGetOrganisationSettingsQuery>;
export type GetOrganisationSettingsLazyQueryHookResult = ReturnType<typeof useGetOrganisationSettingsLazyQuery>;
export type GetOrganisationSettingsSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationSettingsSuspenseQuery>;
export type GetOrganisationSettingsQueryResult = Apollo.QueryResult<GetOrganisationSettingsQuery, GetOrganisationSettingsQueryVariables>;
export const GetOrganisationOrderCommentsDocument = gql`
    query getOrganisationOrderComments($organisation_order_id: Int!) {
  organisationOrderComments(organisation_order_id: $organisation_order_id) {
    items {
      id
      comment
      created_at
    }
  }
}
    `;

/**
 * __useGetOrganisationOrderCommentsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationOrderCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationOrderCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationOrderCommentsQuery({
 *   variables: {
 *      organisation_order_id: // value for 'organisation_order_id'
 *   },
 * });
 */
export function useGetOrganisationOrderCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationOrderCommentsQuery, GetOrganisationOrderCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationOrderCommentsQuery, GetOrganisationOrderCommentsQueryVariables>(GetOrganisationOrderCommentsDocument, options);
      }
export function useGetOrganisationOrderCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationOrderCommentsQuery, GetOrganisationOrderCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationOrderCommentsQuery, GetOrganisationOrderCommentsQueryVariables>(GetOrganisationOrderCommentsDocument, options);
        }
export function useGetOrganisationOrderCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationOrderCommentsQuery, GetOrganisationOrderCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationOrderCommentsQuery, GetOrganisationOrderCommentsQueryVariables>(GetOrganisationOrderCommentsDocument, options);
        }
export type GetOrganisationOrderCommentsQueryHookResult = ReturnType<typeof useGetOrganisationOrderCommentsQuery>;
export type GetOrganisationOrderCommentsLazyQueryHookResult = ReturnType<typeof useGetOrganisationOrderCommentsLazyQuery>;
export type GetOrganisationOrderCommentsSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationOrderCommentsSuspenseQuery>;
export type GetOrganisationOrderCommentsQueryResult = Apollo.QueryResult<GetOrganisationOrderCommentsQuery, GetOrganisationOrderCommentsQueryVariables>;
export const GetOrganisationCustomerCommentsDocument = gql`
    query getOrganisationCustomerComments($customer_id: Int) {
  organisationCustomerComments(customer_id: $customer_id) {
    items {
      id
      comment
      created_at
    }
  }
}
    `;

/**
 * __useGetOrganisationCustomerCommentsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationCustomerCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationCustomerCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationCustomerCommentsQuery({
 *   variables: {
 *      customer_id: // value for 'customer_id'
 *   },
 * });
 */
export function useGetOrganisationCustomerCommentsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganisationCustomerCommentsQuery, GetOrganisationCustomerCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationCustomerCommentsQuery, GetOrganisationCustomerCommentsQueryVariables>(GetOrganisationCustomerCommentsDocument, options);
      }
export function useGetOrganisationCustomerCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationCustomerCommentsQuery, GetOrganisationCustomerCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationCustomerCommentsQuery, GetOrganisationCustomerCommentsQueryVariables>(GetOrganisationCustomerCommentsDocument, options);
        }
export function useGetOrganisationCustomerCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationCustomerCommentsQuery, GetOrganisationCustomerCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationCustomerCommentsQuery, GetOrganisationCustomerCommentsQueryVariables>(GetOrganisationCustomerCommentsDocument, options);
        }
export type GetOrganisationCustomerCommentsQueryHookResult = ReturnType<typeof useGetOrganisationCustomerCommentsQuery>;
export type GetOrganisationCustomerCommentsLazyQueryHookResult = ReturnType<typeof useGetOrganisationCustomerCommentsLazyQuery>;
export type GetOrganisationCustomerCommentsSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationCustomerCommentsSuspenseQuery>;
export type GetOrganisationCustomerCommentsQueryResult = Apollo.QueryResult<GetOrganisationCustomerCommentsQuery, GetOrganisationCustomerCommentsQueryVariables>;
export const GetOrganisationTagsDocument = gql`
    query getOrganisationTags {
  organisationTags {
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useGetOrganisationTagsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganisationTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganisationTagsQuery, GetOrganisationTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationTagsQuery, GetOrganisationTagsQueryVariables>(GetOrganisationTagsDocument, options);
      }
export function useGetOrganisationTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationTagsQuery, GetOrganisationTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationTagsQuery, GetOrganisationTagsQueryVariables>(GetOrganisationTagsDocument, options);
        }
export function useGetOrganisationTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationTagsQuery, GetOrganisationTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationTagsQuery, GetOrganisationTagsQueryVariables>(GetOrganisationTagsDocument, options);
        }
export type GetOrganisationTagsQueryHookResult = ReturnType<typeof useGetOrganisationTagsQuery>;
export type GetOrganisationTagsLazyQueryHookResult = ReturnType<typeof useGetOrganisationTagsLazyQuery>;
export type GetOrganisationTagsSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationTagsSuspenseQuery>;
export type GetOrganisationTagsQueryResult = Apollo.QueryResult<GetOrganisationTagsQuery, GetOrganisationTagsQueryVariables>;
export const GetEventDocument = gql`
    query getEvent($eventId: Int!) {
  event(id: $eventId) {
    ...Event
  }
}
    ${EventFragmentDoc}`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export function useGetEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventSuspenseQueryHookResult = ReturnType<typeof useGetEventSuspenseQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const GetEventsDocument = gql`
    query getEvents($date_from: String!, $date_to: String!) {
  eventList(date_from: $date_from, date_to: $date_to) {
    events {
      ...Event
    }
  }
}
    ${EventFragmentDoc}`;

/**
 * __useGetEventsQuery__
 *
 * To run a query within a React component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsQuery({
 *   variables: {
 *      date_from: // value for 'date_from'
 *      date_to: // value for 'date_to'
 *   },
 * });
 */
export function useGetEventsQuery(baseOptions: Apollo.QueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
      }
export function useGetEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
        }
export function useGetEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
        }
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryHookResult = ReturnType<typeof useGetEventsLazyQuery>;
export type GetEventsSuspenseQueryHookResult = ReturnType<typeof useGetEventsSuspenseQuery>;
export type GetEventsQueryResult = Apollo.QueryResult<GetEventsQuery, GetEventsQueryVariables>;
export const GetOrganisationInvoiceListDocument = gql`
    query getOrganisationInvoiceList($paymentStatusFilter: String, $orderByDirection: String) {
  organisationInvoiceList(
    paymentStatusFilter: $paymentStatusFilter
    orderByDirection: $orderByDirection
  ) {
    isInvoicingEnabled
    items {
      id
      created_at
      last_sent_at
      updated_at
      organisation_id
      customer_user_id
      organisation_order_id
      invoice_number
      payment_status
      payment_terms_days
      due_date
      customerFullName
      isOverdue
      orderAmount
      magento_reference
      organisationOrder {
        id
        createdAt
        orderNumber
        grandTotal
      }
    }
  }
}
    `;

/**
 * __useGetOrganisationInvoiceListQuery__
 *
 * To run a query within a React component, call `useGetOrganisationInvoiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationInvoiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationInvoiceListQuery({
 *   variables: {
 *      paymentStatusFilter: // value for 'paymentStatusFilter'
 *      orderByDirection: // value for 'orderByDirection'
 *   },
 * });
 */
export function useGetOrganisationInvoiceListQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganisationInvoiceListQuery, GetOrganisationInvoiceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationInvoiceListQuery, GetOrganisationInvoiceListQueryVariables>(GetOrganisationInvoiceListDocument, options);
      }
export function useGetOrganisationInvoiceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationInvoiceListQuery, GetOrganisationInvoiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationInvoiceListQuery, GetOrganisationInvoiceListQueryVariables>(GetOrganisationInvoiceListDocument, options);
        }
export function useGetOrganisationInvoiceListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationInvoiceListQuery, GetOrganisationInvoiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationInvoiceListQuery, GetOrganisationInvoiceListQueryVariables>(GetOrganisationInvoiceListDocument, options);
        }
export type GetOrganisationInvoiceListQueryHookResult = ReturnType<typeof useGetOrganisationInvoiceListQuery>;
export type GetOrganisationInvoiceListLazyQueryHookResult = ReturnType<typeof useGetOrganisationInvoiceListLazyQuery>;
export type GetOrganisationInvoiceListSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationInvoiceListSuspenseQuery>;
export type GetOrganisationInvoiceListQueryResult = Apollo.QueryResult<GetOrganisationInvoiceListQuery, GetOrganisationInvoiceListQueryVariables>;
export const GetUsersBirthdayListDocument = gql`
    query getUsersBirthdayList($date: String!) {
  userBirthdayList(date: $date) {
    total
    items {
      date
      user {
        id
        name
        created_at
        updated_at
        register_date
        email
        date_of_birth
        locale
        login_provider
        newsletter
        user_type
        profile_photo_path
        fullName
        system_tags
        tags {
          id
          name
        }
        billing_address {
          id
          type
          email
          mobile
          phone_number
          first_name
          middle_name
          last_name
          address
          co
          city
          postal_code
          country_code
        }
        customer_organisation_relation {
          user_id
          organisation_id
          active
          vip
          communication_consultant
          career_interest
          class_interest
        }
      }
      days_until
    }
  }
}
    `;

/**
 * __useGetUsersBirthdayListQuery__
 *
 * To run a query within a React component, call `useGetUsersBirthdayListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersBirthdayListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersBirthdayListQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetUsersBirthdayListQuery(baseOptions: Apollo.QueryHookOptions<GetUsersBirthdayListQuery, GetUsersBirthdayListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersBirthdayListQuery, GetUsersBirthdayListQueryVariables>(GetUsersBirthdayListDocument, options);
      }
export function useGetUsersBirthdayListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersBirthdayListQuery, GetUsersBirthdayListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersBirthdayListQuery, GetUsersBirthdayListQueryVariables>(GetUsersBirthdayListDocument, options);
        }
export function useGetUsersBirthdayListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersBirthdayListQuery, GetUsersBirthdayListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersBirthdayListQuery, GetUsersBirthdayListQueryVariables>(GetUsersBirthdayListDocument, options);
        }
export type GetUsersBirthdayListQueryHookResult = ReturnType<typeof useGetUsersBirthdayListQuery>;
export type GetUsersBirthdayListLazyQueryHookResult = ReturnType<typeof useGetUsersBirthdayListLazyQuery>;
export type GetUsersBirthdayListSuspenseQueryHookResult = ReturnType<typeof useGetUsersBirthdayListSuspenseQuery>;
export type GetUsersBirthdayListQueryResult = Apollo.QueryResult<GetUsersBirthdayListQuery, GetUsersBirthdayListQueryVariables>;
export const GetStatisticsDocument = gql`
    query getStatistics($date_from: String!, $date_to: String!) {
  organisationStatistics(date_from: $date_from, date_to: $date_to) {
    date_from
    date_to
    datapoints {
      key
      value
      type
    }
    charts {
      key
      datapoints {
        key
        value
        type
      }
    }
  }
}
    `;

/**
 * __useGetStatisticsQuery__
 *
 * To run a query within a React component, call `useGetStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatisticsQuery({
 *   variables: {
 *      date_from: // value for 'date_from'
 *      date_to: // value for 'date_to'
 *   },
 * });
 */
export function useGetStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetStatisticsQuery, GetStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatisticsQuery, GetStatisticsQueryVariables>(GetStatisticsDocument, options);
      }
export function useGetStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatisticsQuery, GetStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatisticsQuery, GetStatisticsQueryVariables>(GetStatisticsDocument, options);
        }
export function useGetStatisticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStatisticsQuery, GetStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStatisticsQuery, GetStatisticsQueryVariables>(GetStatisticsDocument, options);
        }
export type GetStatisticsQueryHookResult = ReturnType<typeof useGetStatisticsQuery>;
export type GetStatisticsLazyQueryHookResult = ReturnType<typeof useGetStatisticsLazyQuery>;
export type GetStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetStatisticsSuspenseQuery>;
export type GetStatisticsQueryResult = Apollo.QueryResult<GetStatisticsQuery, GetStatisticsQueryVariables>;
export const GetContactRequestsCountDocument = gql`
    query GetContactRequestsCount($consultantId: Int!) {
  contactRequestsCount(consultantId: $consultantId)
}
    `;

/**
 * __useGetContactRequestsCountQuery__
 *
 * To run a query within a React component, call `useGetContactRequestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactRequestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactRequestsCountQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useGetContactRequestsCountQuery(baseOptions: Apollo.QueryHookOptions<GetContactRequestsCountQuery, GetContactRequestsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactRequestsCountQuery, GetContactRequestsCountQueryVariables>(GetContactRequestsCountDocument, options);
      }
export function useGetContactRequestsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactRequestsCountQuery, GetContactRequestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactRequestsCountQuery, GetContactRequestsCountQueryVariables>(GetContactRequestsCountDocument, options);
        }
export function useGetContactRequestsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContactRequestsCountQuery, GetContactRequestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactRequestsCountQuery, GetContactRequestsCountQueryVariables>(GetContactRequestsCountDocument, options);
        }
export type GetContactRequestsCountQueryHookResult = ReturnType<typeof useGetContactRequestsCountQuery>;
export type GetContactRequestsCountLazyQueryHookResult = ReturnType<typeof useGetContactRequestsCountLazyQuery>;
export type GetContactRequestsCountSuspenseQueryHookResult = ReturnType<typeof useGetContactRequestsCountSuspenseQuery>;
export type GetContactRequestsCountQueryResult = Apollo.QueryResult<GetContactRequestsCountQuery, GetContactRequestsCountQueryVariables>;
export const GetGeneralNotificationsCountDocument = gql`
    query GetGeneralNotificationsCount($status: String) {
  generalNotificationsCount(status: $status)
}
    `;

/**
 * __useGetGeneralNotificationsCountQuery__
 *
 * To run a query within a React component, call `useGetGeneralNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralNotificationsCountQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetGeneralNotificationsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneralNotificationsCountQuery, GetGeneralNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneralNotificationsCountQuery, GetGeneralNotificationsCountQueryVariables>(GetGeneralNotificationsCountDocument, options);
      }
export function useGetGeneralNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneralNotificationsCountQuery, GetGeneralNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneralNotificationsCountQuery, GetGeneralNotificationsCountQueryVariables>(GetGeneralNotificationsCountDocument, options);
        }
export function useGetGeneralNotificationsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGeneralNotificationsCountQuery, GetGeneralNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGeneralNotificationsCountQuery, GetGeneralNotificationsCountQueryVariables>(GetGeneralNotificationsCountDocument, options);
        }
export type GetGeneralNotificationsCountQueryHookResult = ReturnType<typeof useGetGeneralNotificationsCountQuery>;
export type GetGeneralNotificationsCountLazyQueryHookResult = ReturnType<typeof useGetGeneralNotificationsCountLazyQuery>;
export type GetGeneralNotificationsCountSuspenseQueryHookResult = ReturnType<typeof useGetGeneralNotificationsCountSuspenseQuery>;
export type GetGeneralNotificationsCountQueryResult = Apollo.QueryResult<GetGeneralNotificationsCountQuery, GetGeneralNotificationsCountQueryVariables>;
export const GetContactRequestsDocument = gql`
    query GetContactRequests($consultantId: Int!, $status: String) {
  contactRequests(consultantId: $consultantId, status: $status) {
    id
    consultantId
    guestEmail
    message
    status
    type
    title
    customerName
    customerPhone
    contactInitiatedAt
    contactConfirmedAt
    customerLinkRequestedAt
    customerLinkConfirmedAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetContactRequestsQuery__
 *
 * To run a query within a React component, call `useGetContactRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactRequestsQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetContactRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetContactRequestsQuery, GetContactRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactRequestsQuery, GetContactRequestsQueryVariables>(GetContactRequestsDocument, options);
      }
export function useGetContactRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactRequestsQuery, GetContactRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactRequestsQuery, GetContactRequestsQueryVariables>(GetContactRequestsDocument, options);
        }
export function useGetContactRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContactRequestsQuery, GetContactRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactRequestsQuery, GetContactRequestsQueryVariables>(GetContactRequestsDocument, options);
        }
export type GetContactRequestsQueryHookResult = ReturnType<typeof useGetContactRequestsQuery>;
export type GetContactRequestsLazyQueryHookResult = ReturnType<typeof useGetContactRequestsLazyQuery>;
export type GetContactRequestsSuspenseQueryHookResult = ReturnType<typeof useGetContactRequestsSuspenseQuery>;
export type GetContactRequestsQueryResult = Apollo.QueryResult<GetContactRequestsQuery, GetContactRequestsQueryVariables>;
export const GetGeneralNotificationsDocument = gql`
    query GetGeneralNotifications($status: String) {
  generalNotifications(status: $status) {
    id
    message
    status
    type
    title
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetGeneralNotificationsQuery__
 *
 * To run a query within a React component, call `useGetGeneralNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralNotificationsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetGeneralNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneralNotificationsQuery, GetGeneralNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneralNotificationsQuery, GetGeneralNotificationsQueryVariables>(GetGeneralNotificationsDocument, options);
      }
export function useGetGeneralNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneralNotificationsQuery, GetGeneralNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneralNotificationsQuery, GetGeneralNotificationsQueryVariables>(GetGeneralNotificationsDocument, options);
        }
export function useGetGeneralNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGeneralNotificationsQuery, GetGeneralNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGeneralNotificationsQuery, GetGeneralNotificationsQueryVariables>(GetGeneralNotificationsDocument, options);
        }
export type GetGeneralNotificationsQueryHookResult = ReturnType<typeof useGetGeneralNotificationsQuery>;
export type GetGeneralNotificationsLazyQueryHookResult = ReturnType<typeof useGetGeneralNotificationsLazyQuery>;
export type GetGeneralNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetGeneralNotificationsSuspenseQuery>;
export type GetGeneralNotificationsQueryResult = Apollo.QueryResult<GetGeneralNotificationsQuery, GetGeneralNotificationsQueryVariables>;
export const CreateNotificationDocument = gql`
    mutation CreateNotification($notification: NotificationInput!) {
  createNotification(notification: $notification) {
    id
    consultantId
    guestEmail
    message
    status
    type
    title
    customerName
    customerPhone
    createdAt
  }
}
    `;
export type CreateNotificationMutationFn = Apollo.MutationFunction<CreateNotificationMutation, CreateNotificationMutationVariables>;

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      notification: // value for 'notification'
 *   },
 * });
 */
export function useCreateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationMutation, CreateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationMutation, CreateNotificationMutationVariables>(CreateNotificationDocument, options);
      }
export type CreateNotificationMutationHookResult = ReturnType<typeof useCreateNotificationMutation>;
export type CreateNotificationMutationResult = Apollo.MutationResult<CreateNotificationMutation>;
export type CreateNotificationMutationOptions = Apollo.BaseMutationOptions<CreateNotificationMutation, CreateNotificationMutationVariables>;
export const UpdateNotificationDocument = gql`
    mutation UpdateNotification($notification: UpdateNotificationInput!) {
  updateNotification(notification: $notification) {
    id
    consultantId
    guestEmail
    message
    status
    type
    customerName
    customerPhone
    contactInitiatedAt
    contactConfirmedAt
    customerLinkRequestedAt
    customerLinkConfirmedAt
    createdAt
    updatedAt
  }
}
    `;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<UpdateNotificationMutation, UpdateNotificationMutationVariables>;

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      notification: // value for 'notification'
 *   },
 * });
 */
export function useUpdateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const DeleteNotificationDocument = gql`
    mutation DeleteNotification($id: Int!) {
  deleteNotification(id: $id) {
    success
  }
}
    `;
export type DeleteNotificationMutationFn = Apollo.MutationFunction<DeleteNotificationMutation, DeleteNotificationMutationVariables>;

/**
 * __useDeleteNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationMutation, { data, loading, error }] = useDeleteNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationMutation, DeleteNotificationMutationVariables>(DeleteNotificationDocument, options);
      }
export type DeleteNotificationMutationHookResult = ReturnType<typeof useDeleteNotificationMutation>;
export type DeleteNotificationMutationResult = Apollo.MutationResult<DeleteNotificationMutation>;
export type DeleteNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>;
export const ConfirmContactDocument = gql`
    mutation ConfirmContact($notificationId: Int!) {
  confirmContact(notificationId: $notificationId) {
    id
    consultantId
    guestEmail
    message
    status
    type
    customerName
    customerPhone
    contactInitiatedAt
    contactConfirmedAt
    customerLinkRequestedAt
    customerLinkConfirmedAt
    createdAt
    updatedAt
  }
}
    `;
export type ConfirmContactMutationFn = Apollo.MutationFunction<ConfirmContactMutation, ConfirmContactMutationVariables>;

/**
 * __useConfirmContactMutation__
 *
 * To run a mutation, you first call `useConfirmContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmContactMutation, { data, loading, error }] = useConfirmContactMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useConfirmContactMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmContactMutation, ConfirmContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmContactMutation, ConfirmContactMutationVariables>(ConfirmContactDocument, options);
      }
export type ConfirmContactMutationHookResult = ReturnType<typeof useConfirmContactMutation>;
export type ConfirmContactMutationResult = Apollo.MutationResult<ConfirmContactMutation>;
export type ConfirmContactMutationOptions = Apollo.BaseMutationOptions<ConfirmContactMutation, ConfirmContactMutationVariables>;
export const RequestCustomerLinkDocument = gql`
    mutation RequestCustomerLink($notificationId: Int!) {
  requestCustomerLink(notificationId: $notificationId) {
    id
    consultantId
    guestEmail
    message
    status
    type
    customerName
    customerPhone
    contactInitiatedAt
    contactConfirmedAt
    customerLinkRequestedAt
    customerLinkConfirmedAt
    createdAt
    updatedAt
  }
}
    `;
export type RequestCustomerLinkMutationFn = Apollo.MutationFunction<RequestCustomerLinkMutation, RequestCustomerLinkMutationVariables>;

/**
 * __useRequestCustomerLinkMutation__
 *
 * To run a mutation, you first call `useRequestCustomerLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCustomerLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCustomerLinkMutation, { data, loading, error }] = useRequestCustomerLinkMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useRequestCustomerLinkMutation(baseOptions?: Apollo.MutationHookOptions<RequestCustomerLinkMutation, RequestCustomerLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCustomerLinkMutation, RequestCustomerLinkMutationVariables>(RequestCustomerLinkDocument, options);
      }
export type RequestCustomerLinkMutationHookResult = ReturnType<typeof useRequestCustomerLinkMutation>;
export type RequestCustomerLinkMutationResult = Apollo.MutationResult<RequestCustomerLinkMutation>;
export type RequestCustomerLinkMutationOptions = Apollo.BaseMutationOptions<RequestCustomerLinkMutation, RequestCustomerLinkMutationVariables>;
export const ConfirmCustomerLinkDocument = gql`
    mutation ConfirmCustomerLink($notificationId: Int!) {
  confirmCustomerLink(notificationId: $notificationId) {
    id
    consultantId
    guestEmail
    message
    status
    type
    customerName
    customerPhone
    contactInitiatedAt
    contactConfirmedAt
    customerLinkRequestedAt
    customerLinkConfirmedAt
    createdAt
    updatedAt
  }
}
    `;
export type ConfirmCustomerLinkMutationFn = Apollo.MutationFunction<ConfirmCustomerLinkMutation, ConfirmCustomerLinkMutationVariables>;

/**
 * __useConfirmCustomerLinkMutation__
 *
 * To run a mutation, you first call `useConfirmCustomerLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCustomerLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCustomerLinkMutation, { data, loading, error }] = useConfirmCustomerLinkMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useConfirmCustomerLinkMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCustomerLinkMutation, ConfirmCustomerLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmCustomerLinkMutation, ConfirmCustomerLinkMutationVariables>(ConfirmCustomerLinkDocument, options);
      }
export type ConfirmCustomerLinkMutationHookResult = ReturnType<typeof useConfirmCustomerLinkMutation>;
export type ConfirmCustomerLinkMutationResult = Apollo.MutationResult<ConfirmCustomerLinkMutation>;
export type ConfirmCustomerLinkMutationOptions = Apollo.BaseMutationOptions<ConfirmCustomerLinkMutation, ConfirmCustomerLinkMutationVariables>;
export const ConfirmCustomerLinkFromHashDocument = gql`
    mutation ConfirmCustomerLinkFromHash($hash: String!) {
  confirmCustomerLinkFromHash(hash: $hash) {
    success
    message
    already_confirmed
  }
}
    `;
export type ConfirmCustomerLinkFromHashMutationFn = Apollo.MutationFunction<ConfirmCustomerLinkFromHashMutation, ConfirmCustomerLinkFromHashMutationVariables>;

/**
 * __useConfirmCustomerLinkFromHashMutation__
 *
 * To run a mutation, you first call `useConfirmCustomerLinkFromHashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCustomerLinkFromHashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCustomerLinkFromHashMutation, { data, loading, error }] = useConfirmCustomerLinkFromHashMutation({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useConfirmCustomerLinkFromHashMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCustomerLinkFromHashMutation, ConfirmCustomerLinkFromHashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmCustomerLinkFromHashMutation, ConfirmCustomerLinkFromHashMutationVariables>(ConfirmCustomerLinkFromHashDocument, options);
      }
export type ConfirmCustomerLinkFromHashMutationHookResult = ReturnType<typeof useConfirmCustomerLinkFromHashMutation>;
export type ConfirmCustomerLinkFromHashMutationResult = Apollo.MutationResult<ConfirmCustomerLinkFromHashMutation>;
export type ConfirmCustomerLinkFromHashMutationOptions = Apollo.BaseMutationOptions<ConfirmCustomerLinkFromHashMutation, ConfirmCustomerLinkFromHashMutationVariables>;
export const GetConsultantInfoFromHashDocument = gql`
    query GetConsultantInfoFromHash($hash: String!) {
  getConsultantInfoFromHash(hash: $hash) {
    consultantName
    consultantImage
    consultantPresentation
    organisationName
  }
}
    `;

/**
 * __useGetConsultantInfoFromHashQuery__
 *
 * To run a query within a React component, call `useGetConsultantInfoFromHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantInfoFromHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantInfoFromHashQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useGetConsultantInfoFromHashQuery(baseOptions: Apollo.QueryHookOptions<GetConsultantInfoFromHashQuery, GetConsultantInfoFromHashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultantInfoFromHashQuery, GetConsultantInfoFromHashQueryVariables>(GetConsultantInfoFromHashDocument, options);
      }
export function useGetConsultantInfoFromHashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultantInfoFromHashQuery, GetConsultantInfoFromHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultantInfoFromHashQuery, GetConsultantInfoFromHashQueryVariables>(GetConsultantInfoFromHashDocument, options);
        }
export function useGetConsultantInfoFromHashSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConsultantInfoFromHashQuery, GetConsultantInfoFromHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultantInfoFromHashQuery, GetConsultantInfoFromHashQueryVariables>(GetConsultantInfoFromHashDocument, options);
        }
export type GetConsultantInfoFromHashQueryHookResult = ReturnType<typeof useGetConsultantInfoFromHashQuery>;
export type GetConsultantInfoFromHashLazyQueryHookResult = ReturnType<typeof useGetConsultantInfoFromHashLazyQuery>;
export type GetConsultantInfoFromHashSuspenseQueryHookResult = ReturnType<typeof useGetConsultantInfoFromHashSuspenseQuery>;
export type GetConsultantInfoFromHashQueryResult = Apollo.QueryResult<GetConsultantInfoFromHashQuery, GetConsultantInfoFromHashQueryVariables>;
export const MarkAsCompletedDocument = gql`
    mutation MarkAsCompleted($notificationId: Int!) {
  markAsCompleted(notificationId: $notificationId) {
    id
    consultantId
    guestEmail
    message
    status
    type
    customerName
    customerPhone
    contactInitiatedAt
    contactConfirmedAt
    customerLinkRequestedAt
    customerLinkConfirmedAt
    createdAt
    updatedAt
  }
}
    `;
export type MarkAsCompletedMutationFn = Apollo.MutationFunction<MarkAsCompletedMutation, MarkAsCompletedMutationVariables>;

/**
 * __useMarkAsCompletedMutation__
 *
 * To run a mutation, you first call `useMarkAsCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsCompletedMutation, { data, loading, error }] = useMarkAsCompletedMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkAsCompletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkAsCompletedMutation, MarkAsCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAsCompletedMutation, MarkAsCompletedMutationVariables>(MarkAsCompletedDocument, options);
      }
export type MarkAsCompletedMutationHookResult = ReturnType<typeof useMarkAsCompletedMutation>;
export type MarkAsCompletedMutationResult = Apollo.MutationResult<MarkAsCompletedMutation>;
export type MarkAsCompletedMutationOptions = Apollo.BaseMutationOptions<MarkAsCompletedMutation, MarkAsCompletedMutationVariables>;
export const GetOrganisationGeolocationsDocument = gql`
    query getOrganisationGeolocations($market: String!) {
  organisationGeolocations(market: $market) {
    items {
      organisation_id
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetOrganisationGeolocationsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationGeolocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationGeolocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationGeolocationsQuery({
 *   variables: {
 *      market: // value for 'market'
 *   },
 * });
 */
export function useGetOrganisationGeolocationsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationGeolocationsQuery, GetOrganisationGeolocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationGeolocationsQuery, GetOrganisationGeolocationsQueryVariables>(GetOrganisationGeolocationsDocument, options);
      }
export function useGetOrganisationGeolocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationGeolocationsQuery, GetOrganisationGeolocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationGeolocationsQuery, GetOrganisationGeolocationsQueryVariables>(GetOrganisationGeolocationsDocument, options);
        }
export function useGetOrganisationGeolocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationGeolocationsQuery, GetOrganisationGeolocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationGeolocationsQuery, GetOrganisationGeolocationsQueryVariables>(GetOrganisationGeolocationsDocument, options);
        }
export type GetOrganisationGeolocationsQueryHookResult = ReturnType<typeof useGetOrganisationGeolocationsQuery>;
export type GetOrganisationGeolocationsLazyQueryHookResult = ReturnType<typeof useGetOrganisationGeolocationsLazyQuery>;
export type GetOrganisationGeolocationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationGeolocationsSuspenseQuery>;
export type GetOrganisationGeolocationsQueryResult = Apollo.QueryResult<GetOrganisationGeolocationsQuery, GetOrganisationGeolocationsQueryVariables>;
export const GetEventForHostessDocument = gql`
    query getEventForHostess($eventHash: String!) {
  eventForHostess(eventHash: $eventHash) {
    id
    name
    starts_at
    ends_at
    location
    event_type
    participants {
      id
      user_id
      invite_sent_at
      invite_accepted_at
      fullName
      first_name
      last_name
      email
      mobile
      profile_photo_path
    }
  }
}
    `;

/**
 * __useGetEventForHostessQuery__
 *
 * To run a query within a React component, call `useGetEventForHostessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventForHostessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventForHostessQuery({
 *   variables: {
 *      eventHash: // value for 'eventHash'
 *   },
 * });
 */
export function useGetEventForHostessQuery(baseOptions: Apollo.QueryHookOptions<GetEventForHostessQuery, GetEventForHostessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventForHostessQuery, GetEventForHostessQueryVariables>(GetEventForHostessDocument, options);
      }
export function useGetEventForHostessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventForHostessQuery, GetEventForHostessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventForHostessQuery, GetEventForHostessQueryVariables>(GetEventForHostessDocument, options);
        }
export function useGetEventForHostessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventForHostessQuery, GetEventForHostessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventForHostessQuery, GetEventForHostessQueryVariables>(GetEventForHostessDocument, options);
        }
export type GetEventForHostessQueryHookResult = ReturnType<typeof useGetEventForHostessQuery>;
export type GetEventForHostessLazyQueryHookResult = ReturnType<typeof useGetEventForHostessLazyQuery>;
export type GetEventForHostessSuspenseQueryHookResult = ReturnType<typeof useGetEventForHostessSuspenseQuery>;
export type GetEventForHostessQueryResult = Apollo.QueryResult<GetEventForHostessQuery, GetEventForHostessQueryVariables>;
export const GetUserFromUniqueHashDocument = gql`
    query getUserFromUniqueHash($hash: String!, $hashType: String!) {
  userFromUniqueHash(hash: $hash, hashType: $hashType) {
    email
  }
}
    `;

/**
 * __useGetUserFromUniqueHashQuery__
 *
 * To run a query within a React component, call `useGetUserFromUniqueHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFromUniqueHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFromUniqueHashQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *      hashType: // value for 'hashType'
 *   },
 * });
 */
export function useGetUserFromUniqueHashQuery(baseOptions: Apollo.QueryHookOptions<GetUserFromUniqueHashQuery, GetUserFromUniqueHashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFromUniqueHashQuery, GetUserFromUniqueHashQueryVariables>(GetUserFromUniqueHashDocument, options);
      }
export function useGetUserFromUniqueHashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFromUniqueHashQuery, GetUserFromUniqueHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFromUniqueHashQuery, GetUserFromUniqueHashQueryVariables>(GetUserFromUniqueHashDocument, options);
        }
export function useGetUserFromUniqueHashSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserFromUniqueHashQuery, GetUserFromUniqueHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserFromUniqueHashQuery, GetUserFromUniqueHashQueryVariables>(GetUserFromUniqueHashDocument, options);
        }
export type GetUserFromUniqueHashQueryHookResult = ReturnType<typeof useGetUserFromUniqueHashQuery>;
export type GetUserFromUniqueHashLazyQueryHookResult = ReturnType<typeof useGetUserFromUniqueHashLazyQuery>;
export type GetUserFromUniqueHashSuspenseQueryHookResult = ReturnType<typeof useGetUserFromUniqueHashSuspenseQuery>;
export type GetUserFromUniqueHashQueryResult = Apollo.QueryResult<GetUserFromUniqueHashQuery, GetUserFromUniqueHashQueryVariables>;
export const GetConsultantFavouritesDocument = gql`
    query getConsultantFavourites($id: Int, $filters: ProductFilterInput, $sort: ProductSortInput, $from: Int, $size: Int) {
  organisationFavourites(
    id: $id
    filters: $filters
    sort: $sort
    from: $from
    size: $size
  ) {
    items {
      ...CommonProductFields
    }
    productFilters {
      ...CountedProductFilters
    }
    from
    size
    total
  }
}
    ${CommonProductFieldsFragmentDoc}
${CountedProductFiltersFragmentDoc}`;

/**
 * __useGetConsultantFavouritesQuery__
 *
 * To run a query within a React component, call `useGetConsultantFavouritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantFavouritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantFavouritesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetConsultantFavouritesQuery(baseOptions?: Apollo.QueryHookOptions<GetConsultantFavouritesQuery, GetConsultantFavouritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultantFavouritesQuery, GetConsultantFavouritesQueryVariables>(GetConsultantFavouritesDocument, options);
      }
export function useGetConsultantFavouritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultantFavouritesQuery, GetConsultantFavouritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultantFavouritesQuery, GetConsultantFavouritesQueryVariables>(GetConsultantFavouritesDocument, options);
        }
export function useGetConsultantFavouritesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConsultantFavouritesQuery, GetConsultantFavouritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultantFavouritesQuery, GetConsultantFavouritesQueryVariables>(GetConsultantFavouritesDocument, options);
        }
export type GetConsultantFavouritesQueryHookResult = ReturnType<typeof useGetConsultantFavouritesQuery>;
export type GetConsultantFavouritesLazyQueryHookResult = ReturnType<typeof useGetConsultantFavouritesLazyQuery>;
export type GetConsultantFavouritesSuspenseQueryHookResult = ReturnType<typeof useGetConsultantFavouritesSuspenseQuery>;
export type GetConsultantFavouritesQueryResult = Apollo.QueryResult<GetConsultantFavouritesQuery, GetConsultantFavouritesQueryVariables>;
export const GetConsultantRecommendationsDocument = gql`
    query getConsultantRecommendations($id: Int!) {
  organisationRecommendations(id: $id) {
    favourites {
      ...CommonProductFields
    }
    specialOffers {
      ...CommonProductFields
    }
    dailyOffers {
      ...CommonProductFields
    }
  }
}
    ${CommonProductFieldsFragmentDoc}`;

/**
 * __useGetConsultantRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetConsultantRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantRecommendationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsultantRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<GetConsultantRecommendationsQuery, GetConsultantRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultantRecommendationsQuery, GetConsultantRecommendationsQueryVariables>(GetConsultantRecommendationsDocument, options);
      }
export function useGetConsultantRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultantRecommendationsQuery, GetConsultantRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultantRecommendationsQuery, GetConsultantRecommendationsQueryVariables>(GetConsultantRecommendationsDocument, options);
        }
export function useGetConsultantRecommendationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConsultantRecommendationsQuery, GetConsultantRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultantRecommendationsQuery, GetConsultantRecommendationsQueryVariables>(GetConsultantRecommendationsDocument, options);
        }
export type GetConsultantRecommendationsQueryHookResult = ReturnType<typeof useGetConsultantRecommendationsQuery>;
export type GetConsultantRecommendationsLazyQueryHookResult = ReturnType<typeof useGetConsultantRecommendationsLazyQuery>;
export type GetConsultantRecommendationsSuspenseQueryHookResult = ReturnType<typeof useGetConsultantRecommendationsSuspenseQuery>;
export type GetConsultantRecommendationsQueryResult = Apollo.QueryResult<GetConsultantRecommendationsQuery, GetConsultantRecommendationsQueryVariables>;
export const GetConsultantProfileDocument = gql`
    query getConsultantProfile($id: Int, $slug: String) {
  organisationPublicContent(id: $id, slug: $slug) {
    id
    profile_photo_path
    email
    mobile
    facebook_url
    favourite_quote_id
    presentation
    market
    first_name
    middle_name
    last_name
    title_name_short
    title_name_long
    personal_webshop_url
  }
}
    `;

/**
 * __useGetConsultantProfileQuery__
 *
 * To run a query within a React component, call `useGetConsultantProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetConsultantProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetConsultantProfileQuery, GetConsultantProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultantProfileQuery, GetConsultantProfileQueryVariables>(GetConsultantProfileDocument, options);
      }
export function useGetConsultantProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultantProfileQuery, GetConsultantProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultantProfileQuery, GetConsultantProfileQueryVariables>(GetConsultantProfileDocument, options);
        }
export function useGetConsultantProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConsultantProfileQuery, GetConsultantProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultantProfileQuery, GetConsultantProfileQueryVariables>(GetConsultantProfileDocument, options);
        }
export type GetConsultantProfileQueryHookResult = ReturnType<typeof useGetConsultantProfileQuery>;
export type GetConsultantProfileLazyQueryHookResult = ReturnType<typeof useGetConsultantProfileLazyQuery>;
export type GetConsultantProfileSuspenseQueryHookResult = ReturnType<typeof useGetConsultantProfileSuspenseQuery>;
export type GetConsultantProfileQueryResult = Apollo.QueryResult<GetConsultantProfileQuery, GetConsultantProfileQueryVariables>;
export const GetConsultantTextSearchDocument = gql`
    query getConsultantTextSearch($query: String!, $market: String!, $page: Int, $limit: Int, $organisationIds: [Int]) {
  organisationPublicSearch(
    search: $query
    market: $market
    page: $page
    limit: $limit
    organisationIds: $organisationIds
  ) {
    items {
      id
      profile_photo_path
      first_name
      middle_name
      last_name
      shipping_address
      shipping_postal_code
      shipping_city
      profile_url
    }
    count
    total
    currentPage
    pageCount
  }
}
    `;

/**
 * __useGetConsultantTextSearchQuery__
 *
 * To run a query within a React component, call `useGetConsultantTextSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantTextSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantTextSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      market: // value for 'market'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      organisationIds: // value for 'organisationIds'
 *   },
 * });
 */
export function useGetConsultantTextSearchQuery(baseOptions: Apollo.QueryHookOptions<GetConsultantTextSearchQuery, GetConsultantTextSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultantTextSearchQuery, GetConsultantTextSearchQueryVariables>(GetConsultantTextSearchDocument, options);
      }
export function useGetConsultantTextSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultantTextSearchQuery, GetConsultantTextSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultantTextSearchQuery, GetConsultantTextSearchQueryVariables>(GetConsultantTextSearchDocument, options);
        }
export function useGetConsultantTextSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConsultantTextSearchQuery, GetConsultantTextSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultantTextSearchQuery, GetConsultantTextSearchQueryVariables>(GetConsultantTextSearchDocument, options);
        }
export type GetConsultantTextSearchQueryHookResult = ReturnType<typeof useGetConsultantTextSearchQuery>;
export type GetConsultantTextSearchLazyQueryHookResult = ReturnType<typeof useGetConsultantTextSearchLazyQuery>;
export type GetConsultantTextSearchSuspenseQueryHookResult = ReturnType<typeof useGetConsultantTextSearchSuspenseQuery>;
export type GetConsultantTextSearchQueryResult = Apollo.QueryResult<GetConsultantTextSearchQuery, GetConsultantTextSearchQueryVariables>;
export const GetCustomerOrganisationDocument = gql`
    query getCustomerOrganisation {
  customerOrganisation {
    country_code
  }
}
    `;

/**
 * __useGetCustomerOrganisationQuery__
 *
 * To run a query within a React component, call `useGetCustomerOrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerOrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerOrganisationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerOrganisationQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerOrganisationQuery, GetCustomerOrganisationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerOrganisationQuery, GetCustomerOrganisationQueryVariables>(GetCustomerOrganisationDocument, options);
      }
export function useGetCustomerOrganisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerOrganisationQuery, GetCustomerOrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerOrganisationQuery, GetCustomerOrganisationQueryVariables>(GetCustomerOrganisationDocument, options);
        }
export function useGetCustomerOrganisationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerOrganisationQuery, GetCustomerOrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerOrganisationQuery, GetCustomerOrganisationQueryVariables>(GetCustomerOrganisationDocument, options);
        }
export type GetCustomerOrganisationQueryHookResult = ReturnType<typeof useGetCustomerOrganisationQuery>;
export type GetCustomerOrganisationLazyQueryHookResult = ReturnType<typeof useGetCustomerOrganisationLazyQuery>;
export type GetCustomerOrganisationSuspenseQueryHookResult = ReturnType<typeof useGetCustomerOrganisationSuspenseQuery>;
export type GetCustomerOrganisationQueryResult = Apollo.QueryResult<GetCustomerOrganisationQuery, GetCustomerOrganisationQueryVariables>;
export const GetUserDocument = gql`
    query getUser {
  user {
    id
    name
    fullName
    email
    date_of_birth
    locale
    login_provider
    newsletter
    user_type
    profile_photo_path
    consultant_personal_webshop_slug
    created_at
    updated_at
    billing_address {
      id
      type
      phone_number
      address
      postal_code
      city
      country_code
      email
      first_name
      last_name
    }
    shipping_address {
      id
      type
      phone_number
      address
      postal_code
      city
      country_code
      email
      first_name
      last_name
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetCustomerConsultantFavouritesDocument = gql`
    query getCustomerConsultantFavourites($filters: ProductFilterInput, $sort: ProductSortInput, $from: Int, $size: Int) {
  customerConsultantFavourites(
    filters: $filters
    sort: $sort
    from: $from
    size: $size
  ) {
    items {
      ...CommonProductFields
    }
    productFilters {
      ...CountedProductFilters
    }
    from
    size
    total
  }
}
    ${CommonProductFieldsFragmentDoc}
${CountedProductFiltersFragmentDoc}`;

/**
 * __useGetCustomerConsultantFavouritesQuery__
 *
 * To run a query within a React component, call `useGetCustomerConsultantFavouritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerConsultantFavouritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerConsultantFavouritesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetCustomerConsultantFavouritesQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerConsultantFavouritesQuery, GetCustomerConsultantFavouritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerConsultantFavouritesQuery, GetCustomerConsultantFavouritesQueryVariables>(GetCustomerConsultantFavouritesDocument, options);
      }
export function useGetCustomerConsultantFavouritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerConsultantFavouritesQuery, GetCustomerConsultantFavouritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerConsultantFavouritesQuery, GetCustomerConsultantFavouritesQueryVariables>(GetCustomerConsultantFavouritesDocument, options);
        }
export function useGetCustomerConsultantFavouritesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerConsultantFavouritesQuery, GetCustomerConsultantFavouritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerConsultantFavouritesQuery, GetCustomerConsultantFavouritesQueryVariables>(GetCustomerConsultantFavouritesDocument, options);
        }
export type GetCustomerConsultantFavouritesQueryHookResult = ReturnType<typeof useGetCustomerConsultantFavouritesQuery>;
export type GetCustomerConsultantFavouritesLazyQueryHookResult = ReturnType<typeof useGetCustomerConsultantFavouritesLazyQuery>;
export type GetCustomerConsultantFavouritesSuspenseQueryHookResult = ReturnType<typeof useGetCustomerConsultantFavouritesSuspenseQuery>;
export type GetCustomerConsultantFavouritesQueryResult = Apollo.QueryResult<GetCustomerConsultantFavouritesQuery, GetCustomerConsultantFavouritesQueryVariables>;
export const GetFavouritesIdsDocument = gql`
    query getFavouritesIds($filters: ProductFilterInput, $sort: ProductSortInput, $from: Int, $size: Int) {
  favourites(filters: $filters, sort: $sort, from: $from, size: $size) {
    items {
      id
    }
  }
}
    `;

/**
 * __useGetFavouritesIdsQuery__
 *
 * To run a query within a React component, call `useGetFavouritesIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavouritesIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavouritesIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetFavouritesIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetFavouritesIdsQuery, GetFavouritesIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavouritesIdsQuery, GetFavouritesIdsQueryVariables>(GetFavouritesIdsDocument, options);
      }
export function useGetFavouritesIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavouritesIdsQuery, GetFavouritesIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavouritesIdsQuery, GetFavouritesIdsQueryVariables>(GetFavouritesIdsDocument, options);
        }
export function useGetFavouritesIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFavouritesIdsQuery, GetFavouritesIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFavouritesIdsQuery, GetFavouritesIdsQueryVariables>(GetFavouritesIdsDocument, options);
        }
export type GetFavouritesIdsQueryHookResult = ReturnType<typeof useGetFavouritesIdsQuery>;
export type GetFavouritesIdsLazyQueryHookResult = ReturnType<typeof useGetFavouritesIdsLazyQuery>;
export type GetFavouritesIdsSuspenseQueryHookResult = ReturnType<typeof useGetFavouritesIdsSuspenseQuery>;
export type GetFavouritesIdsQueryResult = Apollo.QueryResult<GetFavouritesIdsQuery, GetFavouritesIdsQueryVariables>;
export const GetFavouritesDocument = gql`
    query getFavourites($filters: ProductFilterInput, $sort: ProductSortInput, $from: Int, $size: Int) {
  favourites(filters: $filters, sort: $sort, from: $from, size: $size) {
    items {
      ...CommonProductFields
    }
    productFilters {
      ...CountedProductFilters
    }
    from
    size
    total
  }
}
    ${CommonProductFieldsFragmentDoc}
${CountedProductFiltersFragmentDoc}`;

/**
 * __useGetFavouritesQuery__
 *
 * To run a query within a React component, call `useGetFavouritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavouritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavouritesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetFavouritesQuery(baseOptions?: Apollo.QueryHookOptions<GetFavouritesQuery, GetFavouritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavouritesQuery, GetFavouritesQueryVariables>(GetFavouritesDocument, options);
      }
export function useGetFavouritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavouritesQuery, GetFavouritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavouritesQuery, GetFavouritesQueryVariables>(GetFavouritesDocument, options);
        }
export function useGetFavouritesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFavouritesQuery, GetFavouritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFavouritesQuery, GetFavouritesQueryVariables>(GetFavouritesDocument, options);
        }
export type GetFavouritesQueryHookResult = ReturnType<typeof useGetFavouritesQuery>;
export type GetFavouritesLazyQueryHookResult = ReturnType<typeof useGetFavouritesLazyQuery>;
export type GetFavouritesSuspenseQueryHookResult = ReturnType<typeof useGetFavouritesSuspenseQuery>;
export type GetFavouritesQueryResult = Apollo.QueryResult<GetFavouritesQuery, GetFavouritesQueryVariables>;
export const GetRandomProductsDocument = gql`
    query getRandomProducts($market: String!, $organisationPersonalWebshopSlug: String) {
  randomProducts(
    market: $market
    organisationPersonalWebshopSlug: $organisationPersonalWebshopSlug
  ) {
    items {
      ...CommonProductFields
    }
    productFilters {
      ...CountedProductFilters
    }
    from
    size
    total
  }
}
    ${CommonProductFieldsFragmentDoc}
${CountedProductFiltersFragmentDoc}`;

/**
 * __useGetRandomProductsQuery__
 *
 * To run a query within a React component, call `useGetRandomProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRandomProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRandomProductsQuery({
 *   variables: {
 *      market: // value for 'market'
 *      organisationPersonalWebshopSlug: // value for 'organisationPersonalWebshopSlug'
 *   },
 * });
 */
export function useGetRandomProductsQuery(baseOptions: Apollo.QueryHookOptions<GetRandomProductsQuery, GetRandomProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRandomProductsQuery, GetRandomProductsQueryVariables>(GetRandomProductsDocument, options);
      }
export function useGetRandomProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRandomProductsQuery, GetRandomProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRandomProductsQuery, GetRandomProductsQueryVariables>(GetRandomProductsDocument, options);
        }
export function useGetRandomProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRandomProductsQuery, GetRandomProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRandomProductsQuery, GetRandomProductsQueryVariables>(GetRandomProductsDocument, options);
        }
export type GetRandomProductsQueryHookResult = ReturnType<typeof useGetRandomProductsQuery>;
export type GetRandomProductsLazyQueryHookResult = ReturnType<typeof useGetRandomProductsLazyQuery>;
export type GetRandomProductsSuspenseQueryHookResult = ReturnType<typeof useGetRandomProductsSuspenseQuery>;
export type GetRandomProductsQueryResult = Apollo.QueryResult<GetRandomProductsQuery, GetRandomProductsQueryVariables>;
export const GetRecommendedProductsDocument = gql`
    query getRecommendedProducts($market: String!, $organisationPersonalWebshopSlug: String) {
  recommended(
    market: $market
    organisationPersonalWebshopSlug: $organisationPersonalWebshopSlug
  ) {
    items {
      ...CommonProductFields
    }
    productFilters {
      ...CountedProductFilters
    }
    from
    size
    total
  }
}
    ${CommonProductFieldsFragmentDoc}
${CountedProductFiltersFragmentDoc}`;

/**
 * __useGetRecommendedProductsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedProductsQuery({
 *   variables: {
 *      market: // value for 'market'
 *      organisationPersonalWebshopSlug: // value for 'organisationPersonalWebshopSlug'
 *   },
 * });
 */
export function useGetRecommendedProductsQuery(baseOptions: Apollo.QueryHookOptions<GetRecommendedProductsQuery, GetRecommendedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendedProductsQuery, GetRecommendedProductsQueryVariables>(GetRecommendedProductsDocument, options);
      }
export function useGetRecommendedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendedProductsQuery, GetRecommendedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendedProductsQuery, GetRecommendedProductsQueryVariables>(GetRecommendedProductsDocument, options);
        }
export function useGetRecommendedProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecommendedProductsQuery, GetRecommendedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendedProductsQuery, GetRecommendedProductsQueryVariables>(GetRecommendedProductsDocument, options);
        }
export type GetRecommendedProductsQueryHookResult = ReturnType<typeof useGetRecommendedProductsQuery>;
export type GetRecommendedProductsLazyQueryHookResult = ReturnType<typeof useGetRecommendedProductsLazyQuery>;
export type GetRecommendedProductsSuspenseQueryHookResult = ReturnType<typeof useGetRecommendedProductsSuspenseQuery>;
export type GetRecommendedProductsQueryResult = Apollo.QueryResult<GetRecommendedProductsQuery, GetRecommendedProductsQueryVariables>;
export const GetRecommendedRelatedProductsDocument = gql`
    query getRecommendedRelatedProducts($slug: String, $sku: String, $market: String!, $organisationPersonalWebshopSlug: String) {
  recommendedRelated(
    slug: $slug
    sku: $sku
    market: $market
    organisationPersonalWebshopSlug: $organisationPersonalWebshopSlug
  ) {
    items {
      ...CommonProductFields
    }
    productFilters {
      ...CountedProductFilters
    }
    from
    size
    total
  }
}
    ${CommonProductFieldsFragmentDoc}
${CountedProductFiltersFragmentDoc}`;

/**
 * __useGetRecommendedRelatedProductsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedRelatedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedRelatedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedRelatedProductsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      sku: // value for 'sku'
 *      market: // value for 'market'
 *      organisationPersonalWebshopSlug: // value for 'organisationPersonalWebshopSlug'
 *   },
 * });
 */
export function useGetRecommendedRelatedProductsQuery(baseOptions: Apollo.QueryHookOptions<GetRecommendedRelatedProductsQuery, GetRecommendedRelatedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendedRelatedProductsQuery, GetRecommendedRelatedProductsQueryVariables>(GetRecommendedRelatedProductsDocument, options);
      }
export function useGetRecommendedRelatedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendedRelatedProductsQuery, GetRecommendedRelatedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendedRelatedProductsQuery, GetRecommendedRelatedProductsQueryVariables>(GetRecommendedRelatedProductsDocument, options);
        }
export function useGetRecommendedRelatedProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecommendedRelatedProductsQuery, GetRecommendedRelatedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendedRelatedProductsQuery, GetRecommendedRelatedProductsQueryVariables>(GetRecommendedRelatedProductsDocument, options);
        }
export type GetRecommendedRelatedProductsQueryHookResult = ReturnType<typeof useGetRecommendedRelatedProductsQuery>;
export type GetRecommendedRelatedProductsLazyQueryHookResult = ReturnType<typeof useGetRecommendedRelatedProductsLazyQuery>;
export type GetRecommendedRelatedProductsSuspenseQueryHookResult = ReturnType<typeof useGetRecommendedRelatedProductsSuspenseQuery>;
export type GetRecommendedRelatedProductsQueryResult = Apollo.QueryResult<GetRecommendedRelatedProductsQuery, GetRecommendedRelatedProductsQueryVariables>;
export const GetCategoryDocument = gql`
    query getCategory($market: String!, $slug: String!, $showAllProducts: Boolean) {
  category(market: $market, slug: $slug, showAllProducts: $showAllProducts) {
    pim_id
    parent_pim_id
    slug_path
    title
    meta_keywords
    meta_description
    description
    tag
    children {
      pim_id
      parent_pim_id
      slug_path
      title
      description
      meta_keywords
      meta_description
    }
    breadcrumbs {
      title
      href
    }
  }
}
    `;

/**
 * __useGetCategoryQuery__
 *
 * To run a query within a React component, call `useGetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryQuery({
 *   variables: {
 *      market: // value for 'market'
 *      slug: // value for 'slug'
 *      showAllProducts: // value for 'showAllProducts'
 *   },
 * });
 */
export function useGetCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
      }
export function useGetCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
export function useGetCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
export type GetCategoryQueryHookResult = ReturnType<typeof useGetCategoryQuery>;
export type GetCategoryLazyQueryHookResult = ReturnType<typeof useGetCategoryLazyQuery>;
export type GetCategorySuspenseQueryHookResult = ReturnType<typeof useGetCategorySuspenseQuery>;
export type GetCategoryQueryResult = Apollo.QueryResult<GetCategoryQuery, GetCategoryQueryVariables>;
export const GetCategoriesDocument = gql`
    query getCategories($market: String!) {
  categories(market: $market) {
    items {
      id
      pim_id
      parent_pim_id
      name
      title
      language
      level
      path
      slug_path
      tag
      breadcrumbs {
        title
        href
      }
      children {
        id
        pim_id
        parent_pim_id
        name
        title
        language
        level
        path
        slug_path
        breadcrumbs {
          title
          href
        }
        children {
          id
          pim_id
          parent_pim_id
          name
          title
          language
          level
          path
          slug_path
          breadcrumbs {
            title
            href
          }
        }
      }
    }
    count
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      market: // value for 'market'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCategorySlugsDocument = gql`
    query getCategorySlugs($market: String!) {
  categorySlugs(market: $market) {
    items
  }
}
    `;

/**
 * __useGetCategorySlugsQuery__
 *
 * To run a query within a React component, call `useGetCategorySlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategorySlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategorySlugsQuery({
 *   variables: {
 *      market: // value for 'market'
 *   },
 * });
 */
export function useGetCategorySlugsQuery(baseOptions: Apollo.QueryHookOptions<GetCategorySlugsQuery, GetCategorySlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategorySlugsQuery, GetCategorySlugsQueryVariables>(GetCategorySlugsDocument, options);
      }
export function useGetCategorySlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategorySlugsQuery, GetCategorySlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategorySlugsQuery, GetCategorySlugsQueryVariables>(GetCategorySlugsDocument, options);
        }
export function useGetCategorySlugsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategorySlugsQuery, GetCategorySlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategorySlugsQuery, GetCategorySlugsQueryVariables>(GetCategorySlugsDocument, options);
        }
export type GetCategorySlugsQueryHookResult = ReturnType<typeof useGetCategorySlugsQuery>;
export type GetCategorySlugsLazyQueryHookResult = ReturnType<typeof useGetCategorySlugsLazyQuery>;
export type GetCategorySlugsSuspenseQueryHookResult = ReturnType<typeof useGetCategorySlugsSuspenseQuery>;
export type GetCategorySlugsQueryResult = Apollo.QueryResult<GetCategorySlugsQuery, GetCategorySlugsQueryVariables>;
export const GetCustomerOrganisationOrdersDocument = gql`
    query getCustomerOrganisationOrders($customerUserId: Int!, $page: Int, $size: Int, $search: String, $orderBy: OrganisationOrderOrderByEnum!, $orderDirection: OrderDirectionEnum!, $status: OrganisationOrderStatusEnum) {
  customerOrganisationOrders(
    customerUserId: $customerUserId
    page: $page
    size: $size
    search: $search
    orderBy: $orderBy
    orderDirection: $orderDirection
    status: $status
  ) {
    items {
      id
      orderNumber
      createdAt
      customerEmail
      status
      taxTotal
      grandTotal
      grandTotalExclTax
      totalDiscountExclTax
      totalDiscountInclTax
      isInvoicingEnabled
      discountAmount
      discountPercentage
      followUp
      invoice {
        id
        invoice_number
      }
      billingAddress {
        id
        type
        email
        mobile
        phone_number
        first_name
        middle_name
        last_name
        address
        co
        city
        postal_code
        country_code
      }
      items {
        id
        price
        basePrice
        quantity
        priceExclTax
        taxPercentage
        productId
        productName
        productSku
        productThumbnailUrl
        discountAmount
        discountPercentage
      }
      comments {
        id
        created_at
        comment
      }
    }
    total
    page
    size
  }
}
    `;

/**
 * __useGetCustomerOrganisationOrdersQuery__
 *
 * To run a query within a React component, call `useGetCustomerOrganisationOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerOrganisationOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerOrganisationOrdersQuery({
 *   variables: {
 *      customerUserId: // value for 'customerUserId'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetCustomerOrganisationOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerOrganisationOrdersQuery, GetCustomerOrganisationOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerOrganisationOrdersQuery, GetCustomerOrganisationOrdersQueryVariables>(GetCustomerOrganisationOrdersDocument, options);
      }
export function useGetCustomerOrganisationOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerOrganisationOrdersQuery, GetCustomerOrganisationOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerOrganisationOrdersQuery, GetCustomerOrganisationOrdersQueryVariables>(GetCustomerOrganisationOrdersDocument, options);
        }
export function useGetCustomerOrganisationOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerOrganisationOrdersQuery, GetCustomerOrganisationOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerOrganisationOrdersQuery, GetCustomerOrganisationOrdersQueryVariables>(GetCustomerOrganisationOrdersDocument, options);
        }
export type GetCustomerOrganisationOrdersQueryHookResult = ReturnType<typeof useGetCustomerOrganisationOrdersQuery>;
export type GetCustomerOrganisationOrdersLazyQueryHookResult = ReturnType<typeof useGetCustomerOrganisationOrdersLazyQuery>;
export type GetCustomerOrganisationOrdersSuspenseQueryHookResult = ReturnType<typeof useGetCustomerOrganisationOrdersSuspenseQuery>;
export type GetCustomerOrganisationOrdersQueryResult = Apollo.QueryResult<GetCustomerOrganisationOrdersQuery, GetCustomerOrganisationOrdersQueryVariables>;
export const GetProductsDocument = gql`
    query getProducts($market: String!, $from: Int!, $size: Int, $category_slug_path: String, $tags: [String!], $searchField: String, $filters: ProductFilterInput, $myCustomersFilter: MyCustomersProductListFilterEnum, $myCustomersSorting: MyCustomersProductSortInput, $sort: ProductSortInput, $includeUnpublished: Boolean, $unwrapWrappedProducts: Boolean, $organisationPersonalWebshopSlug: String, $includeEndOfLifeOverridable: Boolean, $includeVariants: Boolean, $onlyBundledProducts: Boolean, $onlySimpleProducts: Boolean, $onlyReactivatableProducts: Boolean) {
  products(
    market: $market
    from: $from
    size: $size
    tags: $tags
    category_slug_path: $category_slug_path
    searchField: $searchField
    filters: $filters
    myCustomersFilter: $myCustomersFilter
    myCustomersSorting: $myCustomersSorting
    sort: $sort
    includeUnpublished: $includeUnpublished
    unwrapWrappedProducts: $unwrapWrappedProducts
    includeVariants: $includeVariants
    organisationPersonalWebshopSlug: $organisationPersonalWebshopSlug
    includeEndOfLifeOverridable: $includeEndOfLifeOverridable
    onlyBundledProducts: $onlyBundledProducts
    onlySimpleProducts: $onlySimpleProducts
    onlyReactivatableProducts: $onlyReactivatableProducts
  ) {
    items {
      ...CommonProductFields
    }
    productFilters {
      ...CountedProductFilters
    }
    from
    size
    total
  }
}
    ${CommonProductFieldsFragmentDoc}
${CountedProductFiltersFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      market: // value for 'market'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *      category_slug_path: // value for 'category_slug_path'
 *      tags: // value for 'tags'
 *      searchField: // value for 'searchField'
 *      filters: // value for 'filters'
 *      myCustomersFilter: // value for 'myCustomersFilter'
 *      myCustomersSorting: // value for 'myCustomersSorting'
 *      sort: // value for 'sort'
 *      includeUnpublished: // value for 'includeUnpublished'
 *      unwrapWrappedProducts: // value for 'unwrapWrappedProducts'
 *      organisationPersonalWebshopSlug: // value for 'organisationPersonalWebshopSlug'
 *      includeEndOfLifeOverridable: // value for 'includeEndOfLifeOverridable'
 *      includeVariants: // value for 'includeVariants'
 *      onlyBundledProducts: // value for 'onlyBundledProducts'
 *      onlySimpleProducts: // value for 'onlySimpleProducts'
 *      onlyReactivatableProducts: // value for 'onlyReactivatableProducts'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export function useGetProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductsSuspenseQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetProductDocument = gql`
    query getProduct($market: String!, $slug: String, $sku: String, $organisationPersonalWebshopSlug: String) {
  product(
    market: $market
    slug: $slug
    sku: $sku
    organisationPersonalWebshopSlug: $organisationPersonalWebshopSlug
  ) {
    ...CommonProductFields
    ...ProductFilters
    breadcrumbs {
      title
      href
    }
    howItWorks
    applicationTips
  }
}
    ${CommonProductFieldsFragmentDoc}
${ProductFiltersFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      market: // value for 'market'
 *      slug: // value for 'slug'
 *      sku: // value for 'sku'
 *      organisationPersonalWebshopSlug: // value for 'organisationPersonalWebshopSlug'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetFullMenuDocument = gql`
    query getFullMenu($market: String!) {
  menu(market: $market) {
    items {
      ...CommonMenuItem
      items {
        ...CommonMenuItem
        items {
          ...CommonMenuItem
          items {
            ...CommonMenuItem
          }
        }
      }
    }
  }
}
    ${CommonMenuItemFragmentDoc}`;

/**
 * __useGetFullMenuQuery__
 *
 * To run a query within a React component, call `useGetFullMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullMenuQuery({
 *   variables: {
 *      market: // value for 'market'
 *   },
 * });
 */
export function useGetFullMenuQuery(baseOptions: Apollo.QueryHookOptions<GetFullMenuQuery, GetFullMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullMenuQuery, GetFullMenuQueryVariables>(GetFullMenuDocument, options);
      }
export function useGetFullMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullMenuQuery, GetFullMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullMenuQuery, GetFullMenuQueryVariables>(GetFullMenuDocument, options);
        }
export function useGetFullMenuSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFullMenuQuery, GetFullMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFullMenuQuery, GetFullMenuQueryVariables>(GetFullMenuDocument, options);
        }
export type GetFullMenuQueryHookResult = ReturnType<typeof useGetFullMenuQuery>;
export type GetFullMenuLazyQueryHookResult = ReturnType<typeof useGetFullMenuLazyQuery>;
export type GetFullMenuSuspenseQueryHookResult = ReturnType<typeof useGetFullMenuSuspenseQuery>;
export type GetFullMenuQueryResult = Apollo.QueryResult<GetFullMenuQuery, GetFullMenuQueryVariables>;
export const GetPageDocument = gql`
    query getPage($market: String!, $slug: String) {
  page(market: $market, slug: $slug) {
    id
    slug
    title
    content
    elementorStyles
    elementorCss
    elementorScripts
    elementorConfig
    breadcrumbs {
      title
      href
    }
  }
}
    `;

/**
 * __useGetPageQuery__
 *
 * To run a query within a React component, call `useGetPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageQuery({
 *   variables: {
 *      market: // value for 'market'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetPageQuery(baseOptions: Apollo.QueryHookOptions<GetPageQuery, GetPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageQuery, GetPageQueryVariables>(GetPageDocument, options);
      }
export function useGetPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageQuery, GetPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageQuery, GetPageQueryVariables>(GetPageDocument, options);
        }
export function useGetPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageQuery, GetPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageQuery, GetPageQueryVariables>(GetPageDocument, options);
        }
export type GetPageQueryHookResult = ReturnType<typeof useGetPageQuery>;
export type GetPageLazyQueryHookResult = ReturnType<typeof useGetPageLazyQuery>;
export type GetPageSuspenseQueryHookResult = ReturnType<typeof useGetPageSuspenseQuery>;
export type GetPageQueryResult = Apollo.QueryResult<GetPageQuery, GetPageQueryVariables>;
export const GetCartDocument = gql`
    query getCart($market: String!) {
  cart(market: $market) {
    cart {
      id
      user_id
      market
      uuid
      shipping_address
      billing_address
      shipping_method
      payment_method
      pickup_location
      checked_out_at
      created_at
      updated_at
      items {
        id
        cart_id
        product_id
        child_id
        quantity
        created_at
        updated_at
        product {
          ...CommonProductFields
        }
      }
    }
    totals {
      rows {
        label
        type
        translate
        value
        sort
      }
    }
  }
}
    ${CommonProductFieldsFragmentDoc}`;

/**
 * __useGetCartQuery__
 *
 * To run a query within a React component, call `useGetCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartQuery({
 *   variables: {
 *      market: // value for 'market'
 *   },
 * });
 */
export function useGetCartQuery(baseOptions: Apollo.QueryHookOptions<GetCartQuery, GetCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartQuery, GetCartQueryVariables>(GetCartDocument, options);
      }
export function useGetCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartQuery, GetCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartQuery, GetCartQueryVariables>(GetCartDocument, options);
        }
export function useGetCartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCartQuery, GetCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartQuery, GetCartQueryVariables>(GetCartDocument, options);
        }
export type GetCartQueryHookResult = ReturnType<typeof useGetCartQuery>;
export type GetCartLazyQueryHookResult = ReturnType<typeof useGetCartLazyQuery>;
export type GetCartSuspenseQueryHookResult = ReturnType<typeof useGetCartSuspenseQuery>;
export type GetCartQueryResult = Apollo.QueryResult<GetCartQuery, GetCartQueryVariables>;
export const GetOrganisationOrdersForCustomerDocument = gql`
    query getOrganisationOrdersForCustomer($page: Int!, $size: Int!) {
  organisationOrdersForCustomer(page: $page, size: $size) {
    page
    size
    total
    items {
      id
      orderNumber
      createdAt
      status
      grandTotal
      subTotal
      taxTotal
      paymentMethod
      paymentIdentification
      deliveryMethod
      shippingInclTax
      items {
        id
        price
        basePrice
        price
        quantity
        priceExclTax
        taxPercentage
        productId
        productName
        productSku
        productThumbnailUrl
        discountAmount
        discountPercentage
        product {
          ...CommonProductFields
        }
      }
    }
  }
}
    ${CommonProductFieldsFragmentDoc}`;

/**
 * __useGetOrganisationOrdersForCustomerQuery__
 *
 * To run a query within a React component, call `useGetOrganisationOrdersForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationOrdersForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationOrdersForCustomerQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetOrganisationOrdersForCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationOrdersForCustomerQuery, GetOrganisationOrdersForCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationOrdersForCustomerQuery, GetOrganisationOrdersForCustomerQueryVariables>(GetOrganisationOrdersForCustomerDocument, options);
      }
export function useGetOrganisationOrdersForCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationOrdersForCustomerQuery, GetOrganisationOrdersForCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationOrdersForCustomerQuery, GetOrganisationOrdersForCustomerQueryVariables>(GetOrganisationOrdersForCustomerDocument, options);
        }
export function useGetOrganisationOrdersForCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationOrdersForCustomerQuery, GetOrganisationOrdersForCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationOrdersForCustomerQuery, GetOrganisationOrdersForCustomerQueryVariables>(GetOrganisationOrdersForCustomerDocument, options);
        }
export type GetOrganisationOrdersForCustomerQueryHookResult = ReturnType<typeof useGetOrganisationOrdersForCustomerQuery>;
export type GetOrganisationOrdersForCustomerLazyQueryHookResult = ReturnType<typeof useGetOrganisationOrdersForCustomerLazyQuery>;
export type GetOrganisationOrdersForCustomerSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationOrdersForCustomerSuspenseQuery>;
export type GetOrganisationOrdersForCustomerQueryResult = Apollo.QueryResult<GetOrganisationOrdersForCustomerQuery, GetOrganisationOrdersForCustomerQueryVariables>;
export const GetCustomerOrdersForShopperDocument = gql`
    query getCustomerOrdersForShopper($page: Int!, $size: Int!) {
  customerOrdersForShopper(page: $page, size: $size) {
    page
    size
    total
    items {
      id
      orderNumber
      createdAt
      status
      grandTotal
      shippingInclTax
      paymentMethod
      deliveryMethod
      items {
        id
        productSku: sku
        productName
        productThumbnailUrl
        price
        quantity
      }
      deliveries {
        id
        trackingNumber
        createdAt
        items {
          sku
          quantity
        }
      }
    }
  }
}
    `;

/**
 * __useGetCustomerOrdersForShopperQuery__
 *
 * To run a query within a React component, call `useGetCustomerOrdersForShopperQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerOrdersForShopperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerOrdersForShopperQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetCustomerOrdersForShopperQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerOrdersForShopperQuery, GetCustomerOrdersForShopperQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerOrdersForShopperQuery, GetCustomerOrdersForShopperQueryVariables>(GetCustomerOrdersForShopperDocument, options);
      }
export function useGetCustomerOrdersForShopperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerOrdersForShopperQuery, GetCustomerOrdersForShopperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerOrdersForShopperQuery, GetCustomerOrdersForShopperQueryVariables>(GetCustomerOrdersForShopperDocument, options);
        }
export function useGetCustomerOrdersForShopperSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerOrdersForShopperQuery, GetCustomerOrdersForShopperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerOrdersForShopperQuery, GetCustomerOrdersForShopperQueryVariables>(GetCustomerOrdersForShopperDocument, options);
        }
export type GetCustomerOrdersForShopperQueryHookResult = ReturnType<typeof useGetCustomerOrdersForShopperQuery>;
export type GetCustomerOrdersForShopperLazyQueryHookResult = ReturnType<typeof useGetCustomerOrdersForShopperLazyQuery>;
export type GetCustomerOrdersForShopperSuspenseQueryHookResult = ReturnType<typeof useGetCustomerOrdersForShopperSuspenseQuery>;
export type GetCustomerOrdersForShopperQueryResult = Apollo.QueryResult<GetCustomerOrdersForShopperQuery, GetCustomerOrdersForShopperQueryVariables>;
export const GetPublicProductsDocument = gql`
    query getPublicProducts($market: String!, $sku: [String!]!) {
  publicProducts(market: $market, sku: $sku) {
    items {
      id
      sku
      name
      url
      thumbnail
    }
    from
    size
    total
  }
}
    `;

/**
 * __useGetPublicProductsQuery__
 *
 * To run a query within a React component, call `useGetPublicProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicProductsQuery({
 *   variables: {
 *      market: // value for 'market'
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useGetPublicProductsQuery(baseOptions: Apollo.QueryHookOptions<GetPublicProductsQuery, GetPublicProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicProductsQuery, GetPublicProductsQueryVariables>(GetPublicProductsDocument, options);
      }
export function useGetPublicProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicProductsQuery, GetPublicProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicProductsQuery, GetPublicProductsQueryVariables>(GetPublicProductsDocument, options);
        }
export function useGetPublicProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPublicProductsQuery, GetPublicProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicProductsQuery, GetPublicProductsQueryVariables>(GetPublicProductsDocument, options);
        }
export type GetPublicProductsQueryHookResult = ReturnType<typeof useGetPublicProductsQuery>;
export type GetPublicProductsLazyQueryHookResult = ReturnType<typeof useGetPublicProductsLazyQuery>;
export type GetPublicProductsSuspenseQueryHookResult = ReturnType<typeof useGetPublicProductsSuspenseQuery>;
export type GetPublicProductsQueryResult = Apollo.QueryResult<GetPublicProductsQuery, GetPublicProductsQueryVariables>;
export const GetPublicConsultantSubmissionsProfileDocument = gql`
    query getPublicConsultantSubmissionsProfile {
  publicConsultantSubmissionsContent {
    items {
      id
      profile_photo_url
      email
      mobile
      presentation
      consultant_locale
      consultant_number
      full_name
      first_name
      last_name
      title_name_short
      title_name_long
      personal_webshop_url
    }
    count
    total
    currentPage
    pageCount
  }
}
    `;

/**
 * __useGetPublicConsultantSubmissionsProfileQuery__
 *
 * To run a query within a React component, call `useGetPublicConsultantSubmissionsProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicConsultantSubmissionsProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicConsultantSubmissionsProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublicConsultantSubmissionsProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetPublicConsultantSubmissionsProfileQuery, GetPublicConsultantSubmissionsProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicConsultantSubmissionsProfileQuery, GetPublicConsultantSubmissionsProfileQueryVariables>(GetPublicConsultantSubmissionsProfileDocument, options);
      }
export function useGetPublicConsultantSubmissionsProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicConsultantSubmissionsProfileQuery, GetPublicConsultantSubmissionsProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicConsultantSubmissionsProfileQuery, GetPublicConsultantSubmissionsProfileQueryVariables>(GetPublicConsultantSubmissionsProfileDocument, options);
        }
export function useGetPublicConsultantSubmissionsProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPublicConsultantSubmissionsProfileQuery, GetPublicConsultantSubmissionsProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicConsultantSubmissionsProfileQuery, GetPublicConsultantSubmissionsProfileQueryVariables>(GetPublicConsultantSubmissionsProfileDocument, options);
        }
export type GetPublicConsultantSubmissionsProfileQueryHookResult = ReturnType<typeof useGetPublicConsultantSubmissionsProfileQuery>;
export type GetPublicConsultantSubmissionsProfileLazyQueryHookResult = ReturnType<typeof useGetPublicConsultantSubmissionsProfileLazyQuery>;
export type GetPublicConsultantSubmissionsProfileSuspenseQueryHookResult = ReturnType<typeof useGetPublicConsultantSubmissionsProfileSuspenseQuery>;
export type GetPublicConsultantSubmissionsProfileQueryResult = Apollo.QueryResult<GetPublicConsultantSubmissionsProfileQuery, GetPublicConsultantSubmissionsProfileQueryVariables>;
export const GetCmsBlockDocument = gql`
    query getCmsBlock($title: String!) {
  cmsBlock(title: $title) {
    content
  }
}
    `;

/**
 * __useGetCmsBlockQuery__
 *
 * To run a query within a React component, call `useGetCmsBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsBlockQuery({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useGetCmsBlockQuery(baseOptions: Apollo.QueryHookOptions<GetCmsBlockQuery, GetCmsBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmsBlockQuery, GetCmsBlockQueryVariables>(GetCmsBlockDocument, options);
      }
export function useGetCmsBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmsBlockQuery, GetCmsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmsBlockQuery, GetCmsBlockQueryVariables>(GetCmsBlockDocument, options);
        }
export function useGetCmsBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCmsBlockQuery, GetCmsBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCmsBlockQuery, GetCmsBlockQueryVariables>(GetCmsBlockDocument, options);
        }
export type GetCmsBlockQueryHookResult = ReturnType<typeof useGetCmsBlockQuery>;
export type GetCmsBlockLazyQueryHookResult = ReturnType<typeof useGetCmsBlockLazyQuery>;
export type GetCmsBlockSuspenseQueryHookResult = ReturnType<typeof useGetCmsBlockSuspenseQuery>;
export type GetCmsBlockQueryResult = Apollo.QueryResult<GetCmsBlockQuery, GetCmsBlockQueryVariables>;
export const GetBackwebCommandsForUiDocument = gql`
    query GetBackwebCommandsForUI($token: String!) {
  backweb(token: $token) {
    commands {
      key
      signature
      description
      dangerous
    }
  }
}
    `;

/**
 * __useGetBackwebCommandsForUiQuery__
 *
 * To run a query within a React component, call `useGetBackwebCommandsForUiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBackwebCommandsForUiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBackwebCommandsForUiQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetBackwebCommandsForUiQuery(baseOptions: Apollo.QueryHookOptions<GetBackwebCommandsForUiQuery, GetBackwebCommandsForUiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBackwebCommandsForUiQuery, GetBackwebCommandsForUiQueryVariables>(GetBackwebCommandsForUiDocument, options);
      }
export function useGetBackwebCommandsForUiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBackwebCommandsForUiQuery, GetBackwebCommandsForUiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBackwebCommandsForUiQuery, GetBackwebCommandsForUiQueryVariables>(GetBackwebCommandsForUiDocument, options);
        }
export function useGetBackwebCommandsForUiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBackwebCommandsForUiQuery, GetBackwebCommandsForUiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBackwebCommandsForUiQuery, GetBackwebCommandsForUiQueryVariables>(GetBackwebCommandsForUiDocument, options);
        }
export type GetBackwebCommandsForUiQueryHookResult = ReturnType<typeof useGetBackwebCommandsForUiQuery>;
export type GetBackwebCommandsForUiLazyQueryHookResult = ReturnType<typeof useGetBackwebCommandsForUiLazyQuery>;
export type GetBackwebCommandsForUiSuspenseQueryHookResult = ReturnType<typeof useGetBackwebCommandsForUiSuspenseQuery>;
export type GetBackwebCommandsForUiQueryResult = Apollo.QueryResult<GetBackwebCommandsForUiQuery, GetBackwebCommandsForUiQueryVariables>;